/* tslint:disable */
/* eslint-disable */
/**
 * Simply Carbs API development
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AssignProvidersToImportDto
 */
export interface AssignProvidersToImportDto {
    /**
     * Whether to send notifications to the assigned providers
     * @type {boolean}
     * @memberof AssignProvidersToImportDto
     */
    'needNotify'?: boolean;
}
/**
 * 
 * @export
 * @interface AvailableShifts
 */
export interface AvailableShifts {
    /**
     * Shift ID
     * @type {string}
     * @memberof AvailableShifts
     */
    'id': string;
    /**
     * Shift start time
     * @type {string}
     * @memberof AvailableShifts
     */
    'time': string;
    /**
     * Shift location
     * @type {string}
     * @memberof AvailableShifts
     */
    'status': string;
    /**
     * Employee Name
     * @type {string}
     * @memberof AvailableShifts
     */
    'displayName': string;
    /**
     * Employee Id
     * @type {string}
     * @memberof AvailableShifts
     */
    'employeeId': string;
    /**
     * Employee Id Number
     * @type {string}
     * @memberof AvailableShifts
     */
    'employeeIdNumber': string | null;
}
/**
 * 
 * @export
 * @interface BindLineDto
 */
export interface BindLineDto {
    /**
     * line code to get access token
     * @type {string}
     * @memberof BindLineDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface BulkCreateEmployeeSalaryAdjustmentDto
 */
export interface BulkCreateEmployeeSalaryAdjustmentDto {
    /**
     * 批量薪資調整資料陣列（使用員工姓名）
     * @type {Array<CreateEmployeeSalaryAdjustmentByNameDto>}
     * @memberof BulkCreateEmployeeSalaryAdjustmentDto
     */
    'data': Array<CreateEmployeeSalaryAdjustmentByNameDto>;
}
/**
 * 
 * @export
 * @interface BulkCreateEmployeesDto
 */
export interface BulkCreateEmployeesDto {
    /**
     * 員工資料陣列（包含匯款資訊）
     * @type {Array<CreateEmployeeWithRemittanceDto>}
     * @memberof BulkCreateEmployeesDto
     */
    'employees': Array<CreateEmployeeWithRemittanceDto>;
}
/**
 * 
 * @export
 * @interface BulkCreateEmployeesResponseDto
 */
export interface BulkCreateEmployeesResponseDto {
    /**
     * 成功創建的員工
     * @type {Array<SuccessfulEmployee>}
     * @memberof BulkCreateEmployeesResponseDto
     */
    'successful': Array<SuccessfulEmployee>;
    /**
     * 創建失敗的員工
     * @type {Array<FailedEmployee>}
     * @memberof BulkCreateEmployeesResponseDto
     */
    'failed': Array<FailedEmployee>;
    /**
     * 總數
     * @type {number}
     * @memberof BulkCreateEmployeesResponseDto
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface CancelStatementDto
 */
export interface CancelStatementDto {
    /**
     * 
     * @type {string}
     * @memberof CancelStatementDto
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface CheckLineBoundResult
 */
export interface CheckLineBoundResult {
    /**
     * Indicates whether the LINE account is bound
     * @type {boolean}
     * @memberof CheckLineBoundResult
     */
    'isBound': boolean;
}
/**
 * 
 * @export
 * @interface CreateDeliveryMealElement
 */
export interface CreateDeliveryMealElement {
    /**
     * This is milliseconds timestamp
     * @type {number}
     * @memberof CreateDeliveryMealElement
     */
    'time': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryMealElement
     */
    'locationTagId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryMealElement
     */
    'providerId': string;
}
/**
 * 
 * @export
 * @interface CreateDeliveryMealsDto
 */
export interface CreateDeliveryMealsDto {
    /**
     * 
     * @type {Array<CreateDeliveryMealElement>}
     * @memberof CreateDeliveryMealsDto
     */
    'deliveryMeals': Array<CreateDeliveryMealElement>;
}
/**
 * 
 * @export
 * @interface CreateDriverEventDto
 */
export interface CreateDriverEventDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDriverEventDto
     */
    'driverId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverEventDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverEventDto
     */
    'note': string;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverEventDto
     */
    'time': number;
}
/**
 * 
 * @export
 * @interface CreateDriverInfoDto
 */
export interface CreateDriverInfoDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'idNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'carNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'carModel'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'carColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'bankCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'bankAccount'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'bankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverInfoDto
     */
    'lineGroupId'?: string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeDto
 */
export interface CreateEmployeeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'nationalIdNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'idNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'onBoardingTime': string;
}
/**
 * 
 * @export
 * @interface CreateEmployeePayrollDto
 */
export interface CreateEmployeePayrollDto {
    /**
     * 員工ID
     * @type {Array<string>}
     * @memberof CreateEmployeePayrollDto
     */
    'employeeIds'?: Array<string>;
    /**
     * 月份
     * @type {string}
     * @memberof CreateEmployeePayrollDto
     */
    'time': string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeResponseDto
 */
export interface CreateEmployeeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeResponseDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeSalaryAdjustmentByNameDto
 */
export interface CreateEmployeeSalaryAdjustmentByNameDto {
    /**
     * 員工姓名
     * @type {string}
     * @memberof CreateEmployeeSalaryAdjustmentByNameDto
     */
    'employeeName': string;
    /**
     * 金額
     * @type {number}
     * @memberof CreateEmployeeSalaryAdjustmentByNameDto
     */
    'amount': number;
    /**
     * 薪資調整類型
     * @type {string}
     * @memberof CreateEmployeeSalaryAdjustmentByNameDto
     */
    'type': string;
    /**
     * 備註
     * @type {string}
     * @memberof CreateEmployeeSalaryAdjustmentByNameDto
     */
    'note'?: string;
    /**
     * 時間 (ISO format)
     * @type {string}
     * @memberof CreateEmployeeSalaryAdjustmentByNameDto
     */
    'time': string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeSalaryAdjustmentDto
 */
export interface CreateEmployeeSalaryAdjustmentDto {
    /**
     * 員工ID
     * @type {string}
     * @memberof CreateEmployeeSalaryAdjustmentDto
     */
    'employeeId': string;
    /**
     * 金額
     * @type {number}
     * @memberof CreateEmployeeSalaryAdjustmentDto
     */
    'amount': number;
    /**
     * 薪資調整類型
     * @type {string}
     * @memberof CreateEmployeeSalaryAdjustmentDto
     */
    'type': string;
    /**
     * 備註
     * @type {string}
     * @memberof CreateEmployeeSalaryAdjustmentDto
     */
    'note'?: string;
    /**
     * 時間 (ISO format)
     * @type {string}
     * @memberof CreateEmployeeSalaryAdjustmentDto
     */
    'time': string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeWithRemittanceDto
 */
export interface CreateEmployeeWithRemittanceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'nationalIdNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'idNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'onBoardingTime': string;
    /**
     * 銀行代碼
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'bankCode'?: string;
    /**
     * 銀行帳號
     * @type {string}
     * @memberof CreateEmployeeWithRemittanceDto
     */
    'bankAccount'?: string;
}
/**
 * 
 * @export
 * @interface CreateLocationDto
 */
export interface CreateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationDto
     */
    'idNumber': number;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'backgroundColor': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationDto
     */
    'recycleBagsWeight': number;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'district'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'locationAssistantMeetingPoint'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationDto
     */
    'isLocationAssistantNeedToolsBag'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateLocationTagDto
 */
export interface CreateLocationTagDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationTagDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationTagDto
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationTagDto
     */
    'pay': number;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationTagDto
     */
    'rank': number;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationTagDto
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationTagDto
     */
    'textColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationTagDto
     */
    'markColor'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationTagDto
     */
    'locationIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateOrderDto
 */
export interface CreateOrderDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'clientTaxId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'contactInfo': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'deliveryDate': string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDto
     */
    'deliveryFee': number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDto
     */
    'discount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'contactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'customerSource'?: string;
    /**
     * 
     * @type {Array<CreateOrderItemDto>}
     * @memberof CreateOrderDto
     */
    'items': Array<CreateOrderItemDto>;
}
/**
 * 
 * @export
 * @interface CreateOrderItemDto
 */
export interface CreateOrderItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderItemDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderItemDto
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderItemDto
     */
    'providerId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderItemDto
     */
    'productId'?: string;
}
/**
 * 
 * @export
 * @interface CreateProviderDto
 */
export interface CreateProviderDto {
    /**
     * The name of the Provider
     * @type {string}
     * @memberof CreateProviderDto
     */
    'name': string;
    /**
     * The id number of the Provider
     * @type {string}
     * @memberof CreateProviderDto
     */
    'idNumber': string;
    /**
     * The line group id of the Provider
     * @type {string}
     * @memberof CreateProviderDto
     */
    'lineGroupId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderDto
     */
    'nickname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderDto
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderDto
     */
    'addressComment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderDto
     */
    'taxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderDto
     */
    'foodBusinessRegistrationNumber'?: string;
    /**
     * 
     * @type {EnterpriseOrderBusinessInfo}
     * @memberof CreateProviderDto
     */
    'enterpriseOrderBusinessInfo'?: EnterpriseOrderBusinessInfo;
}
/**
 * 
 * @export
 * @interface CreateProviderEventDto
 */
export interface CreateProviderEventDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProviderEventDto
     */
    'providerId': string;
    /**
     * 
     * @type {object}
     * @memberof CreateProviderEventDto
     */
    'type': object;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderEventDto
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderEventDto
     */
    'time': string;
    /**
     * 
     * @type {number}
     * @memberof CreateProviderEventDto
     */
    'fine': number;
}
/**
 * 
 * @export
 * @interface CreateProviderTagDto
 */
export interface CreateProviderTagDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProviderTagDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProviderTagDto
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProviderTagDto
     */
    'providerIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateProviderTypeDto
 */
export interface CreateProviderTypeDto {
    /**
     * The name of the provider type
     * @type {string}
     * @memberof CreateProviderTypeDto
     */
    'name': string;
    /**
     * The color(hex) associated with the provider type
     * @type {string}
     * @memberof CreateProviderTypeDto
     */
    'color': string;
}
/**
 * 
 * @export
 * @interface CreateReceivableDto
 */
export interface CreateReceivableDto {
    /**
     * 供應商 ID
     * @type {string}
     * @memberof CreateReceivableDto
     */
    'providerId': string;
    /**
     * 應收時間
     * @type {string}
     * @memberof CreateReceivableDto
     */
    'dueTime': string;
    /**
     * 費用名稱
     * @type {string}
     * @memberof CreateReceivableDto
     */
    'name': string;
    /**
     * 費用金額
     * @type {number}
     * @memberof CreateReceivableDto
     */
    'amount': number;
    /**
     * 備註
     * @type {string}
     * @memberof CreateReceivableDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface CreateReceivablePlanDto
 */
export interface CreateReceivablePlanDto {
    /**
     * provider id
     * @type {string}
     * @memberof CreateReceivablePlanDto
     */
    'providerId': string;
    /**
     * discount
     * @type {number}
     * @memberof CreateReceivablePlanDto
     */
    'discount'?: number;
    /**
     * 分期數，最少分一期
     * @type {number}
     * @memberof CreateReceivablePlanDto
     */
    'installmentAmount': number;
    /**
     * note
     * @type {string}
     * @memberof CreateReceivablePlanDto
     */
    'note'?: string;
    /**
     * total amount
     * @type {number}
     * @memberof CreateReceivablePlanDto
     */
    'totalAmount': number;
    /**
     * 費用名稱
     * @type {string}
     * @memberof CreateReceivablePlanDto
     */
    'name': string;
    /**
     * duration days
     * @type {number}
     * @memberof CreateReceivablePlanDto
     */
    'durationDays': number;
    /**
     * start time
     * @type {string}
     * @memberof CreateReceivablePlanDto
     */
    'startTime': string;
}
/**
 * 
 * @export
 * @interface CreateReportScheduleDto
 */
export interface CreateReportScheduleDto {
    /**
     * 班表ID
     * @type {string}
     * @memberof CreateReportScheduleDto
     */
    'scheduleId': string;
    /**
     * 備註
     * @type {string}
     * @memberof CreateReportScheduleDto
     */
    'note'?: string;
    /**
     * 回報時間
     * @type {Array<string>}
     * @memberof CreateReportScheduleDto
     */
    'dates': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateRoleDto
 */
export interface CreateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'desc'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRoleDto
     */
    'userIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRoleDto
     */
    'permissionIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateScheduleDto
 */
export interface CreateScheduleDto {
    /**
     * 開始時間
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'startTime': string;
    /**
     * 結束時間
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'endTime': string;
    /**
     * 備註
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface CreateToolBagOwnerDto
 */
export interface CreateToolBagOwnerDto {
    /**
     * 主要工具包負責人員工ID
     * @type {string}
     * @memberof CreateToolBagOwnerDto
     */
    'employeeId'?: string;
    /**
     * 副工具包負責人員工ID（通常是新人）
     * @type {string}
     * @memberof CreateToolBagOwnerDto
     */
    'secondaryEmployeeId'?: string;
    /**
     * 位置ID
     * @type {string}
     * @memberof CreateToolBagOwnerDto
     */
    'locationId': string;
    /**
     * 時間
     * @type {string}
     * @memberof CreateToolBagOwnerDto
     */
    'time': string;
}
/**
 * 
 * @export
 * @interface CreateVendingMenuDto
 */
export interface CreateVendingMenuDto {
    /**
     * 
     * @type {string}
     * @memberof CreateVendingMenuDto
     */
    'orderNumber': string;
    /**
     * 
     * @type {number}
     * @memberof CreateVendingMenuDto
     */
    'deadline': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateVendingMenuDto
     */
    'products': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteDeliveryMealsDto
 */
export interface DeleteDeliveryMealsDto {
    /**
     * 
     * @type {Array<CreateDeliveryMealElement>}
     * @memberof DeleteDeliveryMealsDto
     */
    'deliveryMeals': Array<CreateDeliveryMealElement>;
}
/**
 * 
 * @export
 * @interface Department
 */
export interface Department {
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DepartmentResult
 */
export interface DepartmentResult {
    /**
     * 
     * @type {string}
     * @memberof DepartmentResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DepartmentResult
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Employee
 */
export interface Employee {
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'birthday': string | null;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'idNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'nationalIdNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'onBoardingTime': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Employee
     */
    'lineId': string | null;
    /**
     * 
     * @type {RemittanceInfo}
     * @memberof Employee
     */
    'remittanceInfo': RemittanceInfo;
}
/**
 * 
 * @export
 * @interface EmployeeLocationHistoryItem
 */
export interface EmployeeLocationHistoryItem {
    /**
     * The unique identifier of the employee
     * @type {string}
     * @memberof EmployeeLocationHistoryItem
     */
    'employeeId': string;
    /**
     * List of location IDs the employee has been assigned to
     * @type {Array<string>}
     * @memberof EmployeeLocationHistoryItem
     */
    'locationIds': Array<string>;
}
/**
 * 
 * @export
 * @interface EmployeeResult
 */
export interface EmployeeResult {
    /**
     * 
     * @type {string}
     * @memberof EmployeeResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResult
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResult
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResult
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResult
     */
    'birthday': string | null;
    /**
     * Salary information of the employee
     * @type {FindDepartmentEmployeesResultSalaryInfo}
     * @memberof EmployeeResult
     */
    'salaryInfo': FindDepartmentEmployeesResultSalaryInfo;
    /**
     * History of salary information for the employee
     * @type {Array<FindDepartmentEmployeesResultSalaryInfoHistory>}
     * @memberof EmployeeResult
     */
    'salaryInfoHistory': Array<FindDepartmentEmployeesResultSalaryInfoHistory>;
}
/**
 * 
 * @export
 * @interface EnterpriseOrderBusinessInfo
 */
export interface EnterpriseOrderBusinessInfo {
    /**
     * 
     * @type {number}
     * @memberof EnterpriseOrderBusinessInfo
     */
    'commission'?: number;
}
/**
 * 
 * @export
 * @interface ExportDeliveryMealsDto
 */
export interface ExportDeliveryMealsDto {
    /**
     * This is milliseconds timestamp
     * @type {number}
     * @memberof ExportDeliveryMealsDto
     */
    'startTime': number;
    /**
     * This is milliseconds timestamp
     * @type {number}
     * @memberof ExportDeliveryMealsDto
     */
    'endTime': number;
}
/**
 * 
 * @export
 * @interface ExportDriversSalaryDto
 */
export interface ExportDriversSalaryDto {
    /**
     * This is milliseconds timestamp
     * @type {number}
     * @memberof ExportDriversSalaryDto
     */
    'startTime': number;
    /**
     * This is milliseconds timestamp
     * @type {number}
     * @memberof ExportDriversSalaryDto
     */
    'endTime': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportDriversSalaryDto
     */
    'driverIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ExportLocationAssistantShiftScheduleResult
 */
export interface ExportLocationAssistantShiftScheduleResult {
    /**
     * 
     * @type {object}
     * @memberof ExportLocationAssistantShiftScheduleResult
     */
    'buffer': object;
}
/**
 * 
 * @export
 * @interface ExportStatementsDto
 */
export interface ExportStatementsDto {
    /**
     * 
     * @type {string}
     * @memberof ExportStatementsDto
     */
    'exportType': string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatementsDto
     */
    'month': string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatementsDto
     */
    'period': string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatementsDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatementsDto
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatementsDto
     */
    'invoiceReceivedDueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatementsDto
     */
    'remittanceDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportStatementsDto
     */
    'providerIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportStatementsDto
     */
    'locationNumbers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FailedEmployee
 */
export interface FailedEmployee {
    /**
     * 員工姓名
     * @type {string}
     * @memberof FailedEmployee
     */
    'name': string;
    /**
     * 錯誤訊息
     * @type {string}
     * @memberof FailedEmployee
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface FilterOption
 */
export interface FilterOption {
    /**
     * 顯示文字
     * @type {string}
     * @memberof FilterOption
     */
    'text': string;
    /**
     * 值
     * @type {string}
     * @memberof FilterOption
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface FinalOrderActionDto
 */
export interface FinalOrderActionDto {
    /**
     * 
     * @type {number}
     * @memberof FinalOrderActionDto
     */
    'time': number;
}
/**
 * 
 * @export
 * @interface FindDepartmentEmployeesResult
 */
export interface FindDepartmentEmployeesResult {
    /**
     * 
     * @type {Array<EmployeeResult>}
     * @memberof FindDepartmentEmployeesResult
     */
    'data': Array<EmployeeResult>;
    /**
     * 
     * @type {number}
     * @memberof FindDepartmentEmployeesResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindDepartmentEmployeesResultSalaryInfo
 */
export interface FindDepartmentEmployeesResultSalaryInfo {
    /**
     * Salary amount of the employee
     * @type {number}
     * @memberof FindDepartmentEmployeesResultSalaryInfo
     */
    'amount': number;
    /**
     * Compensation type of the employee
     * @type {string}
     * @memberof FindDepartmentEmployeesResultSalaryInfo
     */
    'compensationType': string;
    /**
     * Default hours for the compensation
     * @type {number}
     * @memberof FindDepartmentEmployeesResultSalaryInfo
     */
    'defaultHours': number;
}
/**
 * 
 * @export
 * @interface FindDepartmentEmployeesResultSalaryInfoHistory
 */
export interface FindDepartmentEmployeesResultSalaryInfoHistory {
    /**
     * Salary amount of the employee
     * @type {number}
     * @memberof FindDepartmentEmployeesResultSalaryInfoHistory
     */
    'amount': number;
    /**
     * Compensation type of the employee
     * @type {string}
     * @memberof FindDepartmentEmployeesResultSalaryInfoHistory
     */
    'compensationType': string;
    /**
     * Default hours for the compensation
     * @type {number}
     * @memberof FindDepartmentEmployeesResultSalaryInfoHistory
     */
    'defaultHours': number;
    /**
     * Time when the salary information was effective
     * @type {string}
     * @memberof FindDepartmentEmployeesResultSalaryInfoHistory
     */
    'time': string;
}
/**
 * 
 * @export
 * @interface FindDepartmentResult
 */
export interface FindDepartmentResult {
    /**
     * 
     * @type {DepartmentResult}
     * @memberof FindDepartmentResult
     */
    'data': DepartmentResult;
}
/**
 * 
 * @export
 * @interface FindDepartmentsResult
 */
export interface FindDepartmentsResult {
    /**
     * 
     * @type {Array<Department>}
     * @memberof FindDepartmentsResult
     */
    'data': Array<Department>;
    /**
     * 
     * @type {number}
     * @memberof FindDepartmentsResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindEmployeeLocationHistoryResult
 */
export interface FindEmployeeLocationHistoryResult {
    /**
     * Employee location history data
     * @type {Array<EmployeeLocationHistoryItem>}
     * @memberof FindEmployeeLocationHistoryResult
     */
    'data': Array<EmployeeLocationHistoryItem>;
}
/**
 * 
 * @export
 * @interface FindEmployeePayrollsResult
 */
export interface FindEmployeePayrollsResult {
    /**
     * 員工薪資列表
     * @type {Array<FindEmployeePayrollsResultDataItem>}
     * @memberof FindEmployeePayrollsResult
     */
    'data': Array<FindEmployeePayrollsResultDataItem>;
    /**
     * 
     * @type {number}
     * @memberof FindEmployeePayrollsResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindEmployeePayrollsResultDataItem
 */
export interface FindEmployeePayrollsResultDataItem {
    /**
     * 
     * @type {string}
     * @memberof FindEmployeePayrollsResultDataItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FindEmployeePayrollsResultDataItem
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof FindEmployeePayrollsResultDataItem
     */
    'pdfUrl': string;
    /**
     * 
     * @type {number}
     * @memberof FindEmployeePayrollsResultDataItem
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof FindEmployeePayrollsResultDataItem
     */
    'status': FindEmployeePayrollsResultDataItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FindEmployeePayrollsResultDataItem
     */
    'time': string;
    /**
     * 
     * @type {Array<FindEmployeePayrollsResultDataItemStatusHistoryItem>}
     * @memberof FindEmployeePayrollsResultDataItem
     */
    'statusHistory': Array<FindEmployeePayrollsResultDataItemStatusHistoryItem>;
}

export const FindEmployeePayrollsResultDataItemStatusEnum = {
    Draft: 'DRAFT',
    Reviewing: 'REVIEWING',
    EmployeeConfirming: 'EMPLOYEE_CONFIRMING',
    EmployeeDisputed: 'EMPLOYEE_DISPUTED',
    ReadyForPay: 'READY_FOR_PAY',
    Paid: 'PAID',
    Voided: 'VOIDED'
} as const;

export type FindEmployeePayrollsResultDataItemStatusEnum = typeof FindEmployeePayrollsResultDataItemStatusEnum[keyof typeof FindEmployeePayrollsResultDataItemStatusEnum];

/**
 * 
 * @export
 * @interface FindEmployeePayrollsResultDataItemStatusHistoryItem
 */
export interface FindEmployeePayrollsResultDataItemStatusHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof FindEmployeePayrollsResultDataItemStatusHistoryItem
     */
    'status': FindEmployeePayrollsResultDataItemStatusHistoryItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FindEmployeePayrollsResultDataItemStatusHistoryItem
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof FindEmployeePayrollsResultDataItemStatusHistoryItem
     */
    'note': string | null;
}

export const FindEmployeePayrollsResultDataItemStatusHistoryItemStatusEnum = {
    Draft: 'DRAFT',
    Reviewing: 'REVIEWING',
    EmployeeConfirming: 'EMPLOYEE_CONFIRMING',
    EmployeeDisputed: 'EMPLOYEE_DISPUTED',
    ReadyForPay: 'READY_FOR_PAY',
    Paid: 'PAID',
    Voided: 'VOIDED'
} as const;

export type FindEmployeePayrollsResultDataItemStatusHistoryItemStatusEnum = typeof FindEmployeePayrollsResultDataItemStatusHistoryItemStatusEnum[keyof typeof FindEmployeePayrollsResultDataItemStatusHistoryItemStatusEnum];

/**
 * 
 * @export
 * @interface FindEmployeesResult
 */
export interface FindEmployeesResult {
    /**
     * 
     * @type {Array<Employee>}
     * @memberof FindEmployeesResult
     */
    'data': Array<Employee>;
    /**
     * 
     * @type {number}
     * @memberof FindEmployeesResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindFindScheduleByIdResultDateItem
 */
export interface FindFindScheduleByIdResultDateItem {
    /**
     * The date of the schedule
     * @type {string}
     * @memberof FindFindScheduleByIdResultDateItem
     */
    'time': string;
    /**
     * Indicates if the date is waiting for arrangement
     * @type {boolean}
     * @memberof FindFindScheduleByIdResultDateItem
     */
    'isWaitingForArrange': boolean;
    /**
     * The location ID
     * @type {string}
     * @memberof FindFindScheduleByIdResultDateItem
     */
    'locationId': string;
}
/**
 * 
 * @export
 * @interface FindLocationAssistantReportShiftsResult
 */
export interface FindLocationAssistantReportShiftsResult {
    /**
     * List of available shifts
     * @type {Array<AvailableShifts>}
     * @memberof FindLocationAssistantReportShiftsResult
     */
    'data': Array<AvailableShifts>;
    /**
     * Total number of shifts
     * @type {number}
     * @memberof FindLocationAssistantReportShiftsResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindLocationAssistantShiftScheduleResult
 */
export interface FindLocationAssistantShiftScheduleResult {
    /**
     * 查詢結果的數據
     * @type {Array<FindLocationAssistantShiftScheduleResultDataItem>}
     * @memberof FindLocationAssistantShiftScheduleResult
     */
    'data': Array<FindLocationAssistantShiftScheduleResultDataItem>;
    /**
     * 查詢結果的總數量
     * @type {number}
     * @memberof FindLocationAssistantShiftScheduleResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindLocationAssistantShiftScheduleResultDataItem
 */
export interface FindLocationAssistantShiftScheduleResultDataItem {
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftScheduleResultDataItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftScheduleResultDataItem
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftScheduleResultDataItem
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftScheduleResultDataItem
     */
    'note': string | null;
    /**
     * 與此排班表關聯的員工回報班表 (已根據員工篩選)
     * @type {Array<LocationAssistantReportScheduleResultItem>}
     * @memberof FindLocationAssistantShiftScheduleResultDataItem
     */
    'locationAssistantReportSchedule': Array<LocationAssistantReportScheduleResultItem>;
}
/**
 * 
 * @export
 * @interface FindLocationAssistantShiftsResult
 */
export interface FindLocationAssistantShiftsResult {
    /**
     * 查詢結果的數據
     * @type {Array<FindLocationAssistantShiftsResultDataItem>}
     * @memberof FindLocationAssistantShiftsResult
     */
    'data': Array<FindLocationAssistantShiftsResultDataItem>;
    /**
     * 查詢結果的總數量
     * @type {number}
     * @memberof FindLocationAssistantShiftsResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindLocationAssistantShiftsResultDataItem
 */
export interface FindLocationAssistantShiftsResultDataItem {
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'locationName': string;
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'locationBackgroundColor': string;
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'locationIdNumber': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'partnerNames': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'locationAddress': string;
    /**
     * 
     * @type {string}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'meetingPoint': string | null;
    /**
     * 是否為主要工具包負責人
     * @type {boolean}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'hasToolBag': boolean;
    /**
     * 是否為副工具包負責人（新人）
     * @type {boolean}
     * @memberof FindLocationAssistantShiftsResultDataItem
     */
    'hasSecondaryToolBag': boolean;
}
/**
 * 
 * @export
 * @interface FindLocationsResult
 */
export interface FindLocationsResult {
    /**
     * 
     * @type {Array<LocationResultDto>}
     * @memberof FindLocationsResult
     */
    'locations': Array<LocationResultDto>;
    /**
     * 
     * @type {number}
     * @memberof FindLocationsResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindProductsResult
 */
export interface FindProductsResult {
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof FindProductsResult
     */
    'products': Array<ProductDto>;
    /**
     * 
     * @type {Array<ProviderFilterDto>}
     * @memberof FindProductsResult
     */
    'providerFilters': Array<ProviderFilterDto>;
    /**
     * 
     * @type {number}
     * @memberof FindProductsResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindProvider
 */
export interface FindProvider {
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'id': string;
    /**
     * 
     * @type {PaymentInfoResult}
     * @memberof FindProvider
     */
    'paymentInfo': PaymentInfoResult | null;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'idNumber': string;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'nickname': string;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'type': string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'lineGroupId': string;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'foodBusinessRegistrationNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'taxId': string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'address': string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'addressComment': string | null;
    /**
     * 
     * @type {string}
     * @memberof FindProvider
     */
    'status': string | null;
}
/**
 * 
 * @export
 * @interface FindProviderResult
 */
export interface FindProviderResult {
    /**
     * 
     * @type {FindProvider}
     * @memberof FindProviderResult
     */
    'data': FindProvider;
}
/**
 * 
 * @export
 * @interface FindProviderTypesResult
 */
export interface FindProviderTypesResult {
    /**
     * 
     * @type {Array<ProviderType>}
     * @memberof FindProviderTypesResult
     */
    'data': Array<ProviderType>;
    /**
     * 
     * @type {number}
     * @memberof FindProviderTypesResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindReceivablePlansResult
 */
export interface FindReceivablePlansResult {
    /**
     * The list of receivable plans
     * @type {Array<ReceivablePlan>}
     * @memberof FindReceivablePlansResult
     */
    'data': Array<ReceivablePlan>;
    /**
     * The total number of receivable plans
     * @type {number}
     * @memberof FindReceivablePlansResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindReceivablesResult
 */
export interface FindReceivablesResult {
    /**
     * 
     * @type {Array<ReceivableDto>}
     * @memberof FindReceivablesResult
     */
    'data': Array<ReceivableDto>;
    /**
     * 
     * @type {number}
     * @memberof FindReceivablesResult
     */
    'total': number;
    /**
     * 
     * @type {Array<ProviderDto>}
     * @memberof FindReceivablesResult
     */
    'providerFilters': Array<ProviderDto>;
}
/**
 * 
 * @export
 * @interface FindScheduleByIdResult
 */
export interface FindScheduleByIdResult {
    /**
     * The unique identifier of the schedule
     * @type {string}
     * @memberof FindScheduleByIdResult
     */
    'id': string;
    /**
     * The start time of the schedule
     * @type {string}
     * @memberof FindScheduleByIdResult
     */
    'startTime': string;
    /**
     * The end time of the schedule
     * @type {string}
     * @memberof FindScheduleByIdResult
     */
    'endTime': string;
    /**
     * Additional notes about the schedule
     * @type {object}
     * @memberof FindScheduleByIdResult
     */
    'note'?: object;
    /**
     * Associated location assistant shifts
     * @type {Array<FindScheduleByIdResultShift>}
     * @memberof FindScheduleByIdResult
     */
    'shifts': Array<FindScheduleByIdResultShift>;
    /**
     * Associated dates for the schedule
     * @type {Array<FindFindScheduleByIdResultDateItem>}
     * @memberof FindScheduleByIdResult
     */
    'dates': Array<FindFindScheduleByIdResultDateItem>;
    /**
     * When the schedule was created
     * @type {string}
     * @memberof FindScheduleByIdResult
     */
    'createdAt': string;
    /**
     * When the schedule was last updated
     * @type {string}
     * @memberof FindScheduleByIdResult
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface FindScheduleByIdResultShift
 */
export interface FindScheduleByIdResultShift {
    /**
     * The unique identifier of the shift
     * @type {string}
     * @memberof FindScheduleByIdResultShift
     */
    'id': string;
    /**
     * The unique identifier of the location
     * @type {string}
     * @memberof FindScheduleByIdResultShift
     */
    'locationId': string;
    /**
     * The unique identifier of the employee
     * @type {string}
     * @memberof FindScheduleByIdResultShift
     */
    'employeeId': string;
    /**
     * The time of the shift
     * @type {string}
     * @memberof FindScheduleByIdResultShift
     */
    'time': string;
    /**
     * 
     * @type {boolean}
     * @memberof FindScheduleByIdResultShift
     */
    'toolBagOwner': boolean;
}
/**
 * 
 * @export
 * @interface FindSchedulesResult
 */
export interface FindSchedulesResult {
    /**
     * 
     * @type {Array<LocationAssistantShiftScheduleResult>}
     * @memberof FindSchedulesResult
     */
    'data': Array<LocationAssistantShiftScheduleResult>;
    /**
     * 總記錄數
     * @type {number}
     * @memberof FindSchedulesResult
     */
    'total': number;
    /**
     * 跳過筆數
     * @type {number}
     * @memberof FindSchedulesResult
     */
    'skip': number;
    /**
     * 取得筆數
     * @type {number}
     * @memberof FindSchedulesResult
     */
    'take': number;
}
/**
 * 
 * @export
 * @interface FindSettingsResult
 */
export interface FindSettingsResult {
    /**
     * 
     * @type {Array<FindSettingsResultDataItem>}
     * @memberof FindSettingsResult
     */
    'data': Array<FindSettingsResultDataItem>;
}
/**
 * 
 * @export
 * @interface FindSettingsResultDataItem
 */
export interface FindSettingsResultDataItem {
    /**
     * 
     * @type {string}
     * @memberof FindSettingsResultDataItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FindSettingsResultDataItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FindSettingsResultDataItem
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface FindToolBagOwnersResult
 */
export interface FindToolBagOwnersResult {
    /**
     * 工具包所有者列表
     * @type {Array<FindToolBagOwnersResultDateItem>}
     * @memberof FindToolBagOwnersResult
     */
    'data': Array<FindToolBagOwnersResultDateItem>;
    /**
     * 總數量
     * @type {number}
     * @memberof FindToolBagOwnersResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface FindToolBagOwnersResultDateItem
 */
export interface FindToolBagOwnersResultDateItem {
    /**
     * 主要工具包負責人員工ID
     * @type {string}
     * @memberof FindToolBagOwnersResultDateItem
     */
    'employeeId': string;
    /**
     * 副工具包負責人員工ID（通常是新人）
     * @type {string}
     * @memberof FindToolBagOwnersResultDateItem
     */
    'secondaryEmployeeId'?: string;
    /**
     * 位置ID
     * @type {string}
     * @memberof FindToolBagOwnersResultDateItem
     */
    'locationId': string;
    /**
     * 時間
     * @type {string}
     * @memberof FindToolBagOwnersResultDateItem
     */
    'time': string;
}
/**
 * 
 * @export
 * @interface FindUsersResult
 */
export interface FindUsersResult {
    /**
     * User IDs
     * @type {Array<UserDto>}
     * @memberof FindUsersResult
     */
    'users': Array<UserDto>;
    /**
     * 
     * @type {number}
     * @memberof FindUsersResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface GenerateAllProviderDriveDataDto
 */
export interface GenerateAllProviderDriveDataDto {
    /**
     * 
     * @type {boolean}
     * @memberof GenerateAllProviderDriveDataDto
     */
    'needRefresh'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GenerateAllProviderDriveDataDto
     */
    'durationLimit'?: number;
}
/**
 * 
 * @export
 * @interface GetAllEmployeeSalaryAdjustmentsResult
 */
export interface GetAllEmployeeSalaryAdjustmentsResult {
    /**
     * 
     * @type {number}
     * @memberof GetAllEmployeeSalaryAdjustmentsResult
     */
    'total': number;
    /**
     * 
     * @type {Array<GetAllEmployeeSalaryAdjustmentsResultDataItem>}
     * @memberof GetAllEmployeeSalaryAdjustmentsResult
     */
    'data': Array<GetAllEmployeeSalaryAdjustmentsResultDataItem>;
}
/**
 * 
 * @export
 * @interface GetAllEmployeeSalaryAdjustmentsResultDataItem
 */
export interface GetAllEmployeeSalaryAdjustmentsResultDataItem {
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItem
     */
    'status': GetAllEmployeeSalaryAdjustmentsResultDataItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItem
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItem
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItem
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItem
     */
    'time': string;
    /**
     * 
     * @type {GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItem
     */
    'employee': GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee;
}

export const GetAllEmployeeSalaryAdjustmentsResultDataItemStatusEnum = {
    Pending: 'PENDING',
    Settled: 'SETTLED'
} as const;

export type GetAllEmployeeSalaryAdjustmentsResultDataItemStatusEnum = typeof GetAllEmployeeSalaryAdjustmentsResultDataItemStatusEnum[keyof typeof GetAllEmployeeSalaryAdjustmentsResultDataItemStatusEnum];

/**
 * 
 * @export
 * @interface GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee
 */
export interface GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee {
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee
     */
    'nickname': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee
     */
    'idNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllEmployeeSalaryAdjustmentsResultDataItemEmployee
     */
    'department': string;
}
/**
 * 
 * @export
 * @interface GetEmployeeSalaryAdjustmentFiltersResult
 */
export interface GetEmployeeSalaryAdjustmentFiltersResult {
    /**
     * 日期過濾選項
     * @type {Array<FilterOption>}
     * @memberof GetEmployeeSalaryAdjustmentFiltersResult
     */
    'date': Array<FilterOption>;
    /**
     * 員工編號過濾選項
     * @type {Array<FilterOption>}
     * @memberof GetEmployeeSalaryAdjustmentFiltersResult
     */
    'idNumber': Array<FilterOption>;
    /**
     * 員工姓名過濾選項
     * @type {Array<FilterOption>}
     * @memberof GetEmployeeSalaryAdjustmentFiltersResult
     */
    'name': Array<FilterOption>;
    /**
     * 員工綽號過濾選項
     * @type {Array<FilterOption>}
     * @memberof GetEmployeeSalaryAdjustmentFiltersResult
     */
    'nickname': Array<FilterOption>;
}
/**
 * 
 * @export
 * @interface GetEmployeeSalaryAdjustmentTypesResult
 */
export interface GetEmployeeSalaryAdjustmentTypesResult {
    /**
     * 薪資調整類型列表
     * @type {Array<string>}
     * @memberof GetEmployeeSalaryAdjustmentTypesResult
     */
    'data': Array<string>;
}
/**
 * 
 * @export
 * @interface GetEnterpriseOrdersResult
 */
export interface GetEnterpriseOrdersResult {
    /**
     * 
     * @type {Array<GetEnterpriseOrdersResultDataItem>}
     * @memberof GetEnterpriseOrdersResult
     */
    'data': Array<GetEnterpriseOrdersResultDataItem>;
    /**
     * 
     * @type {number}
     * @memberof GetEnterpriseOrdersResult
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface GetEnterpriseOrdersResultDataItem
 */
export interface GetEnterpriseOrdersResultDataItem {
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'clientTaxId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'contactInfo': string;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'deliveryAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'deliveryDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'deliveryFee': number;
    /**
     * 
     * @type {number}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'discount': number;
    /**
     * 
     * @type {Array<GetEnterpriseOrdersResultDataItemItem>}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'items': Array<GetEnterpriseOrdersResultDataItemItem>;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'status': GetEnterpriseOrdersResultDataItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItem
     */
    'creatorName': string | null;
}

export const GetEnterpriseOrdersResultDataItemStatusEnum = {
    Ongoing: 'ONGOING',
    Completed: 'COMPLETED'
} as const;

export type GetEnterpriseOrdersResultDataItemStatusEnum = typeof GetEnterpriseOrdersResultDataItemStatusEnum[keyof typeof GetEnterpriseOrdersResultDataItemStatusEnum];

/**
 * 
 * @export
 * @interface GetEnterpriseOrdersResultDataItemItem
 */
export interface GetEnterpriseOrdersResultDataItemItem {
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItemItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItemItem
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof GetEnterpriseOrdersResultDataItemItem
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof GetEnterpriseOrdersResultDataItemItem
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItemItem
     */
    'providerName': string;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItemItem
     */
    'providerIdNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetEnterpriseOrdersResultDataItemItem
     */
    'providerId': string;
}
/**
 * 
 * @export
 * @interface GetMyProfileResult
 */
export interface GetMyProfileResult {
    /**
     * 
     * @type {UserProfileDto}
     * @memberof GetMyProfileResult
     */
    'user': UserProfileDto | null;
}
/**
 * 
 * @export
 * @interface GetRankingResponseDto
 */
export interface GetRankingResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetRankingResponseDto
     */
    'ranking': Array<string>;
}
/**
 * 
 * @export
 * @interface GetReceivableNamesResult
 */
export interface GetReceivableNamesResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetReceivableNamesResult
     */
    'names': Array<string>;
}
/**
 * 
 * @export
 * @interface GetSummaryResponseDto
 */
export interface GetSummaryResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSummaryResponseDto
     */
    'summary': Array<string>;
}
/**
 * 
 * @export
 * @interface GetUserCountResponseDto
 */
export interface GetUserCountResponseDto {
    /**
     * 
     * @type {number}
     * @memberof GetUserCountResponseDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ImportOrdersByProviderDto
 */
export interface ImportOrdersByProviderDto {
    /**
     * 
     * @type {string}
     * @memberof ImportOrdersByProviderDto
     */
    'redeemTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportOrdersByProviderDto
     */
    'needNotify': boolean;
}
/**
 * 
 * @export
 * @interface LineLoginDto
 */
export interface LineLoginDto {
    /**
     * Line access token
     * @type {string}
     * @memberof LineLoginDto
     */
    'lineAccessToken': string;
}
/**
 * 
 * @export
 * @interface ListEmployee
 */
export interface ListEmployee {
    /**
     * Employee name
     * @type {string}
     * @memberof ListEmployee
     */
    'name': string | null;
    /**
     * Employee id
     * @type {string}
     * @memberof ListEmployee
     */
    'id': string;
    /**
     * Employee idNumber
     * @type {string}
     * @memberof ListEmployee
     */
    'idNumber': string | null;
    /**
     * Employee state
     * @type {string}
     * @memberof ListEmployee
     */
    'state': ListEmployeeStateEnum;
    /**
     * Employee onBoardingTime
     * @type {string}
     * @memberof ListEmployee
     */
    'onBoardingTime': string;
}

export const ListEmployeeStateEnum = {
    Activated: 'ACTIVATED',
    Suspended: 'SUSPENDED'
} as const;

export type ListEmployeeStateEnum = typeof ListEmployeeStateEnum[keyof typeof ListEmployeeStateEnum];

/**
 * 
 * @export
 * @interface ListEmployeeTypesResult
 */
export interface ListEmployeeTypesResult {
    /**
     * 員工類型列表
     * @type {Array<string>}
     * @memberof ListEmployeeTypesResult
     */
    'data': Array<string>;
}
/**
 * 
 * @export
 * @interface ListEmployeesResult
 */
export interface ListEmployeesResult {
    /**
     * List of employees
     * @type {Array<ListEmployee>}
     * @memberof ListEmployeesResult
     */
    'data': Array<ListEmployee>;
}
/**
 * 
 * @export
 * @interface ListLocationsResultDataItem
 */
export interface ListLocationsResultDataItem {
    /**
     * 
     * @type {string}
     * @memberof ListLocationsResultDataItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ListLocationsResultDataItem
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ListLocationsResultDataItem
     */
    'idNumber': number;
    /**
     * 
     * @type {string}
     * @memberof ListLocationsResultDataItem
     */
    'address': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListLocationsResultDataItem
     */
    'status': ListLocationsResultDataItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ListLocationsResultDataItem
     */
    'nickname': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListLocationsResultDataItem
     */
    'backgroundColor': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListLocationsResultDataItem
     */
    'isLocationAssistantNeedToolsBag': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListLocationsResultDataItem
     */
    'meetUpPoint': string | null;
    /**
     * 
     * @type {string}
     * @memberof ListLocationsResultDataItem
     */
    'district': string | null;
}

export const ListLocationsResultDataItemStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type ListLocationsResultDataItemStatusEnum = typeof ListLocationsResultDataItemStatusEnum[keyof typeof ListLocationsResultDataItemStatusEnum];

/**
 * 
 * @export
 * @interface ListProvidersResponseDto
 */
export interface ListProvidersResponseDto {
    /**
     * 
     * @type {Array<Provider>}
     * @memberof ListProvidersResponseDto
     */
    'providers': Array<Provider>;
}
/**
 * 
 * @export
 * @interface LocationAssistantInfoDto
 */
export interface LocationAssistantInfoDto {
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantInfoDto
     */
    'transportationMethod': string | null;
}
/**
 * 
 * @export
 * @interface LocationAssistantReportScheduleResultItem
 */
export interface LocationAssistantReportScheduleResultItem {
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportScheduleResultItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportScheduleResultItem
     */
    'employeeId': string;
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportScheduleResultItem
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportScheduleResultItem
     */
    'scheduleId': string;
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportScheduleResultItem
     */
    'time': string;
    /**
     * 該回報班表關聯的班次回報記錄
     * @type {Array<LocationAssistantReportShiftResultItem>}
     * @memberof LocationAssistantReportScheduleResultItem
     */
    'locationAssistantReportShifts': Array<LocationAssistantReportShiftResultItem>;
}
/**
 * 
 * @export
 * @interface LocationAssistantReportShiftResultItem
 */
export interface LocationAssistantReportShiftResultItem {
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportShiftResultItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportShiftResultItem
     */
    'employeeId': string;
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportShiftResultItem
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportShiftResultItem
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof LocationAssistantReportShiftResultItem
     */
    'locationAssistantReportShiftScheduleId': string;
}
/**
 * 
 * @export
 * @interface LocationAssistantShiftScheduleResult
 */
export interface LocationAssistantShiftScheduleResult {
    /**
     * 排程 ID
     * @type {string}
     * @memberof LocationAssistantShiftScheduleResult
     */
    'id': string;
    /**
     * 排程名稱
     * @type {string}
     * @memberof LocationAssistantShiftScheduleResult
     */
    'startTime': string;
    /**
     * 結束時間
     * @type {string}
     * @memberof LocationAssistantShiftScheduleResult
     */
    'endTime': string;
    /**
     * 備註
     * @type {string}
     * @memberof LocationAssistantShiftScheduleResult
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface LocationAssistantShiftScheduleSettingResult
 */
export interface LocationAssistantShiftScheduleSettingResult {
    /**
     * 排班設定列表
     * @type {Array<LocationAssistantShiftScheduleSettingResultDataItem>}
     * @memberof LocationAssistantShiftScheduleSettingResult
     */
    'data': Array<LocationAssistantShiftScheduleSettingResultDataItem>;
}
/**
 * 
 * @export
 * @interface LocationAssistantShiftScheduleSettingResultDataItem
 */
export interface LocationAssistantShiftScheduleSettingResultDataItem {
    /**
     * 設定 ID
     * @type {number}
     * @memberof LocationAssistantShiftScheduleSettingResultDataItem
     */
    'id': number;
    /**
     * 設定鍵值
     * @type {string}
     * @memberof LocationAssistantShiftScheduleSettingResultDataItem
     */
    'key': string;
    /**
     * 設定名稱
     * @type {string}
     * @memberof LocationAssistantShiftScheduleSettingResultDataItem
     */
    'name': string;
    /**
     * 設定值
     * @type {string}
     * @memberof LocationAssistantShiftScheduleSettingResultDataItem
     */
    'value': string;
    /**
     * 設定備註
     * @type {object}
     * @memberof LocationAssistantShiftScheduleSettingResultDataItem
     */
    'note': object | null;
}
/**
 * 
 * @export
 * @interface LocationResultDto
 */
export interface LocationResultDto {
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof LocationResultDto
     */
    'idNumber': number;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'backgroundColor': string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'address': string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'district': string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'city': string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'comment': string | null;
    /**
     * 
     * @type {number}
     * @memberof LocationResultDto
     */
    'recycleBagsWeight': number;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'nickname': string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationResultDto
     */
    'locationAssistantMeetingPoint': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationResultDto
     */
    'isLocationAssistantNeedToolsBag': boolean;
}
/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * username
     * @type {string}
     * @memberof LoginDto
     */
    'username': string;
    /**
     * password
     * @type {string}
     * @memberof LoginDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDto
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 訊息類型
     * @type {string}
     * @memberof Message
     */
    'type': MessageTypeEnum;
    /**
     * 訊息內容
     * @type {string}
     * @memberof Message
     */
    'text'?: string;
    /**
     * 
     * @type {File}
     * @memberof Message
     */
    'image'?: File;
}

export const MessageTypeEnum = {
    Text: 'TEXT',
    Image: 'IMAGE'
} as const;

export type MessageTypeEnum = typeof MessageTypeEnum[keyof typeof MessageTypeEnum];

/**
 * 
 * @export
 * @interface PayEmployeePayrollDto
 */
export interface PayEmployeePayrollDto {
    /**
     * 薪資單ID
     * @type {Array<string>}
     * @memberof PayEmployeePayrollDto
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface PayStatementsDto
 */
export interface PayStatementsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PayStatementsDto
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface PaymentInfoResult
 */
export interface PaymentInfoResult {
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResult
     */
    'account': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResult
     */
    'accountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResult
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResult
     */
    'bankBranchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResult
     */
    'receiptType': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentInfoResult
     */
    'shouldInvoice': boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResult
     */
    'contactPerson': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResult
     */
    'phoneNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentInfoResult
     */
    'email': string | null;
}
/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {object}
     * @memberof ProductDto
     */
    'cost': object;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'idNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    'isToppings': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'provider': string;
}
/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'birthday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'nickname'?: string | null;
}
/**
 * 
 * @export
 * @interface ProfileDto
 */
export interface ProfileDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'displayName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'nickname': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'birthday': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'address': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'photoUrl': string | null;
}
/**
 * 
 * @export
 * @interface Provider
 */
export interface Provider {
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'idNumber': string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'nickname': string;
    /**
     * 
     * @type {object}
     * @memberof Provider
     */
    'address'?: object;
    /**
     * 
     * @type {object}
     * @memberof Provider
     */
    'type'?: object;
    /**
     * 
     * @type {object}
     * @memberof Provider
     */
    'lastPickTime'?: object;
}
/**
 * 
 * @export
 * @interface ProviderDto
 */
export interface ProviderDto {
    /**
     * 
     * @type {string}
     * @memberof ProviderDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderDto
     */
    'idNumber': string;
}
/**
 * 
 * @export
 * @interface ProviderFilterDto
 */
export interface ProviderFilterDto {
    /**
     * 
     * @type {string}
     * @memberof ProviderFilterDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderFilterDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ProviderType
 */
export interface ProviderType {
    /**
     * 
     * @type {string}
     * @memberof ProviderType
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProviderType
     */
    'color': string;
}
/**
 * 
 * @export
 * @interface PublishProvidersMessage
 */
export interface PublishProvidersMessage {
    /**
     * 如果是全部 則 providerIds 可以不帶
     * @type {Array<string>}
     * @memberof PublishProvidersMessage
     */
    'providerIds'?: Array<string>;
    /**
     * 訊息內容
     * @type {Array<Message>}
     * @memberof PublishProvidersMessage
     */
    'messages': Array<Message>;
}
/**
 * 
 * @export
 * @interface ReceivableDto
 */
export interface ReceivableDto {
    /**
     * 
     * @type {ProviderDto}
     * @memberof ReceivableDto
     */
    'provider': ProviderDto;
    /**
     * 
     * @type {string}
     * @memberof ReceivableDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof ReceivableDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof ReceivableDto
     */
    'dueTime': string;
    /**
     * 
     * @type {string}
     * @memberof ReceivableDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReceivableDto
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivableDto
     */
    'state': ReceivableDtoStateEnum;
}

export const ReceivableDtoStateEnum = {
    Received: 'RECEIVED',
    Unreceived: 'UNRECEIVED'
} as const;

export type ReceivableDtoStateEnum = typeof ReceivableDtoStateEnum[keyof typeof ReceivableDtoStateEnum];

/**
 * 
 * @export
 * @interface ReceivablePlan
 */
export interface ReceivablePlan {
    /**
     * The id of the receivable plan
     * @type {string}
     * @memberof ReceivablePlan
     */
    'id': string;
    /**
     * The name of the receivable plan
     * @type {string}
     * @memberof ReceivablePlan
     */
    'name': string;
    /**
     * The amount of the receivable plan
     * @type {number}
     * @memberof ReceivablePlan
     */
    'totalAmount': number;
    /**
     * The amount of the installment
     * @type {number}
     * @memberof ReceivablePlan
     */
    'installmentAmount': number;
    /**
     * The duration of the receivable plan
     * @type {number}
     * @memberof ReceivablePlan
     */
    'durationDays': number;
    /**
     * note
     * @type {string}
     * @memberof ReceivablePlan
     */
    'note': string | null;
    /**
     * The provider of the receivable plan
     * @type {ReceivableProvider}
     * @memberof ReceivablePlan
     */
    'provider': ReceivableProvider;
}
/**
 * 
 * @export
 * @interface ReceivableProvider
 */
export interface ReceivableProvider {
    /**
     * The id of the provider
     * @type {string}
     * @memberof ReceivableProvider
     */
    'id': string;
    /**
     * The id number of the provider
     * @type {string}
     * @memberof ReceivableProvider
     */
    'idNumber': string;
    /**
     * The name of the provider
     * @type {string}
     * @memberof ReceivableProvider
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RefundOrderItemDto
 */
export interface RefundOrderItemDto {
    /**
     * 
     * @type {number}
     * @memberof RefundOrderItemDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof RefundOrderItemDto
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof RefundOrderItemDto
     */
    'note'?: string;
    /**
     * 
     * @type {number}
     * @memberof RefundOrderItemDto
     */
    'fee': number;
}
/**
 * 
 * @export
 * @interface RemittanceInfo
 */
export interface RemittanceInfo {
    /**
     * 
     * @type {string}
     * @memberof RemittanceInfo
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof RemittanceInfo
     */
    'bankAccount': string | null;
    /**
     * 
     * @type {string}
     * @memberof RemittanceInfo
     */
    'bankName': string | null;
}
/**
 * 
 * @export
 * @interface ResolveStatementDto
 */
export interface ResolveStatementDto {
    /**
     * 
     * @type {string}
     * @memberof ResolveStatementDto
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'desc': string | null;
}
/**
 * 
 * @export
 * @interface SendConfirmNotificationDto
 */
export interface SendConfirmNotificationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SendConfirmNotificationDto
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SendConfirmPushMessageDto
 */
export interface SendConfirmPushMessageDto {
    /**
     * 薪資單ID
     * @type {Array<string>}
     * @memberof SendConfirmPushMessageDto
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SendDeliveriesToLineDto
 */
export interface SendDeliveriesToLineDto {
    /**
     * This is milliseconds timestamp
     * @type {Array<number>}
     * @memberof SendDeliveriesToLineDto
     */
    'times': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendDeliveriesToLineDto
     */
    'driverIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SendDriversSalaryDto
 */
export interface SendDriversSalaryDto {
    /**
     * This is milliseconds timestamp
     * @type {number}
     * @memberof SendDriversSalaryDto
     */
    'startTime': number;
    /**
     * This is milliseconds timestamp
     * @type {number}
     * @memberof SendDriversSalaryDto
     */
    'endTime': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendDriversSalaryDto
     */
    'driverIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SendMenuDto
 */
export interface SendMenuDto {
    /**
     * 
     * @type {string}
     * @memberof SendMenuDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof SendMenuDto
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof SendMenuDto
     */
    'type': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendMenuDto
     */
    'providerIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SuccessfulEmployee
 */
export interface SuccessfulEmployee {
    /**
     * 員工ID
     * @type {string}
     * @memberof SuccessfulEmployee
     */
    'id': string;
    /**
     * 員工姓名
     * @type {string}
     * @memberof SuccessfulEmployee
     */
    'name': string;
    /**
     * 執行動作
     * @type {string}
     * @memberof SuccessfulEmployee
     */
    'action': SuccessfulEmployeeActionEnum;
}

export const SuccessfulEmployeeActionEnum = {
    Created: 'created',
    Updated: 'updated'
} as const;

export type SuccessfulEmployeeActionEnum = typeof SuccessfulEmployeeActionEnum[keyof typeof SuccessfulEmployeeActionEnum];

/**
 * 
 * @export
 * @interface ToggleEmployeeStateDto
 */
export interface ToggleEmployeeStateDto {
    /**
     * 員工狀態
     * @type {string}
     * @memberof ToggleEmployeeStateDto
     */
    'state': ToggleEmployeeStateDtoStateEnum;
}

export const ToggleEmployeeStateDtoStateEnum = {
    Activated: 'ACTIVATED',
    Suspended: 'SUSPENDED'
} as const;

export type ToggleEmployeeStateDtoStateEnum = typeof ToggleEmployeeStateDtoStateEnum[keyof typeof ToggleEmployeeStateDtoStateEnum];

/**
 * 
 * @export
 * @interface ToggleScheduleDateIsWaitingForArrangeDto
 */
export interface ToggleScheduleDateIsWaitingForArrangeDto {
    /**
     * 排班日期
     * @type {string}
     * @memberof ToggleScheduleDateIsWaitingForArrangeDto
     */
    'time': string;
    /**
     * 位置ID
     * @type {string}
     * @memberof ToggleScheduleDateIsWaitingForArrangeDto
     */
    'locationId': string;
}
/**
 * 
 * @export
 * @interface TransferVendingProductsDto
 */
export interface TransferVendingProductsDto {
    /**
     * 
     * @type {string}
     * @memberof TransferVendingProductsDto
     */
    'targetAreaId': string;
}
/**
 * 
 * @export
 * @interface UpdateDeliveryMealRanksDto
 */
export interface UpdateDeliveryMealRanksDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryMealRanksDto
     */
    'locationTagId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeliveryMealRanksDto
     */
    'time': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDeliveryMealRanksDto
     */
    'deliveryMealIds': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateDeliveryMealStatusDto
 */
export interface UpdateDeliveryMealStatusDto {
    /**
     * 
     * @type {object}
     * @memberof UpdateDeliveryMealStatusDto
     */
    'status': object;
}
/**
 * 
 * @export
 * @interface UpdateDeliveryMealsRecycleBagsDto
 */
export interface UpdateDeliveryMealsRecycleBagsDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryMealsRecycleBagsDto
     */
    'time'?: string;
}
/**
 * 
 * @export
 * @interface UpdateDriverElement
 */
export interface UpdateDriverElement {
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverElement
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof UpdateDriverElement
     */
    'driverId': object;
}
/**
 * 
 * @export
 * @interface UpdateDriverInfoDto
 */
export interface UpdateDriverInfoDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'idNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'carNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'carModel'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'carColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'bankCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'bankAccount'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'bankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverInfoDto
     */
    'lineGroupId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateDriverLineIdDto
 */
export interface UpdateDriverLineIdDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverLineIdDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverLineIdDto
     */
    'lineId': string;
}
/**
 * 
 * @export
 * @interface UpdateDriversDto
 */
export interface UpdateDriversDto {
    /**
     * 
     * @type {Array<UpdateDriverElement>}
     * @memberof UpdateDriversDto
     */
    'deliveryMeals': Array<UpdateDriverElement>;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeDto
 */
export interface UpdateEmployeeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'nationalIdNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'idNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'onBoardingTime'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeRemittanceInfoDto
 */
export interface UpdateEmployeeRemittanceInfoDto {
    /**
     * 匯款資訊
     * @type {string}
     * @memberof UpdateEmployeeRemittanceInfoDto
     */
    'bankCode': string;
    /**
     * 匯款帳號
     * @type {string}
     * @memberof UpdateEmployeeRemittanceInfoDto
     */
    'bankAccount': string;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeResponseDto
 */
export interface UpdateEmployeeResponseDto {
    /**
     * 員工 ID
     * @type {string}
     * @memberof UpdateEmployeeResponseDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeSalaryAdjustmentDto
 */
export interface UpdateEmployeeSalaryAdjustmentDto {
    /**
     * 金額
     * @type {number}
     * @memberof UpdateEmployeeSalaryAdjustmentDto
     */
    'amount'?: number;
    /**
     * 薪資調整類型
     * @type {string}
     * @memberof UpdateEmployeeSalaryAdjustmentDto
     */
    'type'?: string;
    /**
     * 備註
     * @type {string}
     * @memberof UpdateEmployeeSalaryAdjustmentDto
     */
    'note'?: string;
    /**
     * 時間 (ISO format)
     * @type {string}
     * @memberof UpdateEmployeeSalaryAdjustmentDto
     */
    'time'?: string;
    /**
     * 狀態
     * @type {string}
     * @memberof UpdateEmployeeSalaryAdjustmentDto
     */
    'status'?: UpdateEmployeeSalaryAdjustmentDtoStatusEnum;
    /**
     * 狀態備註
     * @type {string}
     * @memberof UpdateEmployeeSalaryAdjustmentDto
     */
    'statusNote'?: string;
}

export const UpdateEmployeeSalaryAdjustmentDtoStatusEnum = {
    Pending: 'PENDING',
    Settled: 'SETTLED'
} as const;

export type UpdateEmployeeSalaryAdjustmentDtoStatusEnum = typeof UpdateEmployeeSalaryAdjustmentDtoStatusEnum[keyof typeof UpdateEmployeeSalaryAdjustmentDtoStatusEnum];

/**
 * 
 * @export
 * @interface UpdateIgnoredToppingsDto
 */
export interface UpdateIgnoredToppingsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateIgnoredToppingsDto
     */
    'toppings': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateLocationAssistantShiftScheduleSettingDto
 */
export interface UpdateLocationAssistantShiftScheduleSettingDto {
    /**
     * 設定值
     * @type {string}
     * @memberof UpdateLocationAssistantShiftScheduleSettingDto
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface UpdateLocationDto
 */
export interface UpdateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationDto
     */
    'idNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'comment'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationDto
     */
    'recycleBagsWeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'district'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'locationAssistantMeetingPoint'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationDto
     */
    'isLocationAssistantNeedToolsBag'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateLocationTagDto
 */
export interface UpdateLocationTagDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationTagDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationTagDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationTagDto
     */
    'pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationTagDto
     */
    'rank'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationTagDto
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationTagDto
     */
    'textColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationTagDto
     */
    'markColor'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLocationTagDto
     */
    'locationIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateMyProfileDto
 */
export interface UpdateMyProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileDto
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileDto
     */
    'nickname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileDto
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileDto
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyProfileDto
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateMyProfileDto
     */
    'transportationMethod': object;
}
/**
 * 
 * @export
 * @interface UpdateOrderDto
 */
export interface UpdateOrderDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'deliveryAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'clientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'clientTaxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'contactInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'deliveryDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderDto
     */
    'deliveryFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderDto
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'contactPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'customerSource'?: string;
    /**
     * 
     * @type {Array<CreateOrderItemDto>}
     * @memberof UpdateOrderDto
     */
    'items'?: Array<CreateOrderItemDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'status'?: UpdateOrderDtoStatusEnum;
}

export const UpdateOrderDtoStatusEnum = {
    Ongoing: 'ONGOING',
    Completed: 'COMPLETED'
} as const;

export type UpdateOrderDtoStatusEnum = typeof UpdateOrderDtoStatusEnum[keyof typeof UpdateOrderDtoStatusEnum];

/**
 * 
 * @export
 * @interface UpdateOrderItemDto
 */
export interface UpdateOrderItemDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderItemDto
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProductDto
 */
export interface UpdateProductDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDto
     */
    'idNumber': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductDto
     */
    'cost'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductDto
     */
    'isToppings': boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductDto
     */
    'salePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductDto
     */
    'inStorePrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDto
     */
    'state': UpdateProductDtoStateEnum;
}

export const UpdateProductDtoStateEnum = {
    Supplying: 'SUPPLYING',
    Discontinued: 'DISCONTINUED'
} as const;

export type UpdateProductDtoStateEnum = typeof UpdateProductDtoStateEnum[keyof typeof UpdateProductDtoStateEnum];

/**
 * 
 * @export
 * @interface UpdateProviderDto
 */
export interface UpdateProviderDto {
    /**
     * The name of the Provider
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'name'?: string;
    /**
     * The id number of the Provider
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'idNumber'?: string;
    /**
     * The line group id of the Provider
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'lineGroupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'addressComment'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'taxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'foodBusinessRegistrationNumber'?: string;
    /**
     * 
     * @type {EnterpriseOrderBusinessInfo}
     * @memberof UpdateProviderDto
     */
    'enterpriseOrderBusinessInfo'?: EnterpriseOrderBusinessInfo;
    /**
     * Provider status, can be ACTIVE or INACTIVE
     * @type {string}
     * @memberof UpdateProviderDto
     */
    'status'?: UpdateProviderDtoStatusEnum;
    /**
     * needPosSticker default false
     * @type {boolean}
     * @memberof UpdateProviderDto
     */
    'needPosSticker'?: boolean;
}

export const UpdateProviderDtoStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type UpdateProviderDtoStatusEnum = typeof UpdateProviderDtoStatusEnum[keyof typeof UpdateProviderDtoStatusEnum];

/**
 * 
 * @export
 * @interface UpdateProviderEventDto
 */
export interface UpdateProviderEventDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderEventDto
     */
    'providerId'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateProviderEventDto
     */
    'type'?: object;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderEventDto
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderEventDto
     */
    'time'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateProviderEventDto
     */
    'fine'?: number;
}
/**
 * 
 * @export
 * @interface UpdateProviderTagDto
 */
export interface UpdateProviderTagDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderTagDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProviderTagDto
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProviderTagDto
     */
    'providerIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateProviderTypeDto
 */
export interface UpdateProviderTypeDto {
    /**
     * The name of the provider type
     * @type {string}
     * @memberof UpdateProviderTypeDto
     */
    'name'?: string;
    /**
     * The color(hex) associated with the provider type
     * @type {string}
     * @memberof UpdateProviderTypeDto
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface UpdateReceivableDto
 */
export interface UpdateReceivableDto {
    /**
     * 供應商 ID
     * @type {string}
     * @memberof UpdateReceivableDto
     */
    'providerId'?: string;
    /**
     * 應收時間
     * @type {string}
     * @memberof UpdateReceivableDto
     */
    'dueTime'?: string;
    /**
     * 費用名稱
     * @type {string}
     * @memberof UpdateReceivableDto
     */
    'name'?: string;
    /**
     * 費用金額
     * @type {number}
     * @memberof UpdateReceivableDto
     */
    'amount'?: number;
    /**
     * 備註
     * @type {string}
     * @memberof UpdateReceivableDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface UpdateReceivablePlanDto
 */
export interface UpdateReceivablePlanDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateReceivablePlanDto
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface UpdateReportScheduleDto
 */
export interface UpdateReportScheduleDto {
    /**
     * 班表ID
     * @type {string}
     * @memberof UpdateReportScheduleDto
     */
    'scheduleId'?: string;
    /**
     * 備註
     * @type {string}
     * @memberof UpdateReportScheduleDto
     */
    'note'?: string;
    /**
     * 回報時間
     * @type {Array<string>}
     * @memberof UpdateReportScheduleDto
     */
    'dates'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateReportShiftStatusDto
 */
export interface UpdateReportShiftStatusDto {
    /**
     * The employee ID
     * @type {string}
     * @memberof UpdateReportShiftStatusDto
     */
    'employeeId': string;
    /**
     * The time of the shift
     * @type {string}
     * @memberof UpdateReportShiftStatusDto
     */
    'time': string;
    /**
     * The new status
     * @type {string}
     * @memberof UpdateReportShiftStatusDto
     */
    'status': UpdateReportShiftStatusDtoStatusEnum;
    /**
     * Optional note for the status change
     * @type {string}
     * @memberof UpdateReportShiftStatusDto
     */
    'note'?: string;
}

export const UpdateReportShiftStatusDtoStatusEnum = {
    Available: 'AVAILABLE',
    Unavailable: 'UNAVAILABLE'
} as const;

export type UpdateReportShiftStatusDtoStatusEnum = typeof UpdateReportShiftStatusDtoStatusEnum[keyof typeof UpdateReportShiftStatusDtoStatusEnum];

/**
 * 
 * @export
 * @interface UpdateScheduleDto
 */
export interface UpdateScheduleDto {
    /**
     * 備注
     * @type {string}
     * @memberof UpdateScheduleDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface UpdateScheduleShiftDto
 */
export interface UpdateScheduleShiftDto {
    /**
     * The time of the shift
     * @type {string}
     * @memberof UpdateScheduleShiftDto
     */
    'time': string;
    /**
     * The employee ID associated with the shift
     * @type {string}
     * @memberof UpdateScheduleShiftDto
     */
    'employeeId'?: string | null;
    /**
     * The location ID for the shift
     * @type {string}
     * @memberof UpdateScheduleShiftDto
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateStatementDto
 */
export interface UpdateStatementDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateStatementDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface UpdateStatementSettingsDto
 */
export interface UpdateStatementSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateStatementSettingsDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStatementSettingsDto
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStatementSettingsDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserDto
     */
    'roleIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'nationalIdNumber'?: string | null;
    /**
     * 
     * @type {Profile}
     * @memberof UpdateUserDto
     */
    'profile': Profile;
}
/**
 * 
 * @export
 * @interface UpdateVendingProductDto
 */
export interface UpdateVendingProductDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateVendingProductDto
     */
    'productCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendingProductDto
     */
    'productName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendingProductDto
     */
    'brandName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendingProductDto
     */
    'productType'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendingProductDto
     */
    'productInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendingProductDto
     */
    'productMemo'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateVendingProductDto
     */
    'index'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateVendingProductDto
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendingProductDto
     */
    'photo'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateVendingProductDto
     */
    'expireDate'?: object;
}
/**
 * 
 * @export
 * @interface UpsertDeliveryMealNoteDto
 */
export interface UpsertDeliveryMealNoteDto {
    /**
     * 
     * @type {number}
     * @memberof UpsertDeliveryMealNoteDto
     */
    'time': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertDeliveryMealNoteDto
     */
    'locationTagId': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertDeliveryMealNoteDto
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface UpsertDriverLeaveElement
 */
export interface UpsertDriverLeaveElement {
    /**
     * 
     * @type {number}
     * @memberof UpsertDriverLeaveElement
     */
    'time': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertDriverLeaveElement
     */
    'driverId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertDriverLeaveElement
     */
    'isLeave': boolean;
}
/**
 * 
 * @export
 * @interface UpsertDriverSalaryFileDto
 */
export interface UpsertDriverSalaryFileDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertDriverSalaryFileDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertDriverSalaryFileDto
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertDriverSalaryFileDto
     */
    'idNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertDriverSalaryFileDto
     */
    'fileId': string;
}
/**
 * 
 * @export
 * @interface UpsertDriversLeaveDto
 */
export interface UpsertDriversLeaveDto {
    /**
     * 
     * @type {Array<UpsertDriverLeaveElement>}
     * @memberof UpsertDriversLeaveDto
     */
    'driverLeave': Array<UpsertDriverLeaveElement>;
}
/**
 * 
 * @export
 * @interface UpsertProviderColorDto
 */
export interface UpsertProviderColorDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertProviderColorDto
     */
    'providerId': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertProviderColorDto
     */
    'color': string;
}
/**
 * 
 * @export
 * @interface UpsertVendingAreaElement
 */
export interface UpsertVendingAreaElement {
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingAreaElement
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingAreaElement
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingAreaElement
     */
    'companyId': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingAreaElement
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingAreaElement
     */
    'supplierId': string;
}
/**
 * 
 * @export
 * @interface UpsertVendingAreasDto
 */
export interface UpsertVendingAreasDto {
    /**
     * 
     * @type {Array<UpsertVendingAreaElement>}
     * @memberof UpsertVendingAreasDto
     */
    'areas': Array<UpsertVendingAreaElement>;
}
/**
 * 
 * @export
 * @interface UpsertVendingMachineElement
 */
export interface UpsertVendingMachineElement {
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingMachineElement
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingMachineElement
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingMachineElement
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingMachineElement
     */
    'mode': string;
}
/**
 * 
 * @export
 * @interface UpsertVendingMachinesDto
 */
export interface UpsertVendingMachinesDto {
    /**
     * 
     * @type {Array<UpsertVendingMachineElement>}
     * @memberof UpsertVendingMachinesDto
     */
    'machines': Array<UpsertVendingMachineElement>;
}
/**
 * 
 * @export
 * @interface UpsertVendingProductElement
 */
export interface UpsertVendingProductElement {
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingProductElement
     */
    'productCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingProductElement
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingProductElement
     */
    'brandName': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingProductElement
     */
    'productType': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingProductElement
     */
    'productInfo': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingProductElement
     */
    'productMemo': string;
    /**
     * 
     * @type {number}
     * @memberof UpsertVendingProductElement
     */
    'index': number;
    /**
     * 
     * @type {number}
     * @memberof UpsertVendingProductElement
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingProductElement
     */
    'photo': string;
    /**
     * 
     * @type {object}
     * @memberof UpsertVendingProductElement
     */
    'expireDate': object;
}
/**
 * 
 * @export
 * @interface UpsertVendingProductsDto
 */
export interface UpsertVendingProductsDto {
    /**
     * 
     * @type {Array<UpsertVendingProductElement>}
     * @memberof UpsertVendingProductsDto
     */
    'products': Array<UpsertVendingProductElement>;
}
/**
 * 
 * @export
 * @interface UpsertVendingRestockSettingElement
 */
export interface UpsertVendingRestockSettingElement {
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingRestockSettingElement
     */
    'layer': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertVendingRestockSettingElement
     */
    'productCode': string;
    /**
     * 
     * @type {number}
     * @memberof UpsertVendingRestockSettingElement
     */
    'max': number;
    /**
     * 
     * @type {number}
     * @memberof UpsertVendingRestockSettingElement
     */
    'min': number;
}
/**
 * 
 * @export
 * @interface UpsertVendingRestockSettingsDto
 */
export interface UpsertVendingRestockSettingsDto {
    /**
     * 
     * @type {Array<UpsertVendingRestockSettingElement>}
     * @memberof UpsertVendingRestockSettingsDto
     */
    'settings': Array<UpsertVendingRestockSettingElement>;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'username': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'nationalIdNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'state': string;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof UserDto
     */
    'roles': Array<RoleDto>;
    /**
     * 
     * @type {ProfileDto}
     * @memberof UserDto
     */
    'profile': ProfileDto | null;
    /**
     * 
     * @type {LocationAssistantInfoDto}
     * @memberof UserDto
     */
    'locationAssistantInfo': LocationAssistantInfoDto | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'phone': string | null;
}
/**
 * 
 * @export
 * @interface UserProfileDto
 */
export interface UserProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'username': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'nationalIdNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'state': string;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof UserProfileDto
     */
    'roles': Array<RoleDto>;
    /**
     * 
     * @type {ProfileDto}
     * @memberof UserProfileDto
     */
    'profile': ProfileDto | null;
    /**
     * 
     * @type {LocationAssistantInfoDto}
     * @memberof UserProfileDto
     */
    'locationAssistantInfo': LocationAssistantInfoDto | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'phone': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    'isCompleteProfile': boolean;
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGoogleCallback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/google/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGoogleVendingCallback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/google/vending-callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LineLoginDto} lineLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLineLogin: async (lineLoginDto: LineLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineLoginDto' is not null or undefined
            assertParamExists('authControllerLineLogin', 'lineLoginDto', lineLoginDto)
            const localVarPath = `/auth/line/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lineLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin: async (loginDto: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('authControllerLogin', 'loginDto', loginDto)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerGoogleCallback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerGoogleCallback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerGoogleCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerGoogleVendingCallback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerGoogleVendingCallback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerGoogleVendingCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LineLoginDto} lineLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLineLogin(lineLoginDto: LineLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLineLogin(lineLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerLineLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogin(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGoogleCallback(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authControllerGoogleCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGoogleVendingCallback(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authControllerGoogleVendingCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LineLoginDto} lineLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLineLogin(lineLoginDto: LineLoginDto, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.authControllerLineLogin(lineLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.authControllerLogin(loginDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerGoogleCallback(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerGoogleCallback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerGoogleVendingCallback(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerGoogleVendingCallback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LineLoginDto} lineLoginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLineLogin(lineLoginDto: LineLoginDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLineLogin(lineLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogin(loginDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineBotControllerDeleteDriverGroupJoinedLog: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lineBotControllerDeleteDriverGroupJoinedLog', 'id', id)
            const localVarPath = `/line_bot/driver_group_log/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineBotControllerGetDriverGroupJoinedLog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line_bot/driver_group_log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineBotControllerGetGroupJoinedLog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line_bot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerNames] 
         * @param {Array<string>} [times] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderItemRefundControllerFindAll: async (skip?: number, take?: number, providerNames?: Array<string>, times?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order_item_refunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (providerNames) {
                localVarQueryParameter['providerNames'] = providerNames;
            }

            if (times) {
                localVarQueryParameter['times'] = times;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProviderEventDto} createProviderEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerEventControllerCreateProviderEvent: async (createProviderEventDto: CreateProviderEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProviderEventDto' is not null or undefined
            assertParamExists('providerEventControllerCreateProviderEvent', 'createProviderEventDto', createProviderEventDto)
            const localVarPath = `/provider_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProviderEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerEventControllerDeleteProviderEvent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerEventControllerDeleteProviderEvent', 'id', id)
            const localVarPath = `/provider_events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerIds] 
         * @param {Array<string>} [times] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerEventControllerFindProviderEvents: async (skip?: number, take?: number, providerIds?: Array<string>, times?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (providerIds) {
                localVarQueryParameter['providerIds'] = providerIds;
            }

            if (times) {
                localVarQueryParameter['times'] = times;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderEventDto} updateProviderEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerEventControllerUpdateProviderEvent: async (id: string, updateProviderEventDto: UpdateProviderEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerEventControllerUpdateProviderEvent', 'id', id)
            // verify required parameter 'updateProviderEventDto' is not null or undefined
            assertParamExists('providerEventControllerUpdateProviderEvent', 'updateProviderEventDto', updateProviderEventDto)
            const localVarPath = `/provider_events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProviderTagDto} createProviderTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTagControllerCreateProviderTag: async (createProviderTagDto: CreateProviderTagDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProviderTagDto' is not null or undefined
            assertParamExists('providerTagControllerCreateProviderTag', 'createProviderTagDto', createProviderTagDto)
            const localVarPath = `/provider_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProviderTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTagControllerDeleteProviderTag: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerTagControllerDeleteProviderTag', 'id', id)
            const localVarPath = `/provider_tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTagControllerGetProviderTag: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderTagDto} updateProviderTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTagControllerUpdateProviderTag: async (id: string, updateProviderTagDto: UpdateProviderTagDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerTagControllerUpdateProviderTag', 'id', id)
            // verify required parameter 'updateProviderTagDto' is not null or undefined
            assertParamExists('providerTagControllerUpdateProviderTag', 'updateProviderTagDto', updateProviderTagDto)
            const localVarPath = `/provider_tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineBotControllerDeleteDriverGroupJoinedLog(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineBotControllerDeleteDriverGroupJoinedLog(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.lineBotControllerDeleteDriverGroupJoinedLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineBotControllerGetDriverGroupJoinedLog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineBotControllerGetDriverGroupJoinedLog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.lineBotControllerGetDriverGroupJoinedLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineBotControllerGetGroupJoinedLog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineBotControllerGetGroupJoinedLog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.lineBotControllerGetGroupJoinedLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerNames] 
         * @param {Array<string>} [times] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderItemRefundControllerFindAll(skip?: number, take?: number, providerNames?: Array<string>, times?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderItemRefundControllerFindAll(skip, take, providerNames, times, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.orderItemRefundControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateProviderEventDto} createProviderEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerEventControllerCreateProviderEvent(createProviderEventDto: CreateProviderEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerEventControllerCreateProviderEvent(createProviderEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.providerEventControllerCreateProviderEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerEventControllerDeleteProviderEvent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerEventControllerDeleteProviderEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.providerEventControllerDeleteProviderEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerIds] 
         * @param {Array<string>} [times] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerEventControllerFindProviderEvents(skip?: number, take?: number, providerIds?: Array<string>, times?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerEventControllerFindProviderEvents(skip, take, providerIds, times, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.providerEventControllerFindProviderEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderEventDto} updateProviderEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerEventControllerUpdateProviderEvent(id: string, updateProviderEventDto: UpdateProviderEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerEventControllerUpdateProviderEvent(id, updateProviderEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.providerEventControllerUpdateProviderEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateProviderTagDto} createProviderTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerTagControllerCreateProviderTag(createProviderTagDto: CreateProviderTagDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerTagControllerCreateProviderTag(createProviderTagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.providerTagControllerCreateProviderTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerTagControllerDeleteProviderTag(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerTagControllerDeleteProviderTag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.providerTagControllerDeleteProviderTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerTagControllerGetProviderTag(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerTagControllerGetProviderTag(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.providerTagControllerGetProviderTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderTagDto} updateProviderTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerTagControllerUpdateProviderTag(id: string, updateProviderTagDto: UpdateProviderTagDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerTagControllerUpdateProviderTag(id, updateProviderTagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.providerTagControllerUpdateProviderTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineBotControllerDeleteDriverGroupJoinedLog(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.lineBotControllerDeleteDriverGroupJoinedLog(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineBotControllerGetDriverGroupJoinedLog(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.lineBotControllerGetDriverGroupJoinedLog(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineBotControllerGetGroupJoinedLog(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.lineBotControllerGetGroupJoinedLog(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerNames] 
         * @param {Array<string>} [times] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderItemRefundControllerFindAll(skip?: number, take?: number, providerNames?: Array<string>, times?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderItemRefundControllerFindAll(skip, take, providerNames, times, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateProviderEventDto} createProviderEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerEventControllerCreateProviderEvent(createProviderEventDto: CreateProviderEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerEventControllerCreateProviderEvent(createProviderEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerEventControllerDeleteProviderEvent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerEventControllerDeleteProviderEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerIds] 
         * @param {Array<string>} [times] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerEventControllerFindProviderEvents(skip?: number, take?: number, providerIds?: Array<string>, times?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerEventControllerFindProviderEvents(skip, take, providerIds, times, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderEventDto} updateProviderEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerEventControllerUpdateProviderEvent(id: string, updateProviderEventDto: UpdateProviderEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerEventControllerUpdateProviderEvent(id, updateProviderEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateProviderTagDto} createProviderTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTagControllerCreateProviderTag(createProviderTagDto: CreateProviderTagDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerTagControllerCreateProviderTag(createProviderTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTagControllerDeleteProviderTag(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerTagControllerDeleteProviderTag(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTagControllerGetProviderTag(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerTagControllerGetProviderTag(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderTagDto} updateProviderTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTagControllerUpdateProviderTag(id: string, updateProviderTagDto: UpdateProviderTagDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerTagControllerUpdateProviderTag(id, updateProviderTagDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public lineBotControllerDeleteDriverGroupJoinedLog(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).lineBotControllerDeleteDriverGroupJoinedLog(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public lineBotControllerGetDriverGroupJoinedLog(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).lineBotControllerGetDriverGroupJoinedLog(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public lineBotControllerGetGroupJoinedLog(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).lineBotControllerGetGroupJoinedLog(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {Array<string>} [providerNames] 
     * @param {Array<string>} [times] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public orderItemRefundControllerFindAll(skip?: number, take?: number, providerNames?: Array<string>, times?: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).orderItemRefundControllerFindAll(skip, take, providerNames, times, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateProviderEventDto} createProviderEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public providerEventControllerCreateProviderEvent(createProviderEventDto: CreateProviderEventDto, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).providerEventControllerCreateProviderEvent(createProviderEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public providerEventControllerDeleteProviderEvent(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).providerEventControllerDeleteProviderEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {Array<string>} [providerIds] 
     * @param {Array<string>} [times] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public providerEventControllerFindProviderEvents(skip?: number, take?: number, providerIds?: Array<string>, times?: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).providerEventControllerFindProviderEvents(skip, take, providerIds, times, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateProviderEventDto} updateProviderEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public providerEventControllerUpdateProviderEvent(id: string, updateProviderEventDto: UpdateProviderEventDto, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).providerEventControllerUpdateProviderEvent(id, updateProviderEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateProviderTagDto} createProviderTagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public providerTagControllerCreateProviderTag(createProviderTagDto: CreateProviderTagDto, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).providerTagControllerCreateProviderTag(createProviderTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public providerTagControllerDeleteProviderTag(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).providerTagControllerDeleteProviderTag(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public providerTagControllerGetProviderTag(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).providerTagControllerGetProviderTag(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateProviderTagDto} updateProviderTagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public providerTagControllerUpdateProviderTag(id: string, updateProviderTagDto: UpdateProviderTagDto, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).providerTagControllerUpdateProviderTag(id, updateProviderTagDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeliveryMealsApi - axios parameter creator
 * @export
 */
export const DeliveryMealsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDeliveryMealsDto} createDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerCreateDeliveryMeals: async (createDeliveryMealsDto: CreateDeliveryMealsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDeliveryMealsDto' is not null or undefined
            assertParamExists('deliveryMealsControllerCreateDeliveryMeals', 'createDeliveryMealsDto', createDeliveryMealsDto)
            const localVarPath = `/delivery_meals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDeliveryMealsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteDeliveryMealsDto} deleteDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerDeleteDeliveryMeal: async (deleteDeliveryMealsDto: DeleteDeliveryMealsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteDeliveryMealsDto' is not null or undefined
            assertParamExists('deliveryMealsControllerDeleteDeliveryMeal', 'deleteDeliveryMealsDto', deleteDeliveryMealsDto)
            const localVarPath = `/delivery_meals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDeliveryMealsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportDeliveryMealsDto} exportDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerExportDeliveryMeals: async (exportDeliveryMealsDto: ExportDeliveryMealsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportDeliveryMealsDto' is not null or undefined
            assertParamExists('deliveryMealsControllerExportDeliveryMeals', 'exportDeliveryMealsDto', exportDeliveryMealsDto)
            const localVarPath = `/delivery_meals/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportDeliveryMealsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportDeliveryMealsDto} exportDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerExportDeliveryMealsPerDate: async (exportDeliveryMealsDto: ExportDeliveryMealsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportDeliveryMealsDto' is not null or undefined
            assertParamExists('deliveryMealsControllerExportDeliveryMealsPerDate', 'exportDeliveryMealsDto', exportDeliveryMealsDto)
            const localVarPath = `/delivery_meals/export-per-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportDeliveryMealsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} [locationTagId] 
         * @param {string} [providerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerFindDeliveryMeals: async (startTime: number, endTime: number, locationTagId?: string, providerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('deliveryMealsControllerFindDeliveryMeals', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('deliveryMealsControllerFindDeliveryMeals', 'endTime', endTime)
            const localVarPath = `/delivery_meals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (locationTagId !== undefined) {
                localVarQueryParameter['locationTagId'] = locationTagId;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} [locationTagId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerFindDeliveryMealsNotes: async (startTime: number, endTime: number, locationTagId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('deliveryMealsControllerFindDeliveryMealsNotes', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('deliveryMealsControllerFindDeliveryMealsNotes', 'endTime', endTime)
            const localVarPath = `/delivery_meals/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (locationTagId !== undefined) {
                localVarQueryParameter['locationTagId'] = locationTagId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerFindDeliveryMealsProducts: async (startTime: number, endTime: number, locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('deliveryMealsControllerFindDeliveryMealsProducts', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('deliveryMealsControllerFindDeliveryMealsProducts', 'endTime', endTime)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deliveryMealsControllerFindDeliveryMealsProducts', 'locationId', locationId)
            const localVarPath = `/delivery_meals/supplying-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateAllProviderDriveDataDto} generateAllProviderDriveDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerGenerateAllProviderData: async (generateAllProviderDriveDataDto: GenerateAllProviderDriveDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAllProviderDriveDataDto' is not null or undefined
            assertParamExists('deliveryMealsControllerGenerateAllProviderData', 'generateAllProviderDriveDataDto', generateAllProviderDriveDataDto)
            const localVarPath = `/delivery_meals/generate-all-provider-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAllProviderDriveDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerGetExcelFile: async (startTime: number, endTime: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('deliveryMealsControllerGetExcelFile', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('deliveryMealsControllerGetExcelFile', 'endTime', endTime)
            const localVarPath = `/delivery_meals/excel-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerListProviderColors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/delivery_meals/provider_color/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerListProviders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/delivery_meals/providers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendDeliveriesToLineDto} sendDeliveriesToLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerSendDeliveriesToLine: async (sendDeliveriesToLineDto: SendDeliveriesToLineDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendDeliveriesToLineDto' is not null or undefined
            assertParamExists('deliveryMealsControllerSendDeliveriesToLine', 'sendDeliveriesToLineDto', sendDeliveriesToLineDto)
            const localVarPath = `/delivery_meals/send-deliveries-to-line`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendDeliveriesToLineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerSendDeliveryStatusToSlack: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/delivery_meals/send-status-to-slack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime 
         * @param {number} [durationLimit] 
         * @param {number} [suggsetionsCount] 
         * @param {number} [groupSize] value must be an even number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerSuggestDeliveryProviders: async (startTime: number, durationLimit?: number, suggsetionsCount?: number, groupSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('deliveryMealsControllerSuggestDeliveryProviders', 'startTime', startTime)
            const localVarPath = `/delivery_meals/suggest-delivery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (durationLimit !== undefined) {
                localVarQueryParameter['durationLimit'] = durationLimit;
            }

            if (suggsetionsCount !== undefined) {
                localVarQueryParameter['suggsetionsCount'] = suggsetionsCount;
            }

            if (groupSize !== undefined) {
                localVarQueryParameter['groupSize'] = groupSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} idNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateDeliverySendStatus: async (idNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idNumber' is not null or undefined
            assertParamExists('deliveryMealsControllerUpdateDeliverySendStatus', 'idNumber', idNumber)
            const localVarPath = `/delivery_meals/update-send-status/{idNumber}`
                .replace(`{${"idNumber"}}`, encodeURIComponent(String(idNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDriversDto} updateDriversDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateDrivers: async (updateDriversDto: UpdateDriversDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDriversDto' is not null or undefined
            assertParamExists('deliveryMealsControllerUpdateDrivers', 'updateDriversDto', updateDriversDto)
            const localVarPath = `/delivery_meals/update_drivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDriversDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDeliveryMealRanksDto} updateDeliveryMealRanksDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateRanks: async (updateDeliveryMealRanksDto: UpdateDeliveryMealRanksDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDeliveryMealRanksDto' is not null or undefined
            assertParamExists('deliveryMealsControllerUpdateRanks', 'updateDeliveryMealRanksDto', updateDeliveryMealRanksDto)
            const localVarPath = `/delivery_meals/update_ranks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryMealRanksDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDeliveryMealsRecycleBagsDto} updateDeliveryMealsRecycleBagsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateRecycleBags: async (updateDeliveryMealsRecycleBagsDto: UpdateDeliveryMealsRecycleBagsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDeliveryMealsRecycleBagsDto' is not null or undefined
            assertParamExists('deliveryMealsControllerUpdateRecycleBags', 'updateDeliveryMealsRecycleBagsDto', updateDeliveryMealsRecycleBagsDto)
            const localVarPath = `/delivery_meals/update_recycle_bags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryMealsRecycleBagsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDeliveryMealStatusDto} updateDeliveryMealStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateStatus: async (id: string, updateDeliveryMealStatusDto: UpdateDeliveryMealStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deliveryMealsControllerUpdateStatus', 'id', id)
            // verify required parameter 'updateDeliveryMealStatusDto' is not null or undefined
            assertParamExists('deliveryMealsControllerUpdateStatus', 'updateDeliveryMealStatusDto', updateDeliveryMealStatusDto)
            const localVarPath = `/delivery_meals/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryMealStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertDeliveryMealNoteDto} upsertDeliveryMealNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpsertDeliveryMealNote: async (upsertDeliveryMealNoteDto: UpsertDeliveryMealNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertDeliveryMealNoteDto' is not null or undefined
            assertParamExists('deliveryMealsControllerUpsertDeliveryMealNote', 'upsertDeliveryMealNoteDto', upsertDeliveryMealNoteDto)
            const localVarPath = `/delivery_meals/note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDeliveryMealNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertProviderColorDto} upsertProviderColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpsertProvidersColor: async (upsertProviderColorDto: UpsertProviderColorDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertProviderColorDto' is not null or undefined
            assertParamExists('deliveryMealsControllerUpsertProvidersColor', 'upsertProviderColorDto', upsertProviderColorDto)
            const localVarPath = `/delivery_meals/provider_color`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertProviderColorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveryMealsApi - functional programming interface
 * @export
 */
export const DeliveryMealsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveryMealsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDeliveryMealsDto} createDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerCreateDeliveryMeals(createDeliveryMealsDto: CreateDeliveryMealsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerCreateDeliveryMeals(createDeliveryMealsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerCreateDeliveryMeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteDeliveryMealsDto} deleteDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerDeleteDeliveryMeal(deleteDeliveryMealsDto: DeleteDeliveryMealsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerDeleteDeliveryMeal(deleteDeliveryMealsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerDeleteDeliveryMeal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportDeliveryMealsDto} exportDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerExportDeliveryMeals(exportDeliveryMealsDto: ExportDeliveryMealsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerExportDeliveryMeals(exportDeliveryMealsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerExportDeliveryMeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportDeliveryMealsDto} exportDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerExportDeliveryMealsPerDate(exportDeliveryMealsDto: ExportDeliveryMealsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerExportDeliveryMealsPerDate(exportDeliveryMealsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerExportDeliveryMealsPerDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} [locationTagId] 
         * @param {string} [providerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerFindDeliveryMeals(startTime: number, endTime: number, locationTagId?: string, providerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerFindDeliveryMeals(startTime, endTime, locationTagId, providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerFindDeliveryMeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} [locationTagId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerFindDeliveryMealsNotes(startTime: number, endTime: number, locationTagId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerFindDeliveryMealsNotes(startTime, endTime, locationTagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerFindDeliveryMealsNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerFindDeliveryMealsProducts(startTime: number, endTime: number, locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerFindDeliveryMealsProducts(startTime, endTime, locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerFindDeliveryMealsProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateAllProviderDriveDataDto} generateAllProviderDriveDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerGenerateAllProviderData(generateAllProviderDriveDataDto: GenerateAllProviderDriveDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerGenerateAllProviderData(generateAllProviderDriveDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerGenerateAllProviderData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerGetExcelFile(startTime: number, endTime: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerGetExcelFile(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerGetExcelFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerListProviderColors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerListProviderColors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerListProviderColors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerListProviders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListProvidersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerListProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerListProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendDeliveriesToLineDto} sendDeliveriesToLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerSendDeliveriesToLine(sendDeliveriesToLineDto: SendDeliveriesToLineDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerSendDeliveriesToLine(sendDeliveriesToLineDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerSendDeliveriesToLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerSendDeliveryStatusToSlack(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerSendDeliveryStatusToSlack(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerSendDeliveryStatusToSlack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime 
         * @param {number} [durationLimit] 
         * @param {number} [suggsetionsCount] 
         * @param {number} [groupSize] value must be an even number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerSuggestDeliveryProviders(startTime: number, durationLimit?: number, suggsetionsCount?: number, groupSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerSuggestDeliveryProviders(startTime, durationLimit, suggsetionsCount, groupSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerSuggestDeliveryProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} idNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerUpdateDeliverySendStatus(idNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerUpdateDeliverySendStatus(idNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerUpdateDeliverySendStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDriversDto} updateDriversDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerUpdateDrivers(updateDriversDto: UpdateDriversDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerUpdateDrivers(updateDriversDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerUpdateDrivers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDeliveryMealRanksDto} updateDeliveryMealRanksDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerUpdateRanks(updateDeliveryMealRanksDto: UpdateDeliveryMealRanksDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerUpdateRanks(updateDeliveryMealRanksDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerUpdateRanks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDeliveryMealsRecycleBagsDto} updateDeliveryMealsRecycleBagsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerUpdateRecycleBags(updateDeliveryMealsRecycleBagsDto: UpdateDeliveryMealsRecycleBagsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerUpdateRecycleBags(updateDeliveryMealsRecycleBagsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerUpdateRecycleBags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDeliveryMealStatusDto} updateDeliveryMealStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerUpdateStatus(id: string, updateDeliveryMealStatusDto: UpdateDeliveryMealStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerUpdateStatus(id, updateDeliveryMealStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerUpdateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertDeliveryMealNoteDto} upsertDeliveryMealNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerUpsertDeliveryMealNote(upsertDeliveryMealNoteDto: UpsertDeliveryMealNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerUpsertDeliveryMealNote(upsertDeliveryMealNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerUpsertDeliveryMealNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertProviderColorDto} upsertProviderColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryMealsControllerUpsertProvidersColor(upsertProviderColorDto: UpsertProviderColorDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryMealsControllerUpsertProvidersColor(upsertProviderColorDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeliveryMealsApi.deliveryMealsControllerUpsertProvidersColor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeliveryMealsApi - factory interface
 * @export
 */
export const DeliveryMealsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveryMealsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateDeliveryMealsDto} createDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerCreateDeliveryMeals(createDeliveryMealsDto: CreateDeliveryMealsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerCreateDeliveryMeals(createDeliveryMealsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteDeliveryMealsDto} deleteDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerDeleteDeliveryMeal(deleteDeliveryMealsDto: DeleteDeliveryMealsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerDeleteDeliveryMeal(deleteDeliveryMealsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportDeliveryMealsDto} exportDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerExportDeliveryMeals(exportDeliveryMealsDto: ExportDeliveryMealsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerExportDeliveryMeals(exportDeliveryMealsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportDeliveryMealsDto} exportDeliveryMealsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerExportDeliveryMealsPerDate(exportDeliveryMealsDto: ExportDeliveryMealsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerExportDeliveryMealsPerDate(exportDeliveryMealsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} [locationTagId] 
         * @param {string} [providerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerFindDeliveryMeals(startTime: number, endTime: number, locationTagId?: string, providerId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerFindDeliveryMeals(startTime, endTime, locationTagId, providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} [locationTagId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerFindDeliveryMealsNotes(startTime: number, endTime: number, locationTagId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerFindDeliveryMealsNotes(startTime, endTime, locationTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerFindDeliveryMealsProducts(startTime: number, endTime: number, locationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerFindDeliveryMealsProducts(startTime, endTime, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenerateAllProviderDriveDataDto} generateAllProviderDriveDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerGenerateAllProviderData(generateAllProviderDriveDataDto: GenerateAllProviderDriveDataDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerGenerateAllProviderData(generateAllProviderDriveDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerGetExcelFile(startTime: number, endTime: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerGetExcelFile(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerListProviderColors(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerListProviderColors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerListProviders(options?: RawAxiosRequestConfig): AxiosPromise<ListProvidersResponseDto> {
            return localVarFp.deliveryMealsControllerListProviders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendDeliveriesToLineDto} sendDeliveriesToLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerSendDeliveriesToLine(sendDeliveriesToLineDto: SendDeliveriesToLineDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerSendDeliveriesToLine(sendDeliveriesToLineDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerSendDeliveryStatusToSlack(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerSendDeliveryStatusToSlack(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime 
         * @param {number} [durationLimit] 
         * @param {number} [suggsetionsCount] 
         * @param {number} [groupSize] value must be an even number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerSuggestDeliveryProviders(startTime: number, durationLimit?: number, suggsetionsCount?: number, groupSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerSuggestDeliveryProviders(startTime, durationLimit, suggsetionsCount, groupSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} idNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateDeliverySendStatus(idNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerUpdateDeliverySendStatus(idNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDriversDto} updateDriversDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateDrivers(updateDriversDto: UpdateDriversDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerUpdateDrivers(updateDriversDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDeliveryMealRanksDto} updateDeliveryMealRanksDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateRanks(updateDeliveryMealRanksDto: UpdateDeliveryMealRanksDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerUpdateRanks(updateDeliveryMealRanksDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDeliveryMealsRecycleBagsDto} updateDeliveryMealsRecycleBagsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateRecycleBags(updateDeliveryMealsRecycleBagsDto: UpdateDeliveryMealsRecycleBagsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerUpdateRecycleBags(updateDeliveryMealsRecycleBagsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDeliveryMealStatusDto} updateDeliveryMealStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpdateStatus(id: string, updateDeliveryMealStatusDto: UpdateDeliveryMealStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerUpdateStatus(id, updateDeliveryMealStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertDeliveryMealNoteDto} upsertDeliveryMealNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpsertDeliveryMealNote(upsertDeliveryMealNoteDto: UpsertDeliveryMealNoteDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerUpsertDeliveryMealNote(upsertDeliveryMealNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertProviderColorDto} upsertProviderColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryMealsControllerUpsertProvidersColor(upsertProviderColorDto: UpsertProviderColorDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deliveryMealsControllerUpsertProvidersColor(upsertProviderColorDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeliveryMealsApi - object-oriented interface
 * @export
 * @class DeliveryMealsApi
 * @extends {BaseAPI}
 */
export class DeliveryMealsApi extends BaseAPI {
    /**
     * 
     * @param {CreateDeliveryMealsDto} createDeliveryMealsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerCreateDeliveryMeals(createDeliveryMealsDto: CreateDeliveryMealsDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerCreateDeliveryMeals(createDeliveryMealsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteDeliveryMealsDto} deleteDeliveryMealsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerDeleteDeliveryMeal(deleteDeliveryMealsDto: DeleteDeliveryMealsDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerDeleteDeliveryMeal(deleteDeliveryMealsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportDeliveryMealsDto} exportDeliveryMealsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerExportDeliveryMeals(exportDeliveryMealsDto: ExportDeliveryMealsDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerExportDeliveryMeals(exportDeliveryMealsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportDeliveryMealsDto} exportDeliveryMealsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerExportDeliveryMealsPerDate(exportDeliveryMealsDto: ExportDeliveryMealsDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerExportDeliveryMealsPerDate(exportDeliveryMealsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime This is milliseconds timestamp
     * @param {number} endTime This is milliseconds timestamp
     * @param {string} [locationTagId] 
     * @param {string} [providerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerFindDeliveryMeals(startTime: number, endTime: number, locationTagId?: string, providerId?: string, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerFindDeliveryMeals(startTime, endTime, locationTagId, providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime This is milliseconds timestamp
     * @param {number} endTime This is milliseconds timestamp
     * @param {string} [locationTagId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerFindDeliveryMealsNotes(startTime: number, endTime: number, locationTagId?: string, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerFindDeliveryMealsNotes(startTime, endTime, locationTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime This is milliseconds timestamp
     * @param {number} endTime This is milliseconds timestamp
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerFindDeliveryMealsProducts(startTime: number, endTime: number, locationId: string, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerFindDeliveryMealsProducts(startTime, endTime, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenerateAllProviderDriveDataDto} generateAllProviderDriveDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerGenerateAllProviderData(generateAllProviderDriveDataDto: GenerateAllProviderDriveDataDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerGenerateAllProviderData(generateAllProviderDriveDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime This is milliseconds timestamp
     * @param {number} endTime This is milliseconds timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerGetExcelFile(startTime: number, endTime: number, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerGetExcelFile(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerListProviderColors(options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerListProviderColors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerListProviders(options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerListProviders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendDeliveriesToLineDto} sendDeliveriesToLineDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerSendDeliveriesToLine(sendDeliveriesToLineDto: SendDeliveriesToLineDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerSendDeliveriesToLine(sendDeliveriesToLineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerSendDeliveryStatusToSlack(options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerSendDeliveryStatusToSlack(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime 
     * @param {number} [durationLimit] 
     * @param {number} [suggsetionsCount] 
     * @param {number} [groupSize] value must be an even number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerSuggestDeliveryProviders(startTime: number, durationLimit?: number, suggsetionsCount?: number, groupSize?: number, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerSuggestDeliveryProviders(startTime, durationLimit, suggsetionsCount, groupSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} idNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerUpdateDeliverySendStatus(idNumber: string, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerUpdateDeliverySendStatus(idNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDriversDto} updateDriversDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerUpdateDrivers(updateDriversDto: UpdateDriversDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerUpdateDrivers(updateDriversDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDeliveryMealRanksDto} updateDeliveryMealRanksDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerUpdateRanks(updateDeliveryMealRanksDto: UpdateDeliveryMealRanksDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerUpdateRanks(updateDeliveryMealRanksDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDeliveryMealsRecycleBagsDto} updateDeliveryMealsRecycleBagsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerUpdateRecycleBags(updateDeliveryMealsRecycleBagsDto: UpdateDeliveryMealsRecycleBagsDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerUpdateRecycleBags(updateDeliveryMealsRecycleBagsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDeliveryMealStatusDto} updateDeliveryMealStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerUpdateStatus(id: string, updateDeliveryMealStatusDto: UpdateDeliveryMealStatusDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerUpdateStatus(id, updateDeliveryMealStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertDeliveryMealNoteDto} upsertDeliveryMealNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerUpsertDeliveryMealNote(upsertDeliveryMealNoteDto: UpsertDeliveryMealNoteDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerUpsertDeliveryMealNote(upsertDeliveryMealNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertProviderColorDto} upsertProviderColorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryMealsApi
     */
    public deliveryMealsControllerUpsertProvidersColor(upsertProviderColorDto: UpsertProviderColorDto, options?: RawAxiosRequestConfig) {
        return DeliveryMealsApiFp(this.configuration).deliveryMealsControllerUpsertProvidersColor(upsertProviderColorDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepartmentEmployeeApi - axios parameter creator
 * @export
 */
export const DepartmentEmployeeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {number} amount Amount of compensation
         * @param {DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum} compensationType Type of compensation
         * @param {number} defaultHours Default hours for the compensation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentEmployeeControllerAddDepartmentEmployee: async (departmentId: string, employeeId: string, amount: number, compensationType: DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum, defaultHours: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('departmentEmployeeControllerAddDepartmentEmployee', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('departmentEmployeeControllerAddDepartmentEmployee', 'employeeId', employeeId)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('departmentEmployeeControllerAddDepartmentEmployee', 'amount', amount)
            // verify required parameter 'compensationType' is not null or undefined
            assertParamExists('departmentEmployeeControllerAddDepartmentEmployee', 'compensationType', compensationType)
            // verify required parameter 'defaultHours' is not null or undefined
            assertParamExists('departmentEmployeeControllerAddDepartmentEmployee', 'defaultHours', defaultHours)
            const localVarPath = `/departments/{departmentId}/employees/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (compensationType !== undefined) {
                localVarQueryParameter['compensationType'] = compensationType;
            }

            if (defaultHours !== undefined) {
                localVarQueryParameter['defaultHours'] = defaultHours;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentEmployeeControllerDeleteDepartmentEmployee: async (departmentId: string, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('departmentEmployeeControllerDeleteDepartmentEmployee', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('departmentEmployeeControllerDeleteDepartmentEmployee', 'employeeId', employeeId)
            const localVarPath = `/departments/{departmentId}/employees/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {number} skip 
         * @param {number} take 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentEmployeeControllerFindDepartmentEmployees: async (departmentId: string, skip: number, take: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('departmentEmployeeControllerFindDepartmentEmployees', 'departmentId', departmentId)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('departmentEmployeeControllerFindDepartmentEmployees', 'skip', skip)
            // verify required parameter 'take' is not null or undefined
            assertParamExists('departmentEmployeeControllerFindDepartmentEmployees', 'take', take)
            const localVarPath = `/departments/{departmentId}/employees`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {number} [amount] Amount of compensation
         * @param {DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum} [compensationType] Type of compensation
         * @param {number} [defaultHours] Default hours for the compensation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentEmployeeControllerUpdateDepartmentEmployee: async (departmentId: string, employeeId: string, amount?: number, compensationType?: DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum, defaultHours?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('departmentEmployeeControllerUpdateDepartmentEmployee', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('departmentEmployeeControllerUpdateDepartmentEmployee', 'employeeId', employeeId)
            const localVarPath = `/departments/{departmentId}/employees/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (compensationType !== undefined) {
                localVarQueryParameter['compensationType'] = compensationType;
            }

            if (defaultHours !== undefined) {
                localVarQueryParameter['defaultHours'] = defaultHours;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentEmployeeApi - functional programming interface
 * @export
 */
export const DepartmentEmployeeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentEmployeeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {number} amount Amount of compensation
         * @param {DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum} compensationType Type of compensation
         * @param {number} defaultHours Default hours for the compensation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentEmployeeControllerAddDepartmentEmployee(departmentId: string, employeeId: string, amount: number, compensationType: DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum, defaultHours: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentEmployeeControllerAddDepartmentEmployee(departmentId, employeeId, amount, compensationType, defaultHours, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentEmployeeApi.departmentEmployeeControllerAddDepartmentEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentEmployeeControllerDeleteDepartmentEmployee(departmentId: string, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentEmployeeControllerDeleteDepartmentEmployee(departmentId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentEmployeeApi.departmentEmployeeControllerDeleteDepartmentEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {number} skip 
         * @param {number} take 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentEmployeeControllerFindDepartmentEmployees(departmentId: string, skip: number, take: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindDepartmentEmployeesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentEmployeeControllerFindDepartmentEmployees(departmentId, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentEmployeeApi.departmentEmployeeControllerFindDepartmentEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {number} [amount] Amount of compensation
         * @param {DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum} [compensationType] Type of compensation
         * @param {number} [defaultHours] Default hours for the compensation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentEmployeeControllerUpdateDepartmentEmployee(departmentId: string, employeeId: string, amount?: number, compensationType?: DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum, defaultHours?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentEmployeeControllerUpdateDepartmentEmployee(departmentId, employeeId, amount, compensationType, defaultHours, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentEmployeeApi.departmentEmployeeControllerUpdateDepartmentEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepartmentEmployeeApi - factory interface
 * @export
 */
export const DepartmentEmployeeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentEmployeeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {number} amount Amount of compensation
         * @param {DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum} compensationType Type of compensation
         * @param {number} defaultHours Default hours for the compensation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentEmployeeControllerAddDepartmentEmployee(departmentId: string, employeeId: string, amount: number, compensationType: DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum, defaultHours: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.departmentEmployeeControllerAddDepartmentEmployee(departmentId, employeeId, amount, compensationType, defaultHours, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentEmployeeControllerDeleteDepartmentEmployee(departmentId: string, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.departmentEmployeeControllerDeleteDepartmentEmployee(departmentId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {number} skip 
         * @param {number} take 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentEmployeeControllerFindDepartmentEmployees(departmentId: string, skip: number, take: number, options?: RawAxiosRequestConfig): AxiosPromise<FindDepartmentEmployeesResult> {
            return localVarFp.departmentEmployeeControllerFindDepartmentEmployees(departmentId, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} employeeId 
         * @param {number} [amount] Amount of compensation
         * @param {DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum} [compensationType] Type of compensation
         * @param {number} [defaultHours] Default hours for the compensation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentEmployeeControllerUpdateDepartmentEmployee(departmentId: string, employeeId: string, amount?: number, compensationType?: DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum, defaultHours?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.departmentEmployeeControllerUpdateDepartmentEmployee(departmentId, employeeId, amount, compensationType, defaultHours, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentEmployeeApi - object-oriented interface
 * @export
 * @class DepartmentEmployeeApi
 * @extends {BaseAPI}
 */
export class DepartmentEmployeeApi extends BaseAPI {
    /**
     * 
     * @param {string} departmentId 
     * @param {string} employeeId 
     * @param {number} amount Amount of compensation
     * @param {DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum} compensationType Type of compensation
     * @param {number} defaultHours Default hours for the compensation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentEmployeeApi
     */
    public departmentEmployeeControllerAddDepartmentEmployee(departmentId: string, employeeId: string, amount: number, compensationType: DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum, defaultHours: number, options?: RawAxiosRequestConfig) {
        return DepartmentEmployeeApiFp(this.configuration).departmentEmployeeControllerAddDepartmentEmployee(departmentId, employeeId, amount, compensationType, defaultHours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} departmentId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentEmployeeApi
     */
    public departmentEmployeeControllerDeleteDepartmentEmployee(departmentId: string, employeeId: string, options?: RawAxiosRequestConfig) {
        return DepartmentEmployeeApiFp(this.configuration).departmentEmployeeControllerDeleteDepartmentEmployee(departmentId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} departmentId 
     * @param {number} skip 
     * @param {number} take 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentEmployeeApi
     */
    public departmentEmployeeControllerFindDepartmentEmployees(departmentId: string, skip: number, take: number, options?: RawAxiosRequestConfig) {
        return DepartmentEmployeeApiFp(this.configuration).departmentEmployeeControllerFindDepartmentEmployees(departmentId, skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} departmentId 
     * @param {string} employeeId 
     * @param {number} [amount] Amount of compensation
     * @param {DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum} [compensationType] Type of compensation
     * @param {number} [defaultHours] Default hours for the compensation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentEmployeeApi
     */
    public departmentEmployeeControllerUpdateDepartmentEmployee(departmentId: string, employeeId: string, amount?: number, compensationType?: DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum, defaultHours?: number, options?: RawAxiosRequestConfig) {
        return DepartmentEmployeeApiFp(this.configuration).departmentEmployeeControllerUpdateDepartmentEmployee(departmentId, employeeId, amount, compensationType, defaultHours, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum = {
    Hourly: 'HOURLY',
    Daily: 'DAILY',
    Monthly: 'MONTHLY'
} as const;
export type DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum = typeof DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum[keyof typeof DepartmentEmployeeControllerAddDepartmentEmployeeCompensationTypeEnum];
/**
 * @export
 */
export const DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum = {
    Hourly: 'HOURLY',
    Daily: 'DAILY',
    Monthly: 'MONTHLY'
} as const;
export type DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum = typeof DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum[keyof typeof DepartmentEmployeeControllerUpdateDepartmentEmployeeCompensationTypeEnum];


/**
 * DepartmentsApi - axios parameter creator
 * @export
 */
export const DepartmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerFindDepartment: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerFindDepartmentById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('departmentControllerFindDepartmentById', 'id', id)
            const localVarPath = `/departments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentsApi - functional programming interface
 * @export
 */
export const DepartmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentControllerFindDepartment(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindDepartmentsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentControllerFindDepartment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.departmentControllerFindDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentControllerFindDepartmentById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindDepartmentResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentControllerFindDepartmentById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentsApi.departmentControllerFindDepartmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepartmentsApi - factory interface
 * @export
 */
export const DepartmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerFindDepartment(options?: RawAxiosRequestConfig): AxiosPromise<FindDepartmentsResult> {
            return localVarFp.departmentControllerFindDepartment(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerFindDepartmentById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FindDepartmentResult> {
            return localVarFp.departmentControllerFindDepartmentById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentsApi - object-oriented interface
 * @export
 * @class DepartmentsApi
 * @extends {BaseAPI}
 */
export class DepartmentsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public departmentControllerFindDepartment(options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).departmentControllerFindDepartment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public departmentControllerFindDepartmentById(id: string, options?: RawAxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).departmentControllerFindDepartmentById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DriverApi - axios parameter creator
 * @export
 */
export const DriverApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDriverEventDto} createDriverEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerCreateDriverEvent: async (createDriverEventDto: CreateDriverEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDriverEventDto' is not null or undefined
            assertParamExists('driverInfoControllerCreateDriverEvent', 'createDriverEventDto', createDriverEventDto)
            const localVarPath = `/driver_info/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDriverEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDriverInfoDto} createDriverInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerCreateDriverInfo: async (createDriverInfoDto: CreateDriverInfoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDriverInfoDto' is not null or undefined
            assertParamExists('driverInfoControllerCreateDriverInfo', 'createDriverInfoDto', createDriverInfoDto)
            const localVarPath = `/driver_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDriverInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerDeleteDriverEvent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('driverInfoControllerDeleteDriverEvent', 'id', id)
            const localVarPath = `/driver_info/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerDeleteDriverInfo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('driverInfoControllerDeleteDriverInfo', 'id', id)
            const localVarPath = `/driver_info/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportDriversSalaryDto} exportDriversSalaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerExportDriverSalary: async (exportDriversSalaryDto: ExportDriversSalaryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportDriversSalaryDto' is not null or undefined
            assertParamExists('driverInfoControllerExportDriverSalary', 'exportDriversSalaryDto', exportDriversSalaryDto)
            const localVarPath = `/driver_info/salary/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportDriversSalaryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerGetDriverInfo: async (skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/driver_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerGetDriverInfoList: async (startTime: number, endTime: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('driverInfoControllerGetDriverInfoList', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('driverInfoControllerGetDriverInfoList', 'endTime', endTime)
            const localVarPath = `/driver_info/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerGetDriverSalary: async (startTime: number, endTime: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('driverInfoControllerGetDriverSalary', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('driverInfoControllerGetDriverSalary', 'endTime', endTime)
            const localVarPath = `/driver_info/salary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerGetUserByPhone: async (phone: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('driverInfoControllerGetUserByPhone', 'phone', phone)
            const localVarPath = `/driver_info/get-by-phone/{phone}`
                .replace(`{${"phone"}}`, encodeURIComponent(String(phone)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerImportDriversEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/driver_info/events/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendDriversSalaryDto} sendDriversSalaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerSendDriverSalary: async (sendDriversSalaryDto: SendDriversSalaryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendDriversSalaryDto' is not null or undefined
            assertParamExists('driverInfoControllerSendDriverSalary', 'sendDriversSalaryDto', sendDriversSalaryDto)
            const localVarPath = `/driver_info/salary/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendDriversSalaryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDriverInfoDto} updateDriverInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerUpdateDriverInfo: async (id: string, updateDriverInfoDto: UpdateDriverInfoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('driverInfoControllerUpdateDriverInfo', 'id', id)
            // verify required parameter 'updateDriverInfoDto' is not null or undefined
            assertParamExists('driverInfoControllerUpdateDriverInfo', 'updateDriverInfoDto', updateDriverInfoDto)
            const localVarPath = `/driver_info/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDriverInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDriverLineIdDto} updateDriverLineIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerUpdateDriverLineId: async (id: string, updateDriverLineIdDto: UpdateDriverLineIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('driverInfoControllerUpdateDriverLineId', 'id', id)
            // verify required parameter 'updateDriverLineIdDto' is not null or undefined
            assertParamExists('driverInfoControllerUpdateDriverLineId', 'updateDriverLineIdDto', updateDriverLineIdDto)
            const localVarPath = `/driver_info/{id}/update-line-id`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDriverLineIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertDriverSalaryFileDto} upsertDriverSalaryFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerUpsertDriverSalaryFileId: async (upsertDriverSalaryFileDto: UpsertDriverSalaryFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertDriverSalaryFileDto' is not null or undefined
            assertParamExists('driverInfoControllerUpsertDriverSalaryFileId', 'upsertDriverSalaryFileDto', upsertDriverSalaryFileDto)
            const localVarPath = `/driver_info/upsert-salary-file-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDriverSalaryFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {Array<string>} driverIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverLeaveControllerGetDriverLeave: async (startTime: number, endTime: number, driverIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('driverLeaveControllerGetDriverLeave', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('driverLeaveControllerGetDriverLeave', 'endTime', endTime)
            // verify required parameter 'driverIds' is not null or undefined
            assertParamExists('driverLeaveControllerGetDriverLeave', 'driverIds', driverIds)
            const localVarPath = `/driver_info/leave`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (driverIds) {
                localVarQueryParameter['driverIds'] = driverIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertDriversLeaveDto} upsertDriversLeaveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverLeaveControllerUpsertDriverLeave: async (upsertDriversLeaveDto: UpsertDriversLeaveDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertDriversLeaveDto' is not null or undefined
            assertParamExists('driverLeaveControllerUpsertDriverLeave', 'upsertDriversLeaveDto', upsertDriversLeaveDto)
            const localVarPath = `/driver_info/leave`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDriversLeaveDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverApi - functional programming interface
 * @export
 */
export const DriverApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDriverEventDto} createDriverEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerCreateDriverEvent(createDriverEventDto: CreateDriverEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerCreateDriverEvent(createDriverEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerCreateDriverEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateDriverInfoDto} createDriverInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerCreateDriverInfo(createDriverInfoDto: CreateDriverInfoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerCreateDriverInfo(createDriverInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerCreateDriverInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerDeleteDriverEvent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerDeleteDriverEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerDeleteDriverEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerDeleteDriverInfo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerDeleteDriverInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerDeleteDriverInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportDriversSalaryDto} exportDriversSalaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerExportDriverSalary(exportDriversSalaryDto: ExportDriversSalaryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerExportDriverSalary(exportDriversSalaryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerExportDriverSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerGetDriverInfo(skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerGetDriverInfo(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerGetDriverInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerGetDriverInfoList(startTime: number, endTime: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerGetDriverInfoList(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerGetDriverInfoList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerGetDriverSalary(startTime: number, endTime: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerGetDriverSalary(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerGetDriverSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerGetUserByPhone(phone: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerGetUserByPhone(phone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerGetUserByPhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerImportDriversEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerImportDriversEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerImportDriversEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendDriversSalaryDto} sendDriversSalaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerSendDriverSalary(sendDriversSalaryDto: SendDriversSalaryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerSendDriverSalary(sendDriversSalaryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerSendDriverSalary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDriverInfoDto} updateDriverInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerUpdateDriverInfo(id: string, updateDriverInfoDto: UpdateDriverInfoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerUpdateDriverInfo(id, updateDriverInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerUpdateDriverInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDriverLineIdDto} updateDriverLineIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerUpdateDriverLineId(id: string, updateDriverLineIdDto: UpdateDriverLineIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerUpdateDriverLineId(id, updateDriverLineIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerUpdateDriverLineId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertDriverSalaryFileDto} upsertDriverSalaryFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverInfoControllerUpsertDriverSalaryFileId(upsertDriverSalaryFileDto: UpsertDriverSalaryFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverInfoControllerUpsertDriverSalaryFileId(upsertDriverSalaryFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverInfoControllerUpsertDriverSalaryFileId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {Array<string>} driverIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverLeaveControllerGetDriverLeave(startTime: number, endTime: number, driverIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverLeaveControllerGetDriverLeave(startTime, endTime, driverIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverLeaveControllerGetDriverLeave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertDriversLeaveDto} upsertDriversLeaveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async driverLeaveControllerUpsertDriverLeave(upsertDriversLeaveDto: UpsertDriversLeaveDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.driverLeaveControllerUpsertDriverLeave(upsertDriversLeaveDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverApi.driverLeaveControllerUpsertDriverLeave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DriverApi - factory interface
 * @export
 */
export const DriverApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateDriverEventDto} createDriverEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerCreateDriverEvent(createDriverEventDto: CreateDriverEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerCreateDriverEvent(createDriverEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDriverInfoDto} createDriverInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerCreateDriverInfo(createDriverInfoDto: CreateDriverInfoDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerCreateDriverInfo(createDriverInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerDeleteDriverEvent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerDeleteDriverEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerDeleteDriverInfo(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerDeleteDriverInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportDriversSalaryDto} exportDriversSalaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerExportDriverSalary(exportDriversSalaryDto: ExportDriversSalaryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerExportDriverSalary(exportDriversSalaryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerGetDriverInfo(skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerGetDriverInfo(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerGetDriverInfoList(startTime: number, endTime: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerGetDriverInfoList(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerGetDriverSalary(startTime: number, endTime: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerGetDriverSalary(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerGetUserByPhone(phone: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerGetUserByPhone(phone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerImportDriversEvents(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerImportDriversEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendDriversSalaryDto} sendDriversSalaryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerSendDriverSalary(sendDriversSalaryDto: SendDriversSalaryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerSendDriverSalary(sendDriversSalaryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDriverInfoDto} updateDriverInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerUpdateDriverInfo(id: string, updateDriverInfoDto: UpdateDriverInfoDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerUpdateDriverInfo(id, updateDriverInfoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDriverLineIdDto} updateDriverLineIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerUpdateDriverLineId(id: string, updateDriverLineIdDto: UpdateDriverLineIdDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerUpdateDriverLineId(id, updateDriverLineIdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertDriverSalaryFileDto} upsertDriverSalaryFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverInfoControllerUpsertDriverSalaryFileId(upsertDriverSalaryFileDto: UpsertDriverSalaryFileDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverInfoControllerUpsertDriverSalaryFileId(upsertDriverSalaryFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime This is milliseconds timestamp
         * @param {number} endTime This is milliseconds timestamp
         * @param {Array<string>} driverIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverLeaveControllerGetDriverLeave(startTime: number, endTime: number, driverIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverLeaveControllerGetDriverLeave(startTime, endTime, driverIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertDriversLeaveDto} upsertDriversLeaveDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driverLeaveControllerUpsertDriverLeave(upsertDriversLeaveDto: UpsertDriversLeaveDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.driverLeaveControllerUpsertDriverLeave(upsertDriversLeaveDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverApi - object-oriented interface
 * @export
 * @class DriverApi
 * @extends {BaseAPI}
 */
export class DriverApi extends BaseAPI {
    /**
     * 
     * @param {CreateDriverEventDto} createDriverEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerCreateDriverEvent(createDriverEventDto: CreateDriverEventDto, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerCreateDriverEvent(createDriverEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDriverInfoDto} createDriverInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerCreateDriverInfo(createDriverInfoDto: CreateDriverInfoDto, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerCreateDriverInfo(createDriverInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerDeleteDriverEvent(id: string, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerDeleteDriverEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerDeleteDriverInfo(id: string, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerDeleteDriverInfo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportDriversSalaryDto} exportDriversSalaryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerExportDriverSalary(exportDriversSalaryDto: ExportDriversSalaryDto, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerExportDriverSalary(exportDriversSalaryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerGetDriverInfo(skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerGetDriverInfo(skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime This is milliseconds timestamp
     * @param {number} endTime This is milliseconds timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerGetDriverInfoList(startTime: number, endTime: number, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerGetDriverInfoList(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime This is milliseconds timestamp
     * @param {number} endTime This is milliseconds timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerGetDriverSalary(startTime: number, endTime: number, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerGetDriverSalary(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerGetUserByPhone(phone: string, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerGetUserByPhone(phone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerImportDriversEvents(options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerImportDriversEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendDriversSalaryDto} sendDriversSalaryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerSendDriverSalary(sendDriversSalaryDto: SendDriversSalaryDto, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerSendDriverSalary(sendDriversSalaryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDriverInfoDto} updateDriverInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerUpdateDriverInfo(id: string, updateDriverInfoDto: UpdateDriverInfoDto, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerUpdateDriverInfo(id, updateDriverInfoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDriverLineIdDto} updateDriverLineIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerUpdateDriverLineId(id: string, updateDriverLineIdDto: UpdateDriverLineIdDto, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerUpdateDriverLineId(id, updateDriverLineIdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertDriverSalaryFileDto} upsertDriverSalaryFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverInfoControllerUpsertDriverSalaryFileId(upsertDriverSalaryFileDto: UpsertDriverSalaryFileDto, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverInfoControllerUpsertDriverSalaryFileId(upsertDriverSalaryFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime This is milliseconds timestamp
     * @param {number} endTime This is milliseconds timestamp
     * @param {Array<string>} driverIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverLeaveControllerGetDriverLeave(startTime: number, endTime: number, driverIds: Array<string>, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverLeaveControllerGetDriverLeave(startTime, endTime, driverIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertDriversLeaveDto} upsertDriversLeaveDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public driverLeaveControllerUpsertDriverLeave(upsertDriversLeaveDto: UpsertDriversLeaveDto, options?: RawAxiosRequestConfig) {
        return DriverApiFp(this.configuration).driverLeaveControllerUpsertDriverLeave(upsertDriversLeaveDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeLocationAssistantReportSchedulesApi - axios parameter creator
 * @export
 */
export const EmployeeLocationAssistantReportSchedulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateReportScheduleDto} createReportScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantReportScheduleControllerCreateReportSchedule: async (createReportScheduleDto: CreateReportScheduleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReportScheduleDto' is not null or undefined
            assertParamExists('employeeLocationAssistantReportScheduleControllerCreateReportSchedule', 'createReportScheduleDto', createReportScheduleDto)
            const localVarPath = `/employee/location-assistant-report-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReportScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReportScheduleDto} updateReportScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantReportScheduleControllerUpdateReportSchedule: async (id: string, updateReportScheduleDto: UpdateReportScheduleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeeLocationAssistantReportScheduleControllerUpdateReportSchedule', 'id', id)
            // verify required parameter 'updateReportScheduleDto' is not null or undefined
            assertParamExists('employeeLocationAssistantReportScheduleControllerUpdateReportSchedule', 'updateReportScheduleDto', updateReportScheduleDto)
            const localVarPath = `/employee/location-assistant-report-schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeLocationAssistantReportSchedulesApi - functional programming interface
 * @export
 */
export const EmployeeLocationAssistantReportSchedulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeLocationAssistantReportSchedulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateReportScheduleDto} createReportScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeLocationAssistantReportScheduleControllerCreateReportSchedule(createReportScheduleDto: CreateReportScheduleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLocationAssistantReportScheduleControllerCreateReportSchedule(createReportScheduleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeLocationAssistantReportSchedulesApi.employeeLocationAssistantReportScheduleControllerCreateReportSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReportScheduleDto} updateReportScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeLocationAssistantReportScheduleControllerUpdateReportSchedule(id: string, updateReportScheduleDto: UpdateReportScheduleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLocationAssistantReportScheduleControllerUpdateReportSchedule(id, updateReportScheduleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeLocationAssistantReportSchedulesApi.employeeLocationAssistantReportScheduleControllerUpdateReportSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeLocationAssistantReportSchedulesApi - factory interface
 * @export
 */
export const EmployeeLocationAssistantReportSchedulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeLocationAssistantReportSchedulesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateReportScheduleDto} createReportScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantReportScheduleControllerCreateReportSchedule(createReportScheduleDto: CreateReportScheduleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeLocationAssistantReportScheduleControllerCreateReportSchedule(createReportScheduleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReportScheduleDto} updateReportScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantReportScheduleControllerUpdateReportSchedule(id: string, updateReportScheduleDto: UpdateReportScheduleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeLocationAssistantReportScheduleControllerUpdateReportSchedule(id, updateReportScheduleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeLocationAssistantReportSchedulesApi - object-oriented interface
 * @export
 * @class EmployeeLocationAssistantReportSchedulesApi
 * @extends {BaseAPI}
 */
export class EmployeeLocationAssistantReportSchedulesApi extends BaseAPI {
    /**
     * 
     * @param {CreateReportScheduleDto} createReportScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeLocationAssistantReportSchedulesApi
     */
    public employeeLocationAssistantReportScheduleControllerCreateReportSchedule(createReportScheduleDto: CreateReportScheduleDto, options?: RawAxiosRequestConfig) {
        return EmployeeLocationAssistantReportSchedulesApiFp(this.configuration).employeeLocationAssistantReportScheduleControllerCreateReportSchedule(createReportScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateReportScheduleDto} updateReportScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeLocationAssistantReportSchedulesApi
     */
    public employeeLocationAssistantReportScheduleControllerUpdateReportSchedule(id: string, updateReportScheduleDto: UpdateReportScheduleDto, options?: RawAxiosRequestConfig) {
        return EmployeeLocationAssistantReportSchedulesApiFp(this.configuration).employeeLocationAssistantReportScheduleControllerUpdateReportSchedule(id, updateReportScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeLocationAssistantReportShiftsApi - axios parameter creator
 * @export
 */
export const EmployeeLocationAssistantReportShiftsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startTime] Start time for filtering shifts (ISO 8601 format)
         * @param {string} [endTime] End time for filtering shifts (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantReportShiftControllerFindReportShifts: async (startTime?: string, endTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/location-assistant-report-shifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeLocationAssistantReportShiftsApi - functional programming interface
 * @export
 */
export const EmployeeLocationAssistantReportShiftsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeLocationAssistantReportShiftsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [startTime] Start time for filtering shifts (ISO 8601 format)
         * @param {string} [endTime] End time for filtering shifts (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeLocationAssistantReportShiftControllerFindReportShifts(startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindLocationAssistantReportShiftsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLocationAssistantReportShiftControllerFindReportShifts(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeLocationAssistantReportShiftsApi.employeeLocationAssistantReportShiftControllerFindReportShifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeLocationAssistantReportShiftsApi - factory interface
 * @export
 */
export const EmployeeLocationAssistantReportShiftsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeLocationAssistantReportShiftsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [startTime] Start time for filtering shifts (ISO 8601 format)
         * @param {string} [endTime] End time for filtering shifts (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantReportShiftControllerFindReportShifts(startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): AxiosPromise<FindLocationAssistantReportShiftsResult> {
            return localVarFp.employeeLocationAssistantReportShiftControllerFindReportShifts(startTime, endTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeLocationAssistantReportShiftsApi - object-oriented interface
 * @export
 * @class EmployeeLocationAssistantReportShiftsApi
 * @extends {BaseAPI}
 */
export class EmployeeLocationAssistantReportShiftsApi extends BaseAPI {
    /**
     * 
     * @param {string} [startTime] Start time for filtering shifts (ISO 8601 format)
     * @param {string} [endTime] End time for filtering shifts (ISO 8601 format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeLocationAssistantReportShiftsApi
     */
    public employeeLocationAssistantReportShiftControllerFindReportShifts(startTime?: string, endTime?: string, options?: RawAxiosRequestConfig) {
        return EmployeeLocationAssistantReportShiftsApiFp(this.configuration).employeeLocationAssistantReportShiftControllerFindReportShifts(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeLocationAssistantShiftSchedulesApi - axios parameter creator
 * @export
 */
export const EmployeeLocationAssistantShiftSchedulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [time] 查詢日期
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantShiftScheduleControllerFindShiftSchedules: async (time?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/location-assistant-shift-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeLocationAssistantShiftSchedulesApi - functional programming interface
 * @export
 */
export const EmployeeLocationAssistantShiftSchedulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeLocationAssistantShiftSchedulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [time] 查詢日期
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeLocationAssistantShiftScheduleControllerFindShiftSchedules(time?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindLocationAssistantShiftScheduleResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLocationAssistantShiftScheduleControllerFindShiftSchedules(time, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeLocationAssistantShiftSchedulesApi.employeeLocationAssistantShiftScheduleControllerFindShiftSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeLocationAssistantShiftSchedulesApi - factory interface
 * @export
 */
export const EmployeeLocationAssistantShiftSchedulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeLocationAssistantShiftSchedulesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [time] 查詢日期
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantShiftScheduleControllerFindShiftSchedules(time?: string, options?: RawAxiosRequestConfig): AxiosPromise<FindLocationAssistantShiftScheduleResult> {
            return localVarFp.employeeLocationAssistantShiftScheduleControllerFindShiftSchedules(time, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeLocationAssistantShiftSchedulesApi - object-oriented interface
 * @export
 * @class EmployeeLocationAssistantShiftSchedulesApi
 * @extends {BaseAPI}
 */
export class EmployeeLocationAssistantShiftSchedulesApi extends BaseAPI {
    /**
     * 
     * @param {string} [time] 查詢日期
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeLocationAssistantShiftSchedulesApi
     */
    public employeeLocationAssistantShiftScheduleControllerFindShiftSchedules(time?: string, options?: RawAxiosRequestConfig) {
        return EmployeeLocationAssistantShiftSchedulesApiFp(this.configuration).employeeLocationAssistantShiftScheduleControllerFindShiftSchedules(time, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeLocationAssistantShiftsApi - axios parameter creator
 * @export
 */
export const EmployeeLocationAssistantShiftsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startTime] 開始時間
         * @param {string} [endTime] 結束時間
         * @param {string} [locationId] 位置ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantShiftControllerFindShifts: async (startTime?: string, endTime?: string, locationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/location-assistant-shifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeLocationAssistantShiftsApi - functional programming interface
 * @export
 */
export const EmployeeLocationAssistantShiftsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeLocationAssistantShiftsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [startTime] 開始時間
         * @param {string} [endTime] 結束時間
         * @param {string} [locationId] 位置ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeLocationAssistantShiftControllerFindShifts(startTime?: string, endTime?: string, locationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindLocationAssistantShiftsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeLocationAssistantShiftControllerFindShifts(startTime, endTime, locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeLocationAssistantShiftsApi.employeeLocationAssistantShiftControllerFindShifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeLocationAssistantShiftsApi - factory interface
 * @export
 */
export const EmployeeLocationAssistantShiftsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeLocationAssistantShiftsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [startTime] 開始時間
         * @param {string} [endTime] 結束時間
         * @param {string} [locationId] 位置ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeLocationAssistantShiftControllerFindShifts(startTime?: string, endTime?: string, locationId?: string, options?: RawAxiosRequestConfig): AxiosPromise<FindLocationAssistantShiftsResult> {
            return localVarFp.employeeLocationAssistantShiftControllerFindShifts(startTime, endTime, locationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeLocationAssistantShiftsApi - object-oriented interface
 * @export
 * @class EmployeeLocationAssistantShiftsApi
 * @extends {BaseAPI}
 */
export class EmployeeLocationAssistantShiftsApi extends BaseAPI {
    /**
     * 
     * @param {string} [startTime] 開始時間
     * @param {string} [endTime] 結束時間
     * @param {string} [locationId] 位置ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeLocationAssistantShiftsApi
     */
    public employeeLocationAssistantShiftControllerFindShifts(startTime?: string, endTime?: string, locationId?: string, options?: RawAxiosRequestConfig) {
        return EmployeeLocationAssistantShiftsApiFp(this.configuration).employeeLocationAssistantShiftControllerFindShifts(startTime, endTime, locationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeePayrollsApi - axios parameter creator
 * @export
 */
export const EmployeePayrollsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateEmployeePayrollDto} createEmployeePayrollDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerCreatePayroll: async (createEmployeePayrollDto: CreateEmployeePayrollDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeePayrollDto' is not null or undefined
            assertParamExists('employeePayrollControllerCreatePayroll', 'createEmployeePayrollDto', createEmployeePayrollDto)
            const localVarPath = `/employee-payrolls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeePayrollDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [status] 
         * @param {string} [employeeName] Employee name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerFindEmployeePayrolls: async (skip?: number, take?: number, status?: Array<string>, employeeName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee-payrolls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (employeeName !== undefined) {
                localVarQueryParameter['employeeName'] = employeeName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PayEmployeePayrollDto} payEmployeePayrollDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerPayrollPaid: async (payEmployeePayrollDto: PayEmployeePayrollDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payEmployeePayrollDto' is not null or undefined
            assertParamExists('employeePayrollControllerPayrollPaid', 'payEmployeePayrollDto', payEmployeePayrollDto)
            const localVarPath = `/employee-payrolls/payroll-paid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payEmployeePayrollDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendConfirmPushMessageDto} sendConfirmPushMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerSendConfirmPushMessage: async (sendConfirmPushMessageDto: SendConfirmPushMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendConfirmPushMessageDto' is not null or undefined
            assertParamExists('employeePayrollControllerSendConfirmPushMessage', 'sendConfirmPushMessageDto', sendConfirmPushMessageDto)
            const localVarPath = `/employee-payrolls/send-confirm-push-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendConfirmPushMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerVoidPayroll: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeePayrollControllerVoidPayroll', 'id', id)
            const localVarPath = `/employee-payrolls/{id}/void`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeePayrollsApi - functional programming interface
 * @export
 */
export const EmployeePayrollsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeePayrollsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateEmployeePayrollDto} createEmployeePayrollDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePayrollControllerCreatePayroll(createEmployeePayrollDto: CreateEmployeePayrollDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePayrollControllerCreatePayroll(createEmployeePayrollDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeePayrollsApi.employeePayrollControllerCreatePayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [status] 
         * @param {string} [employeeName] Employee name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePayrollControllerFindEmployeePayrolls(skip?: number, take?: number, status?: Array<string>, employeeName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindEmployeePayrollsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePayrollControllerFindEmployeePayrolls(skip, take, status, employeeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeePayrollsApi.employeePayrollControllerFindEmployeePayrolls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PayEmployeePayrollDto} payEmployeePayrollDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePayrollControllerPayrollPaid(payEmployeePayrollDto: PayEmployeePayrollDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePayrollControllerPayrollPaid(payEmployeePayrollDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeePayrollsApi.employeePayrollControllerPayrollPaid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendConfirmPushMessageDto} sendConfirmPushMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePayrollControllerSendConfirmPushMessage(sendConfirmPushMessageDto: SendConfirmPushMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePayrollControllerSendConfirmPushMessage(sendConfirmPushMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeePayrollsApi.employeePayrollControllerSendConfirmPushMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeePayrollControllerVoidPayroll(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeePayrollControllerVoidPayroll(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeePayrollsApi.employeePayrollControllerVoidPayroll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeePayrollsApi - factory interface
 * @export
 */
export const EmployeePayrollsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeePayrollsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateEmployeePayrollDto} createEmployeePayrollDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerCreatePayroll(createEmployeePayrollDto: CreateEmployeePayrollDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeePayrollControllerCreatePayroll(createEmployeePayrollDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [status] 
         * @param {string} [employeeName] Employee name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerFindEmployeePayrolls(skip?: number, take?: number, status?: Array<string>, employeeName?: string, options?: RawAxiosRequestConfig): AxiosPromise<FindEmployeePayrollsResult> {
            return localVarFp.employeePayrollControllerFindEmployeePayrolls(skip, take, status, employeeName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayEmployeePayrollDto} payEmployeePayrollDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerPayrollPaid(payEmployeePayrollDto: PayEmployeePayrollDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeePayrollControllerPayrollPaid(payEmployeePayrollDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendConfirmPushMessageDto} sendConfirmPushMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerSendConfirmPushMessage(sendConfirmPushMessageDto: SendConfirmPushMessageDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeePayrollControllerSendConfirmPushMessage(sendConfirmPushMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeePayrollControllerVoidPayroll(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeePayrollControllerVoidPayroll(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeePayrollsApi - object-oriented interface
 * @export
 * @class EmployeePayrollsApi
 * @extends {BaseAPI}
 */
export class EmployeePayrollsApi extends BaseAPI {
    /**
     * 
     * @param {CreateEmployeePayrollDto} createEmployeePayrollDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePayrollsApi
     */
    public employeePayrollControllerCreatePayroll(createEmployeePayrollDto: CreateEmployeePayrollDto, options?: RawAxiosRequestConfig) {
        return EmployeePayrollsApiFp(this.configuration).employeePayrollControllerCreatePayroll(createEmployeePayrollDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {Array<string>} [status] 
     * @param {string} [employeeName] Employee name to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePayrollsApi
     */
    public employeePayrollControllerFindEmployeePayrolls(skip?: number, take?: number, status?: Array<string>, employeeName?: string, options?: RawAxiosRequestConfig) {
        return EmployeePayrollsApiFp(this.configuration).employeePayrollControllerFindEmployeePayrolls(skip, take, status, employeeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayEmployeePayrollDto} payEmployeePayrollDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePayrollsApi
     */
    public employeePayrollControllerPayrollPaid(payEmployeePayrollDto: PayEmployeePayrollDto, options?: RawAxiosRequestConfig) {
        return EmployeePayrollsApiFp(this.configuration).employeePayrollControllerPayrollPaid(payEmployeePayrollDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendConfirmPushMessageDto} sendConfirmPushMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePayrollsApi
     */
    public employeePayrollControllerSendConfirmPushMessage(sendConfirmPushMessageDto: SendConfirmPushMessageDto, options?: RawAxiosRequestConfig) {
        return EmployeePayrollsApiFp(this.configuration).employeePayrollControllerSendConfirmPushMessage(sendConfirmPushMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePayrollsApi
     */
    public employeePayrollControllerVoidPayroll(id: string, options?: RawAxiosRequestConfig) {
        return EmployeePayrollsApiFp(this.configuration).employeePayrollControllerVoidPayroll(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeeSalaryAdjustmentApi - axios parameter creator
 * @export
 */
export const EmployeeSalaryAdjustmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 批量創建薪資調整項目，使用員工姓名而非 ID，系統會自動查找對應的員工 ID
         * @summary 批量創建薪資調整項目（使用員工姓名）
         * @param {BulkCreateEmployeeSalaryAdjustmentDto} bulkCreateEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerBulkCreate: async (bulkCreateEmployeeSalaryAdjustmentDto: BulkCreateEmployeeSalaryAdjustmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreateEmployeeSalaryAdjustmentDto' is not null or undefined
            assertParamExists('employeeSalaryAdjustmentControllerBulkCreate', 'bulkCreateEmployeeSalaryAdjustmentDto', bulkCreateEmployeeSalaryAdjustmentDto)
            const localVarPath = `/employee-salary-adjustments/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateEmployeeSalaryAdjustmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 創建新的薪資調整項目
         * @param {CreateEmployeeSalaryAdjustmentDto} createEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerCreate: async (createEmployeeSalaryAdjustmentDto: CreateEmployeeSalaryAdjustmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeeSalaryAdjustmentDto' is not null or undefined
            assertParamExists('employeeSalaryAdjustmentControllerCreate', 'createEmployeeSalaryAdjustmentDto', createEmployeeSalaryAdjustmentDto)
            const localVarPath = `/employee-salary-adjustments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeSalaryAdjustmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 獲取所有員工薪資調整項目
         * @param {Array<string>} [employeeId] 員工ID
         * @param {Array<EmployeeSalaryAdjustmentControllerFindAllStatusEnum>} [status] 狀態
         * @param {Array<string>} [type] 薪資調整類型
         * @param {Array<string>} [time] 指定時間 (ISO format)
         * @param {string} [startTime] 開始時間 (ISO format)
         * @param {string} [endTime] 結束時間 (ISO format)
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerFindAll: async (employeeId?: Array<string>, status?: Array<EmployeeSalaryAdjustmentControllerFindAllStatusEnum>, type?: Array<string>, time?: Array<string>, startTime?: string, endTime?: string, take?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee-salary-adjustments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (employeeId) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (time) {
                localVarQueryParameter['time'] = time;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 獲取特定薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerFindOne: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeeSalaryAdjustmentControllerFindOne', 'id', id)
            const localVarPath = `/employee-salary-adjustments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 獲取所有薪資調整項目過濾器
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerGetFilters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee-salary-adjustments/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 獲取所有薪資調整類型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerGetTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee-salary-adjustments/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 刪除薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerRemove: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeeSalaryAdjustmentControllerRemove', 'id', id)
            const localVarPath = `/employee-salary-adjustments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {UpdateEmployeeSalaryAdjustmentDto} updateEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerUpdate: async (id: string, updateEmployeeSalaryAdjustmentDto: UpdateEmployeeSalaryAdjustmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeeSalaryAdjustmentControllerUpdate', 'id', id)
            // verify required parameter 'updateEmployeeSalaryAdjustmentDto' is not null or undefined
            assertParamExists('employeeSalaryAdjustmentControllerUpdate', 'updateEmployeeSalaryAdjustmentDto', updateEmployeeSalaryAdjustmentDto)
            const localVarPath = `/employee-salary-adjustments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeSalaryAdjustmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeSalaryAdjustmentApi - functional programming interface
 * @export
 */
export const EmployeeSalaryAdjustmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeSalaryAdjustmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 批量創建薪資調整項目，使用員工姓名而非 ID，系統會自動查找對應的員工 ID
         * @summary 批量創建薪資調整項目（使用員工姓名）
         * @param {BulkCreateEmployeeSalaryAdjustmentDto} bulkCreateEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeSalaryAdjustmentControllerBulkCreate(bulkCreateEmployeeSalaryAdjustmentDto: BulkCreateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeSalaryAdjustmentControllerBulkCreate(bulkCreateEmployeeSalaryAdjustmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSalaryAdjustmentApi.employeeSalaryAdjustmentControllerBulkCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 創建新的薪資調整項目
         * @param {CreateEmployeeSalaryAdjustmentDto} createEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeSalaryAdjustmentControllerCreate(createEmployeeSalaryAdjustmentDto: CreateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeSalaryAdjustmentControllerCreate(createEmployeeSalaryAdjustmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSalaryAdjustmentApi.employeeSalaryAdjustmentControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 獲取所有員工薪資調整項目
         * @param {Array<string>} [employeeId] 員工ID
         * @param {Array<EmployeeSalaryAdjustmentControllerFindAllStatusEnum>} [status] 狀態
         * @param {Array<string>} [type] 薪資調整類型
         * @param {Array<string>} [time] 指定時間 (ISO format)
         * @param {string} [startTime] 開始時間 (ISO format)
         * @param {string} [endTime] 結束時間 (ISO format)
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeSalaryAdjustmentControllerFindAll(employeeId?: Array<string>, status?: Array<EmployeeSalaryAdjustmentControllerFindAllStatusEnum>, type?: Array<string>, time?: Array<string>, startTime?: string, endTime?: string, take?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllEmployeeSalaryAdjustmentsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeSalaryAdjustmentControllerFindAll(employeeId, status, type, time, startTime, endTime, take, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSalaryAdjustmentApi.employeeSalaryAdjustmentControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 獲取特定薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeSalaryAdjustmentControllerFindOne(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeSalaryAdjustmentControllerFindOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSalaryAdjustmentApi.employeeSalaryAdjustmentControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 獲取所有薪資調整項目過濾器
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeSalaryAdjustmentControllerGetFilters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmployeeSalaryAdjustmentFiltersResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeSalaryAdjustmentControllerGetFilters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSalaryAdjustmentApi.employeeSalaryAdjustmentControllerGetFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 獲取所有薪資調整類型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeSalaryAdjustmentControllerGetTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmployeeSalaryAdjustmentTypesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeSalaryAdjustmentControllerGetTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSalaryAdjustmentApi.employeeSalaryAdjustmentControllerGetTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 刪除薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeSalaryAdjustmentControllerRemove(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeSalaryAdjustmentControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSalaryAdjustmentApi.employeeSalaryAdjustmentControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {UpdateEmployeeSalaryAdjustmentDto} updateEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeSalaryAdjustmentControllerUpdate(id: string, updateEmployeeSalaryAdjustmentDto: UpdateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeSalaryAdjustmentControllerUpdate(id, updateEmployeeSalaryAdjustmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSalaryAdjustmentApi.employeeSalaryAdjustmentControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeSalaryAdjustmentApi - factory interface
 * @export
 */
export const EmployeeSalaryAdjustmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeSalaryAdjustmentApiFp(configuration)
    return {
        /**
         * 批量創建薪資調整項目，使用員工姓名而非 ID，系統會自動查找對應的員工 ID
         * @summary 批量創建薪資調整項目（使用員工姓名）
         * @param {BulkCreateEmployeeSalaryAdjustmentDto} bulkCreateEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerBulkCreate(bulkCreateEmployeeSalaryAdjustmentDto: BulkCreateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeSalaryAdjustmentControllerBulkCreate(bulkCreateEmployeeSalaryAdjustmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 創建新的薪資調整項目
         * @param {CreateEmployeeSalaryAdjustmentDto} createEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerCreate(createEmployeeSalaryAdjustmentDto: CreateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeSalaryAdjustmentControllerCreate(createEmployeeSalaryAdjustmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 獲取所有員工薪資調整項目
         * @param {Array<string>} [employeeId] 員工ID
         * @param {Array<EmployeeSalaryAdjustmentControllerFindAllStatusEnum>} [status] 狀態
         * @param {Array<string>} [type] 薪資調整類型
         * @param {Array<string>} [time] 指定時間 (ISO format)
         * @param {string} [startTime] 開始時間 (ISO format)
         * @param {string} [endTime] 結束時間 (ISO format)
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerFindAll(employeeId?: Array<string>, status?: Array<EmployeeSalaryAdjustmentControllerFindAllStatusEnum>, type?: Array<string>, time?: Array<string>, startTime?: string, endTime?: string, take?: number, skip?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetAllEmployeeSalaryAdjustmentsResult> {
            return localVarFp.employeeSalaryAdjustmentControllerFindAll(employeeId, status, type, time, startTime, endTime, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 獲取特定薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerFindOne(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeSalaryAdjustmentControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 獲取所有薪資調整項目過濾器
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerGetFilters(options?: RawAxiosRequestConfig): AxiosPromise<GetEmployeeSalaryAdjustmentFiltersResult> {
            return localVarFp.employeeSalaryAdjustmentControllerGetFilters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 獲取所有薪資調整類型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerGetTypes(options?: RawAxiosRequestConfig): AxiosPromise<GetEmployeeSalaryAdjustmentTypesResult> {
            return localVarFp.employeeSalaryAdjustmentControllerGetTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 刪除薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerRemove(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeSalaryAdjustmentControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新薪資調整項目
         * @param {string} id 薪資調整項目ID
         * @param {UpdateEmployeeSalaryAdjustmentDto} updateEmployeeSalaryAdjustmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeSalaryAdjustmentControllerUpdate(id: string, updateEmployeeSalaryAdjustmentDto: UpdateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeSalaryAdjustmentControllerUpdate(id, updateEmployeeSalaryAdjustmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeSalaryAdjustmentApi - object-oriented interface
 * @export
 * @class EmployeeSalaryAdjustmentApi
 * @extends {BaseAPI}
 */
export class EmployeeSalaryAdjustmentApi extends BaseAPI {
    /**
     * 批量創建薪資調整項目，使用員工姓名而非 ID，系統會自動查找對應的員工 ID
     * @summary 批量創建薪資調整項目（使用員工姓名）
     * @param {BulkCreateEmployeeSalaryAdjustmentDto} bulkCreateEmployeeSalaryAdjustmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSalaryAdjustmentApi
     */
    public employeeSalaryAdjustmentControllerBulkCreate(bulkCreateEmployeeSalaryAdjustmentDto: BulkCreateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig) {
        return EmployeeSalaryAdjustmentApiFp(this.configuration).employeeSalaryAdjustmentControllerBulkCreate(bulkCreateEmployeeSalaryAdjustmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 創建新的薪資調整項目
     * @param {CreateEmployeeSalaryAdjustmentDto} createEmployeeSalaryAdjustmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSalaryAdjustmentApi
     */
    public employeeSalaryAdjustmentControllerCreate(createEmployeeSalaryAdjustmentDto: CreateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig) {
        return EmployeeSalaryAdjustmentApiFp(this.configuration).employeeSalaryAdjustmentControllerCreate(createEmployeeSalaryAdjustmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 獲取所有員工薪資調整項目
     * @param {Array<string>} [employeeId] 員工ID
     * @param {Array<EmployeeSalaryAdjustmentControllerFindAllStatusEnum>} [status] 狀態
     * @param {Array<string>} [type] 薪資調整類型
     * @param {Array<string>} [time] 指定時間 (ISO format)
     * @param {string} [startTime] 開始時間 (ISO format)
     * @param {string} [endTime] 結束時間 (ISO format)
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSalaryAdjustmentApi
     */
    public employeeSalaryAdjustmentControllerFindAll(employeeId?: Array<string>, status?: Array<EmployeeSalaryAdjustmentControllerFindAllStatusEnum>, type?: Array<string>, time?: Array<string>, startTime?: string, endTime?: string, take?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return EmployeeSalaryAdjustmentApiFp(this.configuration).employeeSalaryAdjustmentControllerFindAll(employeeId, status, type, time, startTime, endTime, take, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 獲取特定薪資調整項目
     * @param {string} id 薪資調整項目ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSalaryAdjustmentApi
     */
    public employeeSalaryAdjustmentControllerFindOne(id: string, options?: RawAxiosRequestConfig) {
        return EmployeeSalaryAdjustmentApiFp(this.configuration).employeeSalaryAdjustmentControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 獲取所有薪資調整項目過濾器
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSalaryAdjustmentApi
     */
    public employeeSalaryAdjustmentControllerGetFilters(options?: RawAxiosRequestConfig) {
        return EmployeeSalaryAdjustmentApiFp(this.configuration).employeeSalaryAdjustmentControllerGetFilters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 獲取所有薪資調整類型
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSalaryAdjustmentApi
     */
    public employeeSalaryAdjustmentControllerGetTypes(options?: RawAxiosRequestConfig) {
        return EmployeeSalaryAdjustmentApiFp(this.configuration).employeeSalaryAdjustmentControllerGetTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 刪除薪資調整項目
     * @param {string} id 薪資調整項目ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSalaryAdjustmentApi
     */
    public employeeSalaryAdjustmentControllerRemove(id: string, options?: RawAxiosRequestConfig) {
        return EmployeeSalaryAdjustmentApiFp(this.configuration).employeeSalaryAdjustmentControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新薪資調整項目
     * @param {string} id 薪資調整項目ID
     * @param {UpdateEmployeeSalaryAdjustmentDto} updateEmployeeSalaryAdjustmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSalaryAdjustmentApi
     */
    public employeeSalaryAdjustmentControllerUpdate(id: string, updateEmployeeSalaryAdjustmentDto: UpdateEmployeeSalaryAdjustmentDto, options?: RawAxiosRequestConfig) {
        return EmployeeSalaryAdjustmentApiFp(this.configuration).employeeSalaryAdjustmentControllerUpdate(id, updateEmployeeSalaryAdjustmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const EmployeeSalaryAdjustmentControllerFindAllStatusEnum = {
    Pending: 'PENDING',
    Settled: 'SETTLED'
} as const;
export type EmployeeSalaryAdjustmentControllerFindAllStatusEnum = typeof EmployeeSalaryAdjustmentControllerFindAllStatusEnum[keyof typeof EmployeeSalaryAdjustmentControllerFindAllStatusEnum];


/**
 * EmployeeUsersMeApi - axios parameter creator
 * @export
 */
export const EmployeeUsersMeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BindLineDto} bindLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeUserControllerBindLine: async (bindLineDto: BindLineDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bindLineDto' is not null or undefined
            assertParamExists('employeeUserControllerBindLine', 'bindLineDto', bindLineDto)
            const localVarPath = `/employee/users/me/bind-line`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bindLineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeUserControllerGetMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeUserControllerIsLineBound: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/users/me/line-bound`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeUserControllerUnbindLine: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee/users/me/unbind-line`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeUsersMeApi - functional programming interface
 * @export
 */
export const EmployeeUsersMeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeUsersMeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BindLineDto} bindLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeUserControllerBindLine(bindLineDto: BindLineDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeUserControllerBindLine(bindLineDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeUsersMeApi.employeeUserControllerBindLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeUserControllerGetMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyProfileResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeUserControllerGetMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeUsersMeApi.employeeUserControllerGetMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeUserControllerIsLineBound(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckLineBoundResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeUserControllerIsLineBound(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeUsersMeApi.employeeUserControllerIsLineBound']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeUserControllerUnbindLine(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeUserControllerUnbindLine(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeUsersMeApi.employeeUserControllerUnbindLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeUsersMeApi - factory interface
 * @export
 */
export const EmployeeUsersMeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeUsersMeApiFp(configuration)
    return {
        /**
         * 
         * @param {BindLineDto} bindLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeUserControllerBindLine(bindLineDto: BindLineDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeUserControllerBindLine(bindLineDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeUserControllerGetMe(options?: RawAxiosRequestConfig): AxiosPromise<GetMyProfileResult> {
            return localVarFp.employeeUserControllerGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeUserControllerIsLineBound(options?: RawAxiosRequestConfig): AxiosPromise<CheckLineBoundResult> {
            return localVarFp.employeeUserControllerIsLineBound(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeUserControllerUnbindLine(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeUserControllerUnbindLine(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeUsersMeApi - object-oriented interface
 * @export
 * @class EmployeeUsersMeApi
 * @extends {BaseAPI}
 */
export class EmployeeUsersMeApi extends BaseAPI {
    /**
     * 
     * @param {BindLineDto} bindLineDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeUsersMeApi
     */
    public employeeUserControllerBindLine(bindLineDto: BindLineDto, options?: RawAxiosRequestConfig) {
        return EmployeeUsersMeApiFp(this.configuration).employeeUserControllerBindLine(bindLineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeUsersMeApi
     */
    public employeeUserControllerGetMe(options?: RawAxiosRequestConfig) {
        return EmployeeUsersMeApiFp(this.configuration).employeeUserControllerGetMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeUsersMeApi
     */
    public employeeUserControllerIsLineBound(options?: RawAxiosRequestConfig) {
        return EmployeeUsersMeApiFp(this.configuration).employeeUserControllerIsLineBound(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeUsersMeApi
     */
    public employeeUserControllerUnbindLine(options?: RawAxiosRequestConfig) {
        return EmployeeUsersMeApiFp(this.configuration).employeeUserControllerUnbindLine(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployeesApi - axios parameter creator
 * @export
 */
export const EmployeesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BulkCreateEmployeesDto} bulkCreateEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerBulkCreateEmployees: async (bulkCreateEmployeesDto: BulkCreateEmployeesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreateEmployeesDto' is not null or undefined
            assertParamExists('employeeControllerBulkCreateEmployees', 'bulkCreateEmployeesDto', bulkCreateEmployeesDto)
            const localVarPath = `/employees/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateEmployeesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateEmployeeDto} createEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerCreateEmployee: async (createEmployeeDto: CreateEmployeeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeeDto' is not null or undefined
            assertParamExists('employeeControllerCreateEmployee', 'createEmployeeDto', createEmployeeDto)
            const localVarPath = `/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerFindEmployees: async (skip?: number, take?: number, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerListEmployeeTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employees/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmployeeControllerListEmployeesDepartmentTypeEnum} [departmentType] 部門類型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerListEmployees: async (departmentType?: EmployeeControllerListEmployeesDepartmentTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employees/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentType !== undefined) {
                localVarQueryParameter['departmentType'] = departmentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ToggleEmployeeStateDto} toggleEmployeeStateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerToggleEmployeeState: async (id: string, toggleEmployeeStateDto: ToggleEmployeeStateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeeControllerToggleEmployeeState', 'id', id)
            // verify required parameter 'toggleEmployeeStateDto' is not null or undefined
            assertParamExists('employeeControllerToggleEmployeeState', 'toggleEmployeeStateDto', toggleEmployeeStateDto)
            const localVarPath = `/employees/{id}/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleEmployeeStateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerUpdateEmployee: async (id: string, updateEmployeeDto: UpdateEmployeeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeeControllerUpdateEmployee', 'id', id)
            // verify required parameter 'updateEmployeeDto' is not null or undefined
            assertParamExists('employeeControllerUpdateEmployee', 'updateEmployeeDto', updateEmployeeDto)
            const localVarPath = `/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeRemittanceInfoDto} updateEmployeeRemittanceInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerUpdateEmployeeRemittanceInfo: async (id: string, updateEmployeeRemittanceInfoDto: UpdateEmployeeRemittanceInfoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('employeeControllerUpdateEmployeeRemittanceInfo', 'id', id)
            // verify required parameter 'updateEmployeeRemittanceInfoDto' is not null or undefined
            assertParamExists('employeeControllerUpdateEmployeeRemittanceInfo', 'updateEmployeeRemittanceInfoDto', updateEmployeeRemittanceInfoDto)
            const localVarPath = `/employees/{id}/remittance-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeRemittanceInfoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeesApi - functional programming interface
 * @export
 */
export const EmployeesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BulkCreateEmployeesDto} bulkCreateEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeControllerBulkCreateEmployees(bulkCreateEmployeesDto: BulkCreateEmployeesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateEmployeesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeControllerBulkCreateEmployees(bulkCreateEmployeesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.employeeControllerBulkCreateEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateEmployeeDto} createEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeControllerCreateEmployee(createEmployeeDto: CreateEmployeeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEmployeeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeControllerCreateEmployee(createEmployeeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.employeeControllerCreateEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeControllerFindEmployees(skip?: number, take?: number, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindEmployeesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeControllerFindEmployees(skip, take, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.employeeControllerFindEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeControllerListEmployeeTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEmployeeTypesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeControllerListEmployeeTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.employeeControllerListEmployeeTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmployeeControllerListEmployeesDepartmentTypeEnum} [departmentType] 部門類型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeControllerListEmployees(departmentType?: EmployeeControllerListEmployeesDepartmentTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEmployeesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeControllerListEmployees(departmentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.employeeControllerListEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ToggleEmployeeStateDto} toggleEmployeeStateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeControllerToggleEmployeeState(id: string, toggleEmployeeStateDto: ToggleEmployeeStateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateEmployeeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeControllerToggleEmployeeState(id, toggleEmployeeStateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.employeeControllerToggleEmployeeState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeControllerUpdateEmployee(id: string, updateEmployeeDto: UpdateEmployeeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateEmployeeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeControllerUpdateEmployee(id, updateEmployeeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.employeeControllerUpdateEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeRemittanceInfoDto} updateEmployeeRemittanceInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeControllerUpdateEmployeeRemittanceInfo(id: string, updateEmployeeRemittanceInfoDto: UpdateEmployeeRemittanceInfoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeControllerUpdateEmployeeRemittanceInfo(id, updateEmployeeRemittanceInfoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.employeeControllerUpdateEmployeeRemittanceInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeesApi - factory interface
 * @export
 */
export const EmployeesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeesApiFp(configuration)
    return {
        /**
         * 
         * @param {BulkCreateEmployeesDto} bulkCreateEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerBulkCreateEmployees(bulkCreateEmployeesDto: BulkCreateEmployeesDto, options?: RawAxiosRequestConfig): AxiosPromise<BulkCreateEmployeesResponseDto> {
            return localVarFp.employeeControllerBulkCreateEmployees(bulkCreateEmployeesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateEmployeeDto} createEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerCreateEmployee(createEmployeeDto: CreateEmployeeDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateEmployeeResponseDto> {
            return localVarFp.employeeControllerCreateEmployee(createEmployeeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerFindEmployees(skip?: number, take?: number, keyword?: string, options?: RawAxiosRequestConfig): AxiosPromise<FindEmployeesResult> {
            return localVarFp.employeeControllerFindEmployees(skip, take, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerListEmployeeTypes(options?: RawAxiosRequestConfig): AxiosPromise<ListEmployeeTypesResult> {
            return localVarFp.employeeControllerListEmployeeTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeControllerListEmployeesDepartmentTypeEnum} [departmentType] 部門類型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerListEmployees(departmentType?: EmployeeControllerListEmployeesDepartmentTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<ListEmployeesResult> {
            return localVarFp.employeeControllerListEmployees(departmentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ToggleEmployeeStateDto} toggleEmployeeStateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerToggleEmployeeState(id: string, toggleEmployeeStateDto: ToggleEmployeeStateDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateEmployeeResponseDto> {
            return localVarFp.employeeControllerToggleEmployeeState(id, toggleEmployeeStateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerUpdateEmployee(id: string, updateEmployeeDto: UpdateEmployeeDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateEmployeeResponseDto> {
            return localVarFp.employeeControllerUpdateEmployee(id, updateEmployeeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeRemittanceInfoDto} updateEmployeeRemittanceInfoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeControllerUpdateEmployeeRemittanceInfo(id: string, updateEmployeeRemittanceInfoDto: UpdateEmployeeRemittanceInfoDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.employeeControllerUpdateEmployeeRemittanceInfo(id, updateEmployeeRemittanceInfoDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeesApi - object-oriented interface
 * @export
 * @class EmployeesApi
 * @extends {BaseAPI}
 */
export class EmployeesApi extends BaseAPI {
    /**
     * 
     * @param {BulkCreateEmployeesDto} bulkCreateEmployeesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public employeeControllerBulkCreateEmployees(bulkCreateEmployeesDto: BulkCreateEmployeesDto, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).employeeControllerBulkCreateEmployees(bulkCreateEmployeesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateEmployeeDto} createEmployeeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public employeeControllerCreateEmployee(createEmployeeDto: CreateEmployeeDto, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).employeeControllerCreateEmployee(createEmployeeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public employeeControllerFindEmployees(skip?: number, take?: number, keyword?: string, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).employeeControllerFindEmployees(skip, take, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public employeeControllerListEmployeeTypes(options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).employeeControllerListEmployeeTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeControllerListEmployeesDepartmentTypeEnum} [departmentType] 部門類型
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public employeeControllerListEmployees(departmentType?: EmployeeControllerListEmployeesDepartmentTypeEnum, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).employeeControllerListEmployees(departmentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ToggleEmployeeStateDto} toggleEmployeeStateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public employeeControllerToggleEmployeeState(id: string, toggleEmployeeStateDto: ToggleEmployeeStateDto, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).employeeControllerToggleEmployeeState(id, toggleEmployeeStateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateEmployeeDto} updateEmployeeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public employeeControllerUpdateEmployee(id: string, updateEmployeeDto: UpdateEmployeeDto, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).employeeControllerUpdateEmployee(id, updateEmployeeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateEmployeeRemittanceInfoDto} updateEmployeeRemittanceInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public employeeControllerUpdateEmployeeRemittanceInfo(id: string, updateEmployeeRemittanceInfoDto: UpdateEmployeeRemittanceInfoDto, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).employeeControllerUpdateEmployeeRemittanceInfo(id, updateEmployeeRemittanceInfoDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const EmployeeControllerListEmployeesDepartmentTypeEnum = {
    Driver: 'DRIVER',
    LocationAssistant: 'LOCATION_ASSISTANT'
} as const;
export type EmployeeControllerListEmployeesDepartmentTypeEnum = typeof EmployeeControllerListEmployeesDepartmentTypeEnum[keyof typeof EmployeeControllerListEmployeesDepartmentTypeEnum];


/**
 * EnterpriseOrdersApi - axios parameter creator
 * @export
 */
export const EnterpriseOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateOrderDto} createOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerCreateOrder: async (createOrderDto: CreateOrderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderDto' is not null or undefined
            assertParamExists('enterpriseOrderControllerCreateOrder', 'createOrderDto', createOrderDto)
            const localVarPath = `/enterprise-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerDeleteOrder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enterpriseOrderControllerDeleteOrder', 'id', id)
            const localVarPath = `/enterprise-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerExportEnterpriseStatement: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enterpriseOrderControllerExportEnterpriseStatement', 'id', id)
            const localVarPath = `/enterprise-orders/{id}/export-enterprise-statement`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerExportProviderStatement: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enterpriseOrderControllerExportProviderStatement', 'id', id)
            const localVarPath = `/enterprise-orders/{id}/export-provider-statement`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<any>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerGetOrders: async (skip?: number, take?: number, status?: Array<any>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/enterprise-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerUpdateOrder: async (id: string, updateOrderDto: UpdateOrderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enterpriseOrderControllerUpdateOrder', 'id', id)
            // verify required parameter 'updateOrderDto' is not null or undefined
            assertParamExists('enterpriseOrderControllerUpdateOrder', 'updateOrderDto', updateOrderDto)
            const localVarPath = `/enterprise-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnterpriseOrdersApi - functional programming interface
 * @export
 */
export const EnterpriseOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnterpriseOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateOrderDto} createOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseOrderControllerCreateOrder(createOrderDto: CreateOrderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseOrderControllerCreateOrder(createOrderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseOrdersApi.enterpriseOrderControllerCreateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseOrderControllerDeleteOrder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseOrderControllerDeleteOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseOrdersApi.enterpriseOrderControllerDeleteOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseOrderControllerExportEnterpriseStatement(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseOrderControllerExportEnterpriseStatement(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseOrdersApi.enterpriseOrderControllerExportEnterpriseStatement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseOrderControllerExportProviderStatement(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseOrderControllerExportProviderStatement(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseOrdersApi.enterpriseOrderControllerExportProviderStatement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<any>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseOrderControllerGetOrders(skip?: number, take?: number, status?: Array<any>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEnterpriseOrdersResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseOrderControllerGetOrders(skip, take, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseOrdersApi.enterpriseOrderControllerGetOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterpriseOrderControllerUpdateOrder(id: string, updateOrderDto: UpdateOrderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterpriseOrderControllerUpdateOrder(id, updateOrderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseOrdersApi.enterpriseOrderControllerUpdateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnterpriseOrdersApi - factory interface
 * @export
 */
export const EnterpriseOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnterpriseOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateOrderDto} createOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerCreateOrder(createOrderDto: CreateOrderDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseOrderControllerCreateOrder(createOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerDeleteOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseOrderControllerDeleteOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerExportEnterpriseStatement(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseOrderControllerExportEnterpriseStatement(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerExportProviderStatement(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseOrderControllerExportProviderStatement(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<any>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerGetOrders(skip?: number, take?: number, status?: Array<any>, options?: RawAxiosRequestConfig): AxiosPromise<GetEnterpriseOrdersResult> {
            return localVarFp.enterpriseOrderControllerGetOrders(skip, take, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterpriseOrderControllerUpdateOrder(id: string, updateOrderDto: UpdateOrderDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enterpriseOrderControllerUpdateOrder(id, updateOrderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnterpriseOrdersApi - object-oriented interface
 * @export
 * @class EnterpriseOrdersApi
 * @extends {BaseAPI}
 */
export class EnterpriseOrdersApi extends BaseAPI {
    /**
     * 
     * @param {CreateOrderDto} createOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseOrdersApi
     */
    public enterpriseOrderControllerCreateOrder(createOrderDto: CreateOrderDto, options?: RawAxiosRequestConfig) {
        return EnterpriseOrdersApiFp(this.configuration).enterpriseOrderControllerCreateOrder(createOrderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseOrdersApi
     */
    public enterpriseOrderControllerDeleteOrder(id: string, options?: RawAxiosRequestConfig) {
        return EnterpriseOrdersApiFp(this.configuration).enterpriseOrderControllerDeleteOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseOrdersApi
     */
    public enterpriseOrderControllerExportEnterpriseStatement(id: string, options?: RawAxiosRequestConfig) {
        return EnterpriseOrdersApiFp(this.configuration).enterpriseOrderControllerExportEnterpriseStatement(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseOrdersApi
     */
    public enterpriseOrderControllerExportProviderStatement(id: string, options?: RawAxiosRequestConfig) {
        return EnterpriseOrdersApiFp(this.configuration).enterpriseOrderControllerExportProviderStatement(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {Array<any>} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseOrdersApi
     */
    public enterpriseOrderControllerGetOrders(skip?: number, take?: number, status?: Array<any>, options?: RawAxiosRequestConfig) {
        return EnterpriseOrdersApiFp(this.configuration).enterpriseOrderControllerGetOrders(skip, take, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateOrderDto} updateOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseOrdersApi
     */
    public enterpriseOrderControllerUpdateOrder(id: string, updateOrderDto: UpdateOrderDto, options?: RawAxiosRequestConfig) {
        return EnterpriseOrdersApiFp(this.configuration).enterpriseOrderControllerUpdateOrder(id, updateOrderDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationAssistantReportShiftsApi - axios parameter creator
 * @export
 */
export const LocationAssistantReportShiftsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startTime] Start time for filtering shifts (ISO 8601 format)
         * @param {string} [endTime] End time for filtering shifts (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantReportShiftControllerFindReportedShift: async (startTime?: string, endTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/location-assistant-report-shifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReportShiftStatusDto} updateReportShiftStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantReportShiftControllerUpdateReportShiftStatus: async (updateReportShiftStatusDto: UpdateReportShiftStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateReportShiftStatusDto' is not null or undefined
            assertParamExists('locationAssistantReportShiftControllerUpdateReportShiftStatus', 'updateReportShiftStatusDto', updateReportShiftStatusDto)
            const localVarPath = `/location-assistant-report-shifts/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportShiftStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationAssistantReportShiftsApi - functional programming interface
 * @export
 */
export const LocationAssistantReportShiftsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationAssistantReportShiftsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [startTime] Start time for filtering shifts (ISO 8601 format)
         * @param {string} [endTime] End time for filtering shifts (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantReportShiftControllerFindReportedShift(startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindLocationAssistantReportShiftsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantReportShiftControllerFindReportedShift(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantReportShiftsApi.locationAssistantReportShiftControllerFindReportedShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateReportShiftStatusDto} updateReportShiftStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantReportShiftControllerUpdateReportShiftStatus(updateReportShiftStatusDto: UpdateReportShiftStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantReportShiftControllerUpdateReportShiftStatus(updateReportShiftStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantReportShiftsApi.locationAssistantReportShiftControllerUpdateReportShiftStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationAssistantReportShiftsApi - factory interface
 * @export
 */
export const LocationAssistantReportShiftsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationAssistantReportShiftsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [startTime] Start time for filtering shifts (ISO 8601 format)
         * @param {string} [endTime] End time for filtering shifts (ISO 8601 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantReportShiftControllerFindReportedShift(startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): AxiosPromise<FindLocationAssistantReportShiftsResult> {
            return localVarFp.locationAssistantReportShiftControllerFindReportedShift(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateReportShiftStatusDto} updateReportShiftStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantReportShiftControllerUpdateReportShiftStatus(updateReportShiftStatusDto: UpdateReportShiftStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationAssistantReportShiftControllerUpdateReportShiftStatus(updateReportShiftStatusDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationAssistantReportShiftsApi - object-oriented interface
 * @export
 * @class LocationAssistantReportShiftsApi
 * @extends {BaseAPI}
 */
export class LocationAssistantReportShiftsApi extends BaseAPI {
    /**
     * 
     * @param {string} [startTime] Start time for filtering shifts (ISO 8601 format)
     * @param {string} [endTime] End time for filtering shifts (ISO 8601 format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantReportShiftsApi
     */
    public locationAssistantReportShiftControllerFindReportedShift(startTime?: string, endTime?: string, options?: RawAxiosRequestConfig) {
        return LocationAssistantReportShiftsApiFp(this.configuration).locationAssistantReportShiftControllerFindReportedShift(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateReportShiftStatusDto} updateReportShiftStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantReportShiftsApi
     */
    public locationAssistantReportShiftControllerUpdateReportShiftStatus(updateReportShiftStatusDto: UpdateReportShiftStatusDto, options?: RawAxiosRequestConfig) {
        return LocationAssistantReportShiftsApiFp(this.configuration).locationAssistantReportShiftControllerUpdateReportShiftStatus(updateReportShiftStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationAssistantShiftScheduleSettingsApi - axios parameter creator
 * @export
 */
export const LocationAssistantShiftScheduleSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 取得所有排班設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleSettingsControllerGetSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/location-assistant-shift-schedule/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新排班設定
         * @param {string} key 設定鍵值
         * @param {UpdateLocationAssistantShiftScheduleSettingDto} updateLocationAssistantShiftScheduleSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleSettingsControllerUpdateSetting: async (key: string, updateLocationAssistantShiftScheduleSettingDto: UpdateLocationAssistantShiftScheduleSettingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleSettingsControllerUpdateSetting', 'key', key)
            // verify required parameter 'updateLocationAssistantShiftScheduleSettingDto' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleSettingsControllerUpdateSetting', 'updateLocationAssistantShiftScheduleSettingDto', updateLocationAssistantShiftScheduleSettingDto)
            const localVarPath = `/location-assistant-shift-schedule/settings/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationAssistantShiftScheduleSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationAssistantShiftScheduleSettingsApi - functional programming interface
 * @export
 */
export const LocationAssistantShiftScheduleSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationAssistantShiftScheduleSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 取得所有排班設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleSettingsControllerGetSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationAssistantShiftScheduleSettingResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleSettingsControllerGetSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftScheduleSettingsApi.locationAssistantShiftScheduleSettingsControllerGetSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新排班設定
         * @param {string} key 設定鍵值
         * @param {UpdateLocationAssistantShiftScheduleSettingDto} updateLocationAssistantShiftScheduleSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleSettingsControllerUpdateSetting(key: string, updateLocationAssistantShiftScheduleSettingDto: UpdateLocationAssistantShiftScheduleSettingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleSettingsControllerUpdateSetting(key, updateLocationAssistantShiftScheduleSettingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftScheduleSettingsApi.locationAssistantShiftScheduleSettingsControllerUpdateSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationAssistantShiftScheduleSettingsApi - factory interface
 * @export
 */
export const LocationAssistantShiftScheduleSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationAssistantShiftScheduleSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary 取得所有排班設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleSettingsControllerGetSettings(options?: RawAxiosRequestConfig): AxiosPromise<LocationAssistantShiftScheduleSettingResult> {
            return localVarFp.locationAssistantShiftScheduleSettingsControllerGetSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新排班設定
         * @param {string} key 設定鍵值
         * @param {UpdateLocationAssistantShiftScheduleSettingDto} updateLocationAssistantShiftScheduleSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleSettingsControllerUpdateSetting(key: string, updateLocationAssistantShiftScheduleSettingDto: UpdateLocationAssistantShiftScheduleSettingDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationAssistantShiftScheduleSettingsControllerUpdateSetting(key, updateLocationAssistantShiftScheduleSettingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationAssistantShiftScheduleSettingsApi - object-oriented interface
 * @export
 * @class LocationAssistantShiftScheduleSettingsApi
 * @extends {BaseAPI}
 */
export class LocationAssistantShiftScheduleSettingsApi extends BaseAPI {
    /**
     * 
     * @summary 取得所有排班設定
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftScheduleSettingsApi
     */
    public locationAssistantShiftScheduleSettingsControllerGetSettings(options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftScheduleSettingsApiFp(this.configuration).locationAssistantShiftScheduleSettingsControllerGetSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新排班設定
     * @param {string} key 設定鍵值
     * @param {UpdateLocationAssistantShiftScheduleSettingDto} updateLocationAssistantShiftScheduleSettingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftScheduleSettingsApi
     */
    public locationAssistantShiftScheduleSettingsControllerUpdateSetting(key: string, updateLocationAssistantShiftScheduleSettingDto: UpdateLocationAssistantShiftScheduleSettingDto, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftScheduleSettingsApiFp(this.configuration).locationAssistantShiftScheduleSettingsControllerUpdateSetting(key, updateLocationAssistantShiftScheduleSettingDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationAssistantShiftSchedulesApi - axios parameter creator
 * @export
 */
export const LocationAssistantShiftSchedulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerCreateSchedule: async (createScheduleDto: CreateScheduleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createScheduleDto' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerCreateSchedule', 'createScheduleDto', createScheduleDto)
            const localVarPath = `/location-assistant-shift-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerDeleteSchedule: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerDeleteSchedule', 'id', id)
            const localVarPath = `/location-assistant-shift-schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerExportSchedule: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerExportSchedule', 'id', id)
            const localVarPath = `/location-assistant-shift-schedules/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} beforeTime Get employee location history before this time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerFindEmployeeLocationHistory: async (beforeTime: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'beforeTime' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerFindEmployeeLocationHistory', 'beforeTime', beforeTime)
            const localVarPath = `/location-assistant-shift-schedules/employee-location-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (beforeTime !== undefined) {
                localVarQueryParameter['beforeTime'] = beforeTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerFindSchedule: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerFindSchedule', 'id', id)
            const localVarPath = `/location-assistant-shift-schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [start] 開始日期
         * @param {string} [end] 結束日期
         * @param {number} [skip] 跳過筆數
         * @param {number} [take] 取得筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerFindSchedules: async (start?: string, end?: string, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/location-assistant-shift-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ToggleScheduleDateIsWaitingForArrangeDto} toggleScheduleDateIsWaitingForArrangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange: async (id: string, toggleScheduleDateIsWaitingForArrangeDto: ToggleScheduleDateIsWaitingForArrangeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange', 'id', id)
            // verify required parameter 'toggleScheduleDateIsWaitingForArrangeDto' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange', 'toggleScheduleDateIsWaitingForArrangeDto', toggleScheduleDateIsWaitingForArrangeDto)
            const localVarPath = `/location-assistant-shift-schedules/{id}/dates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleScheduleDateIsWaitingForArrangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateScheduleDto} updateScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerUpdateSchedule: async (id: string, updateScheduleDto: UpdateScheduleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerUpdateSchedule', 'id', id)
            // verify required parameter 'updateScheduleDto' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerUpdateSchedule', 'updateScheduleDto', updateScheduleDto)
            const localVarPath = `/location-assistant-shift-schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateScheduleShiftDto} updateScheduleShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerUpdateScheduleShift: async (id: string, updateScheduleShiftDto: UpdateScheduleShiftDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerUpdateScheduleShift', 'id', id)
            // verify required parameter 'updateScheduleShiftDto' is not null or undefined
            assertParamExists('locationAssistantShiftScheduleControllerUpdateScheduleShift', 'updateScheduleShiftDto', updateScheduleShiftDto)
            const localVarPath = `/location-assistant-shift-schedules/{id}/shift`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateScheduleShiftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationAssistantShiftSchedulesApi - functional programming interface
 * @export
 */
export const LocationAssistantShiftSchedulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationAssistantShiftSchedulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerCreateSchedule(createScheduleDto: CreateScheduleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerCreateSchedule(createScheduleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerCreateSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerDeleteSchedule(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerDeleteSchedule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerDeleteSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerExportSchedule(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportLocationAssistantShiftScheduleResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerExportSchedule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerExportSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} beforeTime Get employee location history before this time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerFindEmployeeLocationHistory(beforeTime: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindEmployeeLocationHistoryResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerFindEmployeeLocationHistory(beforeTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerFindEmployeeLocationHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerFindSchedule(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindScheduleByIdResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerFindSchedule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerFindSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [start] 開始日期
         * @param {string} [end] 結束日期
         * @param {number} [skip] 跳過筆數
         * @param {number} [take] 取得筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerFindSchedules(start?: string, end?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindSchedulesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerFindSchedules(start, end, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerFindSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ToggleScheduleDateIsWaitingForArrangeDto} toggleScheduleDateIsWaitingForArrangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange(id: string, toggleScheduleDateIsWaitingForArrangeDto: ToggleScheduleDateIsWaitingForArrangeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange(id, toggleScheduleDateIsWaitingForArrangeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateScheduleDto} updateScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerUpdateSchedule(id: string, updateScheduleDto: UpdateScheduleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerUpdateSchedule(id, updateScheduleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerUpdateSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateScheduleShiftDto} updateScheduleShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssistantShiftScheduleControllerUpdateScheduleShift(id: string, updateScheduleShiftDto: UpdateScheduleShiftDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssistantShiftScheduleControllerUpdateScheduleShift(id, updateScheduleShiftDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationAssistantShiftSchedulesApi.locationAssistantShiftScheduleControllerUpdateScheduleShift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationAssistantShiftSchedulesApi - factory interface
 * @export
 */
export const LocationAssistantShiftSchedulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationAssistantShiftSchedulesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerCreateSchedule(createScheduleDto: CreateScheduleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationAssistantShiftScheduleControllerCreateSchedule(createScheduleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerDeleteSchedule(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationAssistantShiftScheduleControllerDeleteSchedule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerExportSchedule(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ExportLocationAssistantShiftScheduleResult> {
            return localVarFp.locationAssistantShiftScheduleControllerExportSchedule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} beforeTime Get employee location history before this time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerFindEmployeeLocationHistory(beforeTime: string, options?: RawAxiosRequestConfig): AxiosPromise<FindEmployeeLocationHistoryResult> {
            return localVarFp.locationAssistantShiftScheduleControllerFindEmployeeLocationHistory(beforeTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerFindSchedule(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FindScheduleByIdResult> {
            return localVarFp.locationAssistantShiftScheduleControllerFindSchedule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [start] 開始日期
         * @param {string} [end] 結束日期
         * @param {number} [skip] 跳過筆數
         * @param {number} [take] 取得筆數
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerFindSchedules(start?: string, end?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<FindSchedulesResult> {
            return localVarFp.locationAssistantShiftScheduleControllerFindSchedules(start, end, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ToggleScheduleDateIsWaitingForArrangeDto} toggleScheduleDateIsWaitingForArrangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange(id: string, toggleScheduleDateIsWaitingForArrangeDto: ToggleScheduleDateIsWaitingForArrangeDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange(id, toggleScheduleDateIsWaitingForArrangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateScheduleDto} updateScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerUpdateSchedule(id: string, updateScheduleDto: UpdateScheduleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationAssistantShiftScheduleControllerUpdateSchedule(id, updateScheduleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateScheduleShiftDto} updateScheduleShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssistantShiftScheduleControllerUpdateScheduleShift(id: string, updateScheduleShiftDto: UpdateScheduleShiftDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationAssistantShiftScheduleControllerUpdateScheduleShift(id, updateScheduleShiftDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationAssistantShiftSchedulesApi - object-oriented interface
 * @export
 * @class LocationAssistantShiftSchedulesApi
 * @extends {BaseAPI}
 */
export class LocationAssistantShiftSchedulesApi extends BaseAPI {
    /**
     * 
     * @param {CreateScheduleDto} createScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerCreateSchedule(createScheduleDto: CreateScheduleDto, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerCreateSchedule(createScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerDeleteSchedule(id: string, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerDeleteSchedule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerExportSchedule(id: string, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerExportSchedule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} beforeTime Get employee location history before this time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerFindEmployeeLocationHistory(beforeTime: string, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerFindEmployeeLocationHistory(beforeTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerFindSchedule(id: string, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerFindSchedule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [start] 開始日期
     * @param {string} [end] 結束日期
     * @param {number} [skip] 跳過筆數
     * @param {number} [take] 取得筆數
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerFindSchedules(start?: string, end?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerFindSchedules(start, end, skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ToggleScheduleDateIsWaitingForArrangeDto} toggleScheduleDateIsWaitingForArrangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange(id: string, toggleScheduleDateIsWaitingForArrangeDto: ToggleScheduleDateIsWaitingForArrangeDto, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerToggleScheduleDateIsWaitingForArrange(id, toggleScheduleDateIsWaitingForArrangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateScheduleDto} updateScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerUpdateSchedule(id: string, updateScheduleDto: UpdateScheduleDto, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerUpdateSchedule(id, updateScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateScheduleShiftDto} updateScheduleShiftDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationAssistantShiftSchedulesApi
     */
    public locationAssistantShiftScheduleControllerUpdateScheduleShift(id: string, updateScheduleShiftDto: UpdateScheduleShiftDto, options?: RawAxiosRequestConfig) {
        return LocationAssistantShiftSchedulesApiFp(this.configuration).locationAssistantShiftScheduleControllerUpdateScheduleShift(id, updateScheduleShiftDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerCreateLocation: async (createLocationDto: CreateLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLocationDto' is not null or undefined
            assertParamExists('locationControllerCreateLocation', 'createLocationDto', createLocationDto)
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerDeleteLocation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationControllerDeleteLocation', 'id', id)
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerFindLocations: async (skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerListLocations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/locations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerToggleStatus: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationControllerToggleStatus', 'id', id)
            const localVarPath = `/locations/{id}/toggle-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerUpdateLocation: async (id: string, updateLocationDto: UpdateLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationControllerUpdateLocation', 'id', id)
            // verify required parameter 'updateLocationDto' is not null or undefined
            assertParamExists('locationControllerUpdateLocation', 'updateLocationDto', updateLocationDto)
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateLocationTagDto} createLocationTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTagControllerCreateLocationTag: async (createLocationTagDto: CreateLocationTagDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLocationTagDto' is not null or undefined
            assertParamExists('locationTagControllerCreateLocationTag', 'createLocationTagDto', createLocationTagDto)
            const localVarPath = `/location_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTagControllerDeleteLocationTag: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationTagControllerDeleteLocationTag', 'id', id)
            const localVarPath = `/location_tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LocationTagControllerGetLocationTagSortByRankEnum} [sortByRank] rank越小 越前面
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTagControllerGetLocationTag: async (sortByRank?: LocationTagControllerGetLocationTagSortByRankEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/location_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortByRank !== undefined) {
                localVarQueryParameter['sortByRank'] = sortByRank;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationTagDto} updateLocationTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTagControllerUpdateLocationTag: async (id: string, updateLocationTagDto: UpdateLocationTagDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationTagControllerUpdateLocationTag', 'id', id)
            // verify required parameter 'updateLocationTagDto' is not null or undefined
            assertParamExists('locationTagControllerUpdateLocationTag', 'updateLocationTagDto', updateLocationTagDto)
            const localVarPath = `/location_tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerCreateLocation(createLocationDto: CreateLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerCreateLocation(createLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationControllerCreateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerDeleteLocation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerDeleteLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationControllerDeleteLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerFindLocations(skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindLocationsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerFindLocations(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationControllerFindLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerListLocations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListLocationsResultDataItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerListLocations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationControllerListLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerToggleStatus(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerToggleStatus(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationControllerToggleStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerUpdateLocation(id: string, updateLocationDto: UpdateLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerUpdateLocation(id, updateLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationControllerUpdateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateLocationTagDto} createLocationTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationTagControllerCreateLocationTag(createLocationTagDto: CreateLocationTagDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationTagControllerCreateLocationTag(createLocationTagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationTagControllerCreateLocationTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationTagControllerDeleteLocationTag(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationTagControllerDeleteLocationTag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationTagControllerDeleteLocationTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LocationTagControllerGetLocationTagSortByRankEnum} [sortByRank] rank越小 越前面
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationTagControllerGetLocationTag(sortByRank?: LocationTagControllerGetLocationTagSortByRankEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationTagControllerGetLocationTag(sortByRank, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationTagControllerGetLocationTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationTagDto} updateLocationTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationTagControllerUpdateLocationTag(id: string, updateLocationTagDto: UpdateLocationTagDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationTagControllerUpdateLocationTag(id, updateLocationTagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.locationTagControllerUpdateLocationTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerCreateLocation(createLocationDto: CreateLocationDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationControllerCreateLocation(createLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerDeleteLocation(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationControllerDeleteLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerFindLocations(skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<FindLocationsResult> {
            return localVarFp.locationControllerFindLocations(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerListLocations(options?: RawAxiosRequestConfig): AxiosPromise<Array<ListLocationsResultDataItem>> {
            return localVarFp.locationControllerListLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerToggleStatus(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationControllerToggleStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerUpdateLocation(id: string, updateLocationDto: UpdateLocationDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationControllerUpdateLocation(id, updateLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateLocationTagDto} createLocationTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTagControllerCreateLocationTag(createLocationTagDto: CreateLocationTagDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationTagControllerCreateLocationTag(createLocationTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTagControllerDeleteLocationTag(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationTagControllerDeleteLocationTag(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LocationTagControllerGetLocationTagSortByRankEnum} [sortByRank] rank越小 越前面
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTagControllerGetLocationTag(sortByRank?: LocationTagControllerGetLocationTagSortByRankEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationTagControllerGetLocationTag(sortByRank, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationTagDto} updateLocationTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTagControllerUpdateLocationTag(id: string, updateLocationTagDto: UpdateLocationTagDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.locationTagControllerUpdateLocationTag(id, updateLocationTagDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @param {CreateLocationDto} createLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerCreateLocation(createLocationDto: CreateLocationDto, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerCreateLocation(createLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerDeleteLocation(id: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerDeleteLocation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerFindLocations(skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerFindLocations(skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerListLocations(options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerListLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerToggleStatus(id: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerToggleStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateLocationDto} updateLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerUpdateLocation(id: string, updateLocationDto: UpdateLocationDto, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerUpdateLocation(id, updateLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateLocationTagDto} createLocationTagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationTagControllerCreateLocationTag(createLocationTagDto: CreateLocationTagDto, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationTagControllerCreateLocationTag(createLocationTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationTagControllerDeleteLocationTag(id: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationTagControllerDeleteLocationTag(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationTagControllerGetLocationTagSortByRankEnum} [sortByRank] rank越小 越前面
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationTagControllerGetLocationTag(sortByRank?: LocationTagControllerGetLocationTagSortByRankEnum, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationTagControllerGetLocationTag(sortByRank, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateLocationTagDto} updateLocationTagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationTagControllerUpdateLocationTag(id: string, updateLocationTagDto: UpdateLocationTagDto, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationTagControllerUpdateLocationTag(id, updateLocationTagDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const LocationTagControllerGetLocationTagSortByRankEnum = {
    True: 'true',
    False: 'false'
} as const;
export type LocationTagControllerGetLocationTagSortByRankEnum = typeof LocationTagControllerGetLocationTagSortByRankEnum[keyof typeof LocationTagControllerGetLocationTagSortByRankEnum];


/**
 * OrderItemsApi - axios parameter creator
 * @export
 */
export const OrderItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {RefundOrderItemDto} refundOrderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderItemControllerRefund: async (id: string, refundOrderItemDto: RefundOrderItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderItemControllerRefund', 'id', id)
            // verify required parameter 'refundOrderItemDto' is not null or undefined
            assertParamExists('orderItemControllerRefund', 'refundOrderItemDto', refundOrderItemDto)
            const localVarPath = `/order_items/refund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundOrderItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderItemControllerRevokeRefund: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderItemControllerRevokeRefund', 'id', id)
            const localVarPath = `/order_items/revoke_refund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOrderItemDto} updateOrderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderItemControllerUpdateOrderItem: async (id: string, updateOrderItemDto: UpdateOrderItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderItemControllerUpdateOrderItem', 'id', id)
            // verify required parameter 'updateOrderItemDto' is not null or undefined
            assertParamExists('orderItemControllerUpdateOrderItem', 'updateOrderItemDto', updateOrderItemDto)
            const localVarPath = `/order_items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderItemsApi - functional programming interface
 * @export
 */
export const OrderItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {RefundOrderItemDto} refundOrderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderItemControllerRefund(id: string, refundOrderItemDto: RefundOrderItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderItemControllerRefund(id, refundOrderItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.orderItemControllerRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderItemControllerRevokeRefund(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderItemControllerRevokeRefund(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.orderItemControllerRevokeRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOrderItemDto} updateOrderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderItemControllerUpdateOrderItem(id: string, updateOrderItemDto: UpdateOrderItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderItemControllerUpdateOrderItem(id, updateOrderItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderItemsApi.orderItemControllerUpdateOrderItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderItemsApi - factory interface
 * @export
 */
export const OrderItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {RefundOrderItemDto} refundOrderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderItemControllerRefund(id: string, refundOrderItemDto: RefundOrderItemDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderItemControllerRefund(id, refundOrderItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderItemControllerRevokeRefund(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderItemControllerRevokeRefund(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateOrderItemDto} updateOrderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderItemControllerUpdateOrderItem(id: string, updateOrderItemDto: UpdateOrderItemDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderItemControllerUpdateOrderItem(id, updateOrderItemDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderItemsApi - object-oriented interface
 * @export
 * @class OrderItemsApi
 * @extends {BaseAPI}
 */
export class OrderItemsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {RefundOrderItemDto} refundOrderItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderItemsApi
     */
    public orderItemControllerRefund(id: string, refundOrderItemDto: RefundOrderItemDto, options?: RawAxiosRequestConfig) {
        return OrderItemsApiFp(this.configuration).orderItemControllerRefund(id, refundOrderItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderItemsApi
     */
    public orderItemControllerRevokeRefund(id: string, options?: RawAxiosRequestConfig) {
        return OrderItemsApiFp(this.configuration).orderItemControllerRevokeRefund(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateOrderItemDto} updateOrderItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderItemsApi
     */
    public orderItemControllerUpdateOrderItem(id: string, updateOrderItemDto: UpdateOrderItemDto, options?: RawAxiosRequestConfig) {
        return OrderItemsApiFp(this.configuration).orderItemControllerUpdateOrderItem(id, updateOrderItemDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssignProvidersToImportDto} assignProvidersToImportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAssignProvidersToImport: async (assignProvidersToImportDto: AssignProvidersToImportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignProvidersToImportDto' is not null or undefined
            assertParamExists('orderControllerAssignProvidersToImport', 'assignProvidersToImportDto', assignProvidersToImportDto)
            const localVarPath = `/orders/assign-providers-to-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignProvidersToImportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerExportMenu: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('orderControllerExportMenu', 'date', date)
            const localVarPath = `/orders/export_menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} timeRange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerExportOrders: async (timeRange: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeRange' is not null or undefined
            assertParamExists('orderControllerExportOrders', 'timeRange', timeRange)
            const localVarPath = `/orders/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeRange) {
                localVarQueryParameter['timeRange'] = timeRange;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {Array<string>} locationIds 
         * @param {string} layoutType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerExportPosData: async (date: string, locationIds: Array<string>, layoutType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('orderControllerExportPosData', 'date', date)
            // verify required parameter 'locationIds' is not null or undefined
            assertParamExists('orderControllerExportPosData', 'locationIds', locationIds)
            // verify required parameter 'layoutType' is not null or undefined
            assertParamExists('orderControllerExportPosData', 'layoutType', layoutType)
            const localVarPath = `/orders/export_pos_data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }

            if (layoutType !== undefined) {
                localVarQueryParameter['layoutType'] = layoutType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} action 
         * @param {FinalOrderActionDto} finalOrderActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerFinalOrderAction: async (providerId: string, action: string, finalOrderActionDto: FinalOrderActionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('orderControllerFinalOrderAction', 'providerId', providerId)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('orderControllerFinalOrderAction', 'action', action)
            // verify required parameter 'finalOrderActionDto' is not null or undefined
            assertParamExists('orderControllerFinalOrderAction', 'finalOrderActionDto', finalOrderActionDto)
            const localVarPath = `/orders/providers/{providerId}/action-status/{action}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)))
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalOrderActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {string} [startTime] 
         * @param {string} [endTime] 
         * @param {Array<string>} [address] 
         * @param {Array<string>} [redeemTime] 
         * @param {Array<string>} [redeemTimeRange] 
         * @param {Array<string>} [state] 
         * @param {string} [keyword] 
         * @param {Array<string>} [providerNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerFindOrders: async (take?: number, skip?: number, startTime?: string, endTime?: string, address?: Array<string>, redeemTime?: Array<string>, redeemTimeRange?: Array<string>, state?: Array<string>, keyword?: string, providerNames?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (address) {
                localVarQueryParameter['address'] = address;
            }

            if (redeemTime) {
                localVarQueryParameter['redeemTime'] = redeemTime;
            }

            if (redeemTimeRange) {
                localVarQueryParameter['redeemTimeRange'] = redeemTimeRange;
            }

            if (state) {
                localVarQueryParameter['state'] = state;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (providerNames) {
                localVarQueryParameter['providerNames'] = providerNames;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetFinalOrderAction: async (providerId: string, time: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('orderControllerGetFinalOrderAction', 'providerId', providerId)
            // verify required parameter 'time' is not null or undefined
            assertParamExists('orderControllerGetFinalOrderAction', 'time', time)
            const localVarPath = `/orders/providers/{providerId}/action-status`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersByProvider: async (providerId: string, time: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('orderControllerGetOrdersByProvider', 'providerId', providerId)
            // verify required parameter 'time' is not null or undefined
            assertParamExists('orderControllerGetOrdersByProvider', 'time', time)
            const localVarPath = `/orders/providers/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerImportOrders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} providerId 
         * @param {ImportOrdersByProviderDto} importOrdersByProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerImportOrdersByProvider: async (providerId: string, importOrdersByProviderDto: ImportOrdersByProviderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('orderControllerImportOrdersByProvider', 'providerId', providerId)
            // verify required parameter 'importOrdersByProviderDto' is not null or undefined
            assertParamExists('orderControllerImportOrdersByProvider', 'importOrdersByProviderDto', importOrdersByProviderDto)
            const localVarPath = `/orders/import-by-provider/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importOrdersByProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNewExportMenu: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('orderControllerNewExportMenu', 'date', date)
            const localVarPath = `/orders/new_export_menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {Array<string>} locationIds 
         * @param {string} layoutType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNewExportPosData: async (date: string, locationIds: Array<string>, layoutType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('orderControllerNewExportPosData', 'date', date)
            // verify required parameter 'locationIds' is not null or undefined
            assertParamExists('orderControllerNewExportPosData', 'locationIds', locationIds)
            // verify required parameter 'layoutType' is not null or undefined
            assertParamExists('orderControllerNewExportPosData', 'layoutType', layoutType)
            const localVarPath = `/orders/new_export_pos_data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }

            if (layoutType !== undefined) {
                localVarQueryParameter['layoutType'] = layoutType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNotifyNotRegisteredProviders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orders/notify-not-registered-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendMenuDto} sendMenuDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerSendMenu: async (sendMenuDto: SendMenuDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendMenuDto' is not null or undefined
            assertParamExists('orderControllerSendMenu', 'sendMenuDto', sendMenuDto)
            const localVarPath = `/orders/send_menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMenuDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssignProvidersToImportDto} assignProvidersToImportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAssignProvidersToImport(assignProvidersToImportDto: AssignProvidersToImportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAssignProvidersToImport(assignProvidersToImportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerAssignProvidersToImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerExportMenu(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerExportMenu(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerExportMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} timeRange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerExportOrders(timeRange: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerExportOrders(timeRange, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerExportOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} date 
         * @param {Array<string>} locationIds 
         * @param {string} layoutType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerExportPosData(date: string, locationIds: Array<string>, layoutType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerExportPosData(date, locationIds, layoutType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerExportPosData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} action 
         * @param {FinalOrderActionDto} finalOrderActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerFinalOrderAction(providerId: string, action: string, finalOrderActionDto: FinalOrderActionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerFinalOrderAction(providerId, action, finalOrderActionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerFinalOrderAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {string} [startTime] 
         * @param {string} [endTime] 
         * @param {Array<string>} [address] 
         * @param {Array<string>} [redeemTime] 
         * @param {Array<string>} [redeemTimeRange] 
         * @param {Array<string>} [state] 
         * @param {string} [keyword] 
         * @param {Array<string>} [providerNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerFindOrders(take?: number, skip?: number, startTime?: string, endTime?: string, address?: Array<string>, redeemTime?: Array<string>, redeemTimeRange?: Array<string>, state?: Array<string>, keyword?: string, providerNames?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerFindOrders(take, skip, startTime, endTime, address, redeemTime, redeemTimeRange, state, keyword, providerNames, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerFindOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetFinalOrderAction(providerId: string, time: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetFinalOrderAction(providerId, time, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerGetFinalOrderAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetOrdersByProvider(providerId: string, time: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetOrdersByProvider(providerId, time, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerGetOrdersByProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerImportOrders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerImportOrders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerImportOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} providerId 
         * @param {ImportOrdersByProviderDto} importOrdersByProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerImportOrdersByProvider(providerId: string, importOrdersByProviderDto: ImportOrdersByProviderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerImportOrdersByProvider(providerId, importOrdersByProviderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerImportOrdersByProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerNewExportMenu(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerNewExportMenu(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerNewExportMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} date 
         * @param {Array<string>} locationIds 
         * @param {string} layoutType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerNewExportPosData(date: string, locationIds: Array<string>, layoutType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerNewExportPosData(date, locationIds, layoutType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerNewExportPosData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerNotifyNotRegisteredProviders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerNotifyNotRegisteredProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerNotifyNotRegisteredProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendMenuDto} sendMenuDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerSendMenu(sendMenuDto: SendMenuDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerSendMenu(sendMenuDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.orderControllerSendMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {AssignProvidersToImportDto} assignProvidersToImportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAssignProvidersToImport(assignProvidersToImportDto: AssignProvidersToImportDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerAssignProvidersToImport(assignProvidersToImportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerExportMenu(date: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerExportMenu(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} timeRange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerExportOrders(timeRange: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerExportOrders(timeRange, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {Array<string>} locationIds 
         * @param {string} layoutType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerExportPosData(date: string, locationIds: Array<string>, layoutType: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerExportPosData(date, locationIds, layoutType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerId 
         * @param {string} action 
         * @param {FinalOrderActionDto} finalOrderActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerFinalOrderAction(providerId: string, action: string, finalOrderActionDto: FinalOrderActionDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerFinalOrderAction(providerId, action, finalOrderActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {string} [startTime] 
         * @param {string} [endTime] 
         * @param {Array<string>} [address] 
         * @param {Array<string>} [redeemTime] 
         * @param {Array<string>} [redeemTimeRange] 
         * @param {Array<string>} [state] 
         * @param {string} [keyword] 
         * @param {Array<string>} [providerNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerFindOrders(take?: number, skip?: number, startTime?: string, endTime?: string, address?: Array<string>, redeemTime?: Array<string>, redeemTimeRange?: Array<string>, state?: Array<string>, keyword?: string, providerNames?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerFindOrders(take, skip, startTime, endTime, address, redeemTime, redeemTimeRange, state, keyword, providerNames, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetFinalOrderAction(providerId: string, time: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerGetFinalOrderAction(providerId, time, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerId 
         * @param {number} time 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrdersByProvider(providerId: string, time: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerGetOrdersByProvider(providerId, time, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerImportOrders(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerImportOrders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} providerId 
         * @param {ImportOrdersByProviderDto} importOrdersByProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerImportOrdersByProvider(providerId: string, importOrdersByProviderDto: ImportOrdersByProviderDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerImportOrdersByProvider(providerId, importOrdersByProviderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNewExportMenu(date: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerNewExportMenu(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {Array<string>} locationIds 
         * @param {string} layoutType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNewExportPosData(date: string, locationIds: Array<string>, layoutType: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerNewExportPosData(date, locationIds, layoutType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNotifyNotRegisteredProviders(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerNotifyNotRegisteredProviders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendMenuDto} sendMenuDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerSendMenu(sendMenuDto: SendMenuDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orderControllerSendMenu(sendMenuDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     * 
     * @param {AssignProvidersToImportDto} assignProvidersToImportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerAssignProvidersToImport(assignProvidersToImportDto: AssignProvidersToImportDto, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerAssignProvidersToImport(assignProvidersToImportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerExportMenu(date: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerExportMenu(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} timeRange 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerExportOrders(timeRange: Array<string>, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerExportOrders(timeRange, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {Array<string>} locationIds 
     * @param {string} layoutType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerExportPosData(date: string, locationIds: Array<string>, layoutType: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerExportPosData(date, locationIds, layoutType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerId 
     * @param {string} action 
     * @param {FinalOrderActionDto} finalOrderActionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerFinalOrderAction(providerId: string, action: string, finalOrderActionDto: FinalOrderActionDto, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerFinalOrderAction(providerId, action, finalOrderActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {string} [startTime] 
     * @param {string} [endTime] 
     * @param {Array<string>} [address] 
     * @param {Array<string>} [redeemTime] 
     * @param {Array<string>} [redeemTimeRange] 
     * @param {Array<string>} [state] 
     * @param {string} [keyword] 
     * @param {Array<string>} [providerNames] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerFindOrders(take?: number, skip?: number, startTime?: string, endTime?: string, address?: Array<string>, redeemTime?: Array<string>, redeemTimeRange?: Array<string>, state?: Array<string>, keyword?: string, providerNames?: Array<string>, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerFindOrders(take, skip, startTime, endTime, address, redeemTime, redeemTimeRange, state, keyword, providerNames, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerId 
     * @param {number} time 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerGetFinalOrderAction(providerId: string, time: number, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerGetFinalOrderAction(providerId, time, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerId 
     * @param {number} time 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerGetOrdersByProvider(providerId: string, time: number, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerGetOrdersByProvider(providerId, time, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerImportOrders(options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerImportOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} providerId 
     * @param {ImportOrdersByProviderDto} importOrdersByProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerImportOrdersByProvider(providerId: string, importOrdersByProviderDto: ImportOrdersByProviderDto, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerImportOrdersByProvider(providerId, importOrdersByProviderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerNewExportMenu(date: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerNewExportMenu(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {Array<string>} locationIds 
     * @param {string} layoutType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerNewExportPosData(date: string, locationIds: Array<string>, layoutType: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerNewExportPosData(date, locationIds, layoutType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerNotifyNotRegisteredProviders(options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerNotifyNotRegisteredProviders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendMenuDto} sendMenuDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public orderControllerSendMenu(sendMenuDto: SendMenuDto, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).orderControllerSendMenu(sendMenuDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionControllerGetPermissions: async (skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionControllerListPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/permissions/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionControllerGetPermissions(skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionControllerGetPermissions(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionControllerGetPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionControllerListPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionControllerListPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionControllerListPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionControllerGetPermissions(skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.permissionControllerGetPermissions(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionControllerListPermissions(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.permissionControllerListPermissions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public permissionControllerGetPermissions(skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).permissionControllerGetPermissions(skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public permissionControllerListPermissions(options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).permissionControllerListPermissions(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerDeleteProduct: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productControllerDeleteProduct', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerExportProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerExportProductsReportHandler: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/export-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {Array<string>} [providerIds] 
         * @param {string} [name] 
         * @param {boolean} [isToppings] 
         * @param {Array<ProductControllerGetProductsStateEnum>} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerGetProducts: async (take?: number, skip?: number, providerIds?: Array<string>, name?: string, isToppings?: boolean, state?: Array<ProductControllerGetProductsStateEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (providerIds) {
                localVarQueryParameter['providerIds'] = providerIds;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (isToppings !== undefined) {
                localVarQueryParameter['isToppings'] = isToppings;
            }

            if (state) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerImportProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerUpdateProduct: async (id: string, updateProductDto: UpdateProductDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productControllerUpdateProduct', 'id', id)
            // verify required parameter 'updateProductDto' is not null or undefined
            assertParamExists('productControllerUpdateProduct', 'updateProductDto', updateProductDto)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerDeleteProduct(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerDeleteProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productControllerDeleteProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerExportProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerExportProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productControllerExportProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerExportProductsReportHandler(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerExportProductsReportHandler(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productControllerExportProductsReportHandler']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {Array<string>} [providerIds] 
         * @param {string} [name] 
         * @param {boolean} [isToppings] 
         * @param {Array<ProductControllerGetProductsStateEnum>} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerGetProducts(take?: number, skip?: number, providerIds?: Array<string>, name?: string, isToppings?: boolean, state?: Array<ProductControllerGetProductsStateEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindProductsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerGetProducts(take, skip, providerIds, name, isToppings, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productControllerGetProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerImportProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerImportProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productControllerImportProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerUpdateProduct(id: string, updateProductDto: UpdateProductDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerUpdateProduct(id, updateProductDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productControllerUpdateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerDeleteProduct(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productControllerDeleteProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerExportProducts(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productControllerExportProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerExportProductsReportHandler(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productControllerExportProductsReportHandler(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {Array<string>} [providerIds] 
         * @param {string} [name] 
         * @param {boolean} [isToppings] 
         * @param {Array<ProductControllerGetProductsStateEnum>} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerGetProducts(take?: number, skip?: number, providerIds?: Array<string>, name?: string, isToppings?: boolean, state?: Array<ProductControllerGetProductsStateEnum>, options?: RawAxiosRequestConfig): AxiosPromise<FindProductsResult> {
            return localVarFp.productControllerGetProducts(take, skip, providerIds, name, isToppings, state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerImportProducts(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productControllerImportProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerUpdateProduct(id: string, updateProductDto: UpdateProductDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productControllerUpdateProduct(id, updateProductDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productControllerDeleteProduct(id: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productControllerDeleteProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productControllerExportProducts(options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productControllerExportProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productControllerExportProductsReportHandler(options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productControllerExportProductsReportHandler(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {Array<string>} [providerIds] 
     * @param {string} [name] 
     * @param {boolean} [isToppings] 
     * @param {Array<ProductControllerGetProductsStateEnum>} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productControllerGetProducts(take?: number, skip?: number, providerIds?: Array<string>, name?: string, isToppings?: boolean, state?: Array<ProductControllerGetProductsStateEnum>, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productControllerGetProducts(take, skip, providerIds, name, isToppings, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productControllerImportProducts(options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productControllerImportProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateProductDto} updateProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productControllerUpdateProduct(id: string, updateProductDto: UpdateProductDto, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productControllerUpdateProduct(id, updateProductDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ProductControllerGetProductsStateEnum = {
    Supplying: 'SUPPLYING',
    Discontinued: 'DISCONTINUED'
} as const;
export type ProductControllerGetProductsStateEnum = typeof ProductControllerGetProductsStateEnum[keyof typeof ProductControllerGetProductsStateEnum];


/**
 * ProviderReceivablePlanApi - axios parameter creator
 * @export
 */
export const ProviderReceivablePlanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerReceivablePlanControllerCreateReceivablePlan: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerReceivablePlanControllerCreateReceivablePlan', 'id', id)
            const localVarPath = `/providers/{id}/receivable-plans`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderReceivablePlanApi - functional programming interface
 * @export
 */
export const ProviderReceivablePlanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderReceivablePlanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerReceivablePlanControllerCreateReceivablePlan(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerReceivablePlanControllerCreateReceivablePlan(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderReceivablePlanApi.providerReceivablePlanControllerCreateReceivablePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderReceivablePlanApi - factory interface
 * @export
 */
export const ProviderReceivablePlanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderReceivablePlanApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerReceivablePlanControllerCreateReceivablePlan(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerReceivablePlanControllerCreateReceivablePlan(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProviderReceivablePlanApi - object-oriented interface
 * @export
 * @class ProviderReceivablePlanApi
 * @extends {BaseAPI}
 */
export class ProviderReceivablePlanApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderReceivablePlanApi
     */
    public providerReceivablePlanControllerCreateReceivablePlan(id: string, options?: RawAxiosRequestConfig) {
        return ProviderReceivablePlanApiFp(this.configuration).providerReceivablePlanControllerCreateReceivablePlan(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProviderStatementsApi - axios parameter creator
 * @export
 */
export const ProviderStatementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {CancelStatementDto} cancelStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerCancelStatement: async (id: string, cancelStatementDto: CancelStatementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('statementControllerCancelStatement', 'id', id)
            // verify required parameter 'cancelStatementDto' is not null or undefined
            assertParamExists('statementControllerCancelStatement', 'cancelStatementDto', cancelStatementDto)
            const localVarPath = `/provider_statements/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelStatementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportStatementsDto} exportStatementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerExportStatements: async (exportStatementsDto: ExportStatementsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportStatementsDto' is not null or undefined
            assertParamExists('statementControllerExportStatements', 'exportStatementsDto', exportStatementsDto)
            const localVarPath = `/provider_statements/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportStatementsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindPendingDetail: async (ids: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('statementControllerFindPendingDetail', 'ids', ids)
            const localVarPath = `/provider_statements/pending_detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerIds] 
         * @param {Array<string>} [states] 
         * @param {Array<string>} [timeRange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindStatements: async (skip?: number, take?: number, providerIds?: Array<string>, states?: Array<string>, timeRange?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider_statements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (providerIds) {
                localVarQueryParameter['providerIds'] = providerIds;
            }

            if (states) {
                localVarQueryParameter['states'] = states;
            }

            if (timeRange) {
                localVarQueryParameter['timeRange'] = timeRange;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerGetIgnoredToppings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider_statements/ignored_toppings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PayStatementsDto} payStatementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerPayStatements: async (payStatementsDto: PayStatementsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payStatementsDto' is not null or undefined
            assertParamExists('statementControllerPayStatements', 'payStatementsDto', payStatementsDto)
            const localVarPath = `/provider_statements/pay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payStatementsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ResolveStatementDto} resolveStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerResolveStatement: async (id: string, resolveStatementDto: ResolveStatementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('statementControllerResolveStatement', 'id', id)
            // verify required parameter 'resolveStatementDto' is not null or undefined
            assertParamExists('statementControllerResolveStatement', 'resolveStatementDto', resolveStatementDto)
            const localVarPath = `/provider_statements/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveStatementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendConfirmNotificationDto} sendConfirmNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerSendConfirmNotification: async (sendConfirmNotificationDto: SendConfirmNotificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendConfirmNotificationDto' is not null or undefined
            assertParamExists('statementControllerSendConfirmNotification', 'sendConfirmNotificationDto', sendConfirmNotificationDto)
            const localVarPath = `/provider_statements/send_confirm_notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendConfirmNotificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateIgnoredToppingsDto} updateIgnoredToppingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerUpdateIgnoredToppings: async (updateIgnoredToppingsDto: UpdateIgnoredToppingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateIgnoredToppingsDto' is not null or undefined
            assertParamExists('statementControllerUpdateIgnoredToppings', 'updateIgnoredToppingsDto', updateIgnoredToppingsDto)
            const localVarPath = `/provider_statements/ignored_toppings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIgnoredToppingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStatementDto} updateStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerUpdateStatement: async (id: string, updateStatementDto: UpdateStatementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('statementControllerUpdateStatement', 'id', id)
            // verify required parameter 'updateStatementDto' is not null or undefined
            assertParamExists('statementControllerUpdateStatement', 'updateStatementDto', updateStatementDto)
            const localVarPath = `/provider_statements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStatementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderStatementsApi - functional programming interface
 * @export
 */
export const ProviderStatementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderStatementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {CancelStatementDto} cancelStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerCancelStatement(id: string, cancelStatementDto: CancelStatementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerCancelStatement(id, cancelStatementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerCancelStatement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportStatementsDto} exportStatementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerExportStatements(exportStatementsDto: ExportStatementsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerExportStatements(exportStatementsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerExportStatements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerFindPendingDetail(ids: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerFindPendingDetail(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerFindPendingDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerIds] 
         * @param {Array<string>} [states] 
         * @param {Array<string>} [timeRange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerFindStatements(skip?: number, take?: number, providerIds?: Array<string>, states?: Array<string>, timeRange?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerFindStatements(skip, take, providerIds, states, timeRange, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerFindStatements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerGetIgnoredToppings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerGetIgnoredToppings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerGetIgnoredToppings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PayStatementsDto} payStatementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerPayStatements(payStatementsDto: PayStatementsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerPayStatements(payStatementsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerPayStatements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ResolveStatementDto} resolveStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerResolveStatement(id: string, resolveStatementDto: ResolveStatementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerResolveStatement(id, resolveStatementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerResolveStatement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendConfirmNotificationDto} sendConfirmNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerSendConfirmNotification(sendConfirmNotificationDto: SendConfirmNotificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerSendConfirmNotification(sendConfirmNotificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerSendConfirmNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateIgnoredToppingsDto} updateIgnoredToppingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerUpdateIgnoredToppings(updateIgnoredToppingsDto: UpdateIgnoredToppingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerUpdateIgnoredToppings(updateIgnoredToppingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerUpdateIgnoredToppings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStatementDto} updateStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementControllerUpdateStatement(id: string, updateStatementDto: UpdateStatementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementControllerUpdateStatement(id, updateStatementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderStatementsApi.statementControllerUpdateStatement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderStatementsApi - factory interface
 * @export
 */
export const ProviderStatementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderStatementsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {CancelStatementDto} cancelStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerCancelStatement(id: string, cancelStatementDto: CancelStatementDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerCancelStatement(id, cancelStatementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportStatementsDto} exportStatementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerExportStatements(exportStatementsDto: ExportStatementsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerExportStatements(exportStatementsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindPendingDetail(ids: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerFindPendingDetail(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<string>} [providerIds] 
         * @param {Array<string>} [states] 
         * @param {Array<string>} [timeRange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerFindStatements(skip?: number, take?: number, providerIds?: Array<string>, states?: Array<string>, timeRange?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerFindStatements(skip, take, providerIds, states, timeRange, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerGetIgnoredToppings(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerGetIgnoredToppings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayStatementsDto} payStatementsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerPayStatements(payStatementsDto: PayStatementsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerPayStatements(payStatementsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ResolveStatementDto} resolveStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerResolveStatement(id: string, resolveStatementDto: ResolveStatementDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerResolveStatement(id, resolveStatementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendConfirmNotificationDto} sendConfirmNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerSendConfirmNotification(sendConfirmNotificationDto: SendConfirmNotificationDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerSendConfirmNotification(sendConfirmNotificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateIgnoredToppingsDto} updateIgnoredToppingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerUpdateIgnoredToppings(updateIgnoredToppingsDto: UpdateIgnoredToppingsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerUpdateIgnoredToppings(updateIgnoredToppingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStatementDto} updateStatementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementControllerUpdateStatement(id: string, updateStatementDto: UpdateStatementDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementControllerUpdateStatement(id, updateStatementDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProviderStatementsApi - object-oriented interface
 * @export
 * @class ProviderStatementsApi
 * @extends {BaseAPI}
 */
export class ProviderStatementsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {CancelStatementDto} cancelStatementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerCancelStatement(id: string, cancelStatementDto: CancelStatementDto, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerCancelStatement(id, cancelStatementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportStatementsDto} exportStatementsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerExportStatements(exportStatementsDto: ExportStatementsDto, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerExportStatements(exportStatementsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerFindPendingDetail(ids: Array<string>, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerFindPendingDetail(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {Array<string>} [providerIds] 
     * @param {Array<string>} [states] 
     * @param {Array<string>} [timeRange] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerFindStatements(skip?: number, take?: number, providerIds?: Array<string>, states?: Array<string>, timeRange?: Array<string>, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerFindStatements(skip, take, providerIds, states, timeRange, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerGetIgnoredToppings(options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerGetIgnoredToppings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayStatementsDto} payStatementsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerPayStatements(payStatementsDto: PayStatementsDto, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerPayStatements(payStatementsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ResolveStatementDto} resolveStatementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerResolveStatement(id: string, resolveStatementDto: ResolveStatementDto, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerResolveStatement(id, resolveStatementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendConfirmNotificationDto} sendConfirmNotificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerSendConfirmNotification(sendConfirmNotificationDto: SendConfirmNotificationDto, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerSendConfirmNotification(sendConfirmNotificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateIgnoredToppingsDto} updateIgnoredToppingsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerUpdateIgnoredToppings(updateIgnoredToppingsDto: UpdateIgnoredToppingsDto, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerUpdateIgnoredToppings(updateIgnoredToppingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateStatementDto} updateStatementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderStatementsApi
     */
    public statementControllerUpdateStatement(id: string, updateStatementDto: UpdateStatementDto, options?: RawAxiosRequestConfig) {
        return ProviderStatementsApiFp(this.configuration).statementControllerUpdateStatement(id, updateStatementDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProviderTypesApi - axios parameter creator
 * @export
 */
export const ProviderTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateProviderTypeDto} createProviderTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTypeControllerCreate: async (createProviderTypeDto: CreateProviderTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProviderTypeDto' is not null or undefined
            assertParamExists('providerTypeControllerCreate', 'createProviderTypeDto', createProviderTypeDto)
            const localVarPath = `/provider-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProviderTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTypeControllerDeleteType: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerTypeControllerDeleteType', 'id', id)
            const localVarPath = `/provider-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTypeControllerFindTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderTypeDto} updateProviderTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTypeControllerUpdateType: async (id: string, updateProviderTypeDto: UpdateProviderTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerTypeControllerUpdateType', 'id', id)
            // verify required parameter 'updateProviderTypeDto' is not null or undefined
            assertParamExists('providerTypeControllerUpdateType', 'updateProviderTypeDto', updateProviderTypeDto)
            const localVarPath = `/provider-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderTypesApi - functional programming interface
 * @export
 */
export const ProviderTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateProviderTypeDto} createProviderTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerTypeControllerCreate(createProviderTypeDto: CreateProviderTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerTypeControllerCreate(createProviderTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderTypesApi.providerTypeControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerTypeControllerDeleteType(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerTypeControllerDeleteType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderTypesApi.providerTypeControllerDeleteType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerTypeControllerFindTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindProviderTypesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerTypeControllerFindTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderTypesApi.providerTypeControllerFindTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderTypeDto} updateProviderTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerTypeControllerUpdateType(id: string, updateProviderTypeDto: UpdateProviderTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerTypeControllerUpdateType(id, updateProviderTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderTypesApi.providerTypeControllerUpdateType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderTypesApi - factory interface
 * @export
 */
export const ProviderTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateProviderTypeDto} createProviderTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTypeControllerCreate(createProviderTypeDto: CreateProviderTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerTypeControllerCreate(createProviderTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTypeControllerDeleteType(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerTypeControllerDeleteType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTypeControllerFindTypes(options?: RawAxiosRequestConfig): AxiosPromise<FindProviderTypesResult> {
            return localVarFp.providerTypeControllerFindTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderTypeDto} updateProviderTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerTypeControllerUpdateType(id: string, updateProviderTypeDto: UpdateProviderTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerTypeControllerUpdateType(id, updateProviderTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProviderTypesApi - object-oriented interface
 * @export
 * @class ProviderTypesApi
 * @extends {BaseAPI}
 */
export class ProviderTypesApi extends BaseAPI {
    /**
     * 
     * @param {CreateProviderTypeDto} createProviderTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderTypesApi
     */
    public providerTypeControllerCreate(createProviderTypeDto: CreateProviderTypeDto, options?: RawAxiosRequestConfig) {
        return ProviderTypesApiFp(this.configuration).providerTypeControllerCreate(createProviderTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderTypesApi
     */
    public providerTypeControllerDeleteType(id: string, options?: RawAxiosRequestConfig) {
        return ProviderTypesApiFp(this.configuration).providerTypeControllerDeleteType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderTypesApi
     */
    public providerTypeControllerFindTypes(options?: RawAxiosRequestConfig) {
        return ProviderTypesApiFp(this.configuration).providerTypeControllerFindTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateProviderTypeDto} updateProviderTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderTypesApi
     */
    public providerTypeControllerUpdateType(id: string, updateProviderTypeDto: UpdateProviderTypeDto, options?: RawAxiosRequestConfig) {
        return ProviderTypesApiFp(this.configuration).providerTypeControllerUpdateType(id, updateProviderTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProvidersApi - axios parameter creator
 * @export
 */
export const ProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateProviderDto} createProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerCreateProvider: async (createProviderDto: CreateProviderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProviderDto' is not null or undefined
            assertParamExists('providerControllerCreateProvider', 'createProviderDto', createProviderDto)
            const localVarPath = `/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerDeleteProvider: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerControllerDeleteProvider', 'id', id)
            const localVarPath = `/providers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublishProvidersMessage} publishProvidersMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerPublishMessage: async (publishProvidersMessage: PublishProvidersMessage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishProvidersMessage' is not null or undefined
            assertParamExists('providerControllerPublishMessage', 'publishProvidersMessage', publishProvidersMessage)
            const localVarPath = `/providers/publish-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishProvidersMessage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerReadProvider: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerControllerReadProvider', 'id', id)
            const localVarPath = `/providers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {any} [types] 
         * @param {Array<ProviderControllerReadProvidersStatusEnum>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerReadProviders: async (keyword?: string, types?: any, status?: Array<ProviderControllerReadProvidersStatusEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (types !== undefined) {
                for (const [key, value] of Object.entries(types)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerReadProvidersList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/providers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderDto} updateProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerUpdateProvider: async (id: string, updateProviderDto: UpdateProviderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('providerControllerUpdateProvider', 'id', id)
            // verify required parameter 'updateProviderDto' is not null or undefined
            assertParamExists('providerControllerUpdateProvider', 'updateProviderDto', updateProviderDto)
            const localVarPath = `/providers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProvidersApi - functional programming interface
 * @export
 */
export const ProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateProviderDto} createProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerControllerCreateProvider(createProviderDto: CreateProviderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerControllerCreateProvider(createProviderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.providerControllerCreateProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerControllerDeleteProvider(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerControllerDeleteProvider(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.providerControllerDeleteProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PublishProvidersMessage} publishProvidersMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerControllerPublishMessage(publishProvidersMessage: PublishProvidersMessage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerControllerPublishMessage(publishProvidersMessage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.providerControllerPublishMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerControllerReadProvider(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindProviderResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerControllerReadProvider(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.providerControllerReadProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {any} [types] 
         * @param {Array<ProviderControllerReadProvidersStatusEnum>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerControllerReadProviders(keyword?: string, types?: any, status?: Array<ProviderControllerReadProvidersStatusEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerControllerReadProviders(keyword, types, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.providerControllerReadProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerControllerReadProvidersList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerControllerReadProvidersList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.providerControllerReadProvidersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderDto} updateProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerControllerUpdateProvider(id: string, updateProviderDto: UpdateProviderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerControllerUpdateProvider(id, updateProviderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.providerControllerUpdateProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProvidersApi - factory interface
 * @export
 */
export const ProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProvidersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateProviderDto} createProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerCreateProvider(createProviderDto: CreateProviderDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerControllerCreateProvider(createProviderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerDeleteProvider(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerControllerDeleteProvider(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublishProvidersMessage} publishProvidersMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerPublishMessage(publishProvidersMessage: PublishProvidersMessage, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerControllerPublishMessage(publishProvidersMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerReadProvider(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FindProviderResult> {
            return localVarFp.providerControllerReadProvider(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {any} [types] 
         * @param {Array<ProviderControllerReadProvidersStatusEnum>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerReadProviders(keyword?: string, types?: any, status?: Array<ProviderControllerReadProvidersStatusEnum>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerControllerReadProviders(keyword, types, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerReadProvidersList(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerControllerReadProvidersList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateProviderDto} updateProviderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerControllerUpdateProvider(id: string, updateProviderDto: UpdateProviderDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.providerControllerUpdateProvider(id, updateProviderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProvidersApi - object-oriented interface
 * @export
 * @class ProvidersApi
 * @extends {BaseAPI}
 */
export class ProvidersApi extends BaseAPI {
    /**
     * 
     * @param {CreateProviderDto} createProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providerControllerCreateProvider(createProviderDto: CreateProviderDto, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).providerControllerCreateProvider(createProviderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providerControllerDeleteProvider(id: string, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).providerControllerDeleteProvider(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublishProvidersMessage} publishProvidersMessage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providerControllerPublishMessage(publishProvidersMessage: PublishProvidersMessage, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).providerControllerPublishMessage(publishProvidersMessage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providerControllerReadProvider(id: string, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).providerControllerReadProvider(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [keyword] 
     * @param {any} [types] 
     * @param {Array<ProviderControllerReadProvidersStatusEnum>} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providerControllerReadProviders(keyword?: string, types?: any, status?: Array<ProviderControllerReadProvidersStatusEnum>, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).providerControllerReadProviders(keyword, types, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providerControllerReadProvidersList(options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).providerControllerReadProvidersList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateProviderDto} updateProviderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providerControllerUpdateProvider(id: string, updateProviderDto: UpdateProviderDto, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).providerControllerUpdateProvider(id, updateProviderDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ProviderControllerReadProvidersStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type ProviderControllerReadProvidersStatusEnum = typeof ProviderControllerReadProvidersStatusEnum[keyof typeof ProviderControllerReadProvidersStatusEnum];


/**
 * ReceivablePlanApi - axios parameter creator
 * @export
 */
export const ReceivablePlanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateReceivablePlanDto} createReceivablePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanControllerCreateReceivablePlan: async (createReceivablePlanDto: CreateReceivablePlanDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReceivablePlanDto' is not null or undefined
            assertParamExists('receivablePlanControllerCreateReceivablePlan', 'createReceivablePlanDto', createReceivablePlanDto)
            const localVarPath = `/receivable-plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReceivablePlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanControllerDeleteReceivablePlan: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receivablePlanControllerDeleteReceivablePlan', 'id', id)
            const localVarPath = `/receivable-plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [providerId] The provider id
         * @param {number} [skip] skip
         * @param {number} [take] take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanControllerFindReceivablePlans: async (providerId?: string, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/receivable-plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['providerId'] = providerId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReceivablePlanDto} updateReceivablePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanControllerUpdateReceivablePlan: async (id: string, updateReceivablePlanDto: UpdateReceivablePlanDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receivablePlanControllerUpdateReceivablePlan', 'id', id)
            // verify required parameter 'updateReceivablePlanDto' is not null or undefined
            assertParamExists('receivablePlanControllerUpdateReceivablePlan', 'updateReceivablePlanDto', updateReceivablePlanDto)
            const localVarPath = `/receivable-plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReceivablePlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceivablePlanApi - functional programming interface
 * @export
 */
export const ReceivablePlanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceivablePlanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateReceivablePlanDto} createReceivablePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivablePlanControllerCreateReceivablePlan(createReceivablePlanDto: CreateReceivablePlanDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivablePlanControllerCreateReceivablePlan(createReceivablePlanDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablePlanApi.receivablePlanControllerCreateReceivablePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivablePlanControllerDeleteReceivablePlan(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivablePlanControllerDeleteReceivablePlan(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablePlanApi.receivablePlanControllerDeleteReceivablePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [providerId] The provider id
         * @param {number} [skip] skip
         * @param {number} [take] take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivablePlanControllerFindReceivablePlans(providerId?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindReceivablePlansResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivablePlanControllerFindReceivablePlans(providerId, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablePlanApi.receivablePlanControllerFindReceivablePlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReceivablePlanDto} updateReceivablePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivablePlanControllerUpdateReceivablePlan(id: string, updateReceivablePlanDto: UpdateReceivablePlanDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivablePlanControllerUpdateReceivablePlan(id, updateReceivablePlanDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablePlanApi.receivablePlanControllerUpdateReceivablePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReceivablePlanApi - factory interface
 * @export
 */
export const ReceivablePlanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceivablePlanApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateReceivablePlanDto} createReceivablePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanControllerCreateReceivablePlan(createReceivablePlanDto: CreateReceivablePlanDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receivablePlanControllerCreateReceivablePlan(createReceivablePlanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanControllerDeleteReceivablePlan(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receivablePlanControllerDeleteReceivablePlan(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [providerId] The provider id
         * @param {number} [skip] skip
         * @param {number} [take] take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanControllerFindReceivablePlans(providerId?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<FindReceivablePlansResult> {
            return localVarFp.receivablePlanControllerFindReceivablePlans(providerId, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReceivablePlanDto} updateReceivablePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanControllerUpdateReceivablePlan(id: string, updateReceivablePlanDto: UpdateReceivablePlanDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receivablePlanControllerUpdateReceivablePlan(id, updateReceivablePlanDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReceivablePlanApi - object-oriented interface
 * @export
 * @class ReceivablePlanApi
 * @extends {BaseAPI}
 */
export class ReceivablePlanApi extends BaseAPI {
    /**
     * 
     * @param {CreateReceivablePlanDto} createReceivablePlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablePlanApi
     */
    public receivablePlanControllerCreateReceivablePlan(createReceivablePlanDto: CreateReceivablePlanDto, options?: RawAxiosRequestConfig) {
        return ReceivablePlanApiFp(this.configuration).receivablePlanControllerCreateReceivablePlan(createReceivablePlanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablePlanApi
     */
    public receivablePlanControllerDeleteReceivablePlan(id: string, options?: RawAxiosRequestConfig) {
        return ReceivablePlanApiFp(this.configuration).receivablePlanControllerDeleteReceivablePlan(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [providerId] The provider id
     * @param {number} [skip] skip
     * @param {number} [take] take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablePlanApi
     */
    public receivablePlanControllerFindReceivablePlans(providerId?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return ReceivablePlanApiFp(this.configuration).receivablePlanControllerFindReceivablePlans(providerId, skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateReceivablePlanDto} updateReceivablePlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablePlanApi
     */
    public receivablePlanControllerUpdateReceivablePlan(id: string, updateReceivablePlanDto: UpdateReceivablePlanDto, options?: RawAxiosRequestConfig) {
        return ReceivablePlanApiFp(this.configuration).receivablePlanControllerUpdateReceivablePlan(id, updateReceivablePlanDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReceivablePlansReceivablesApi - axios parameter creator
 * @export
 */
export const ReceivablePlansReceivablesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanReceivableControllerGetReceivables: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receivablePlanReceivableControllerGetReceivables', 'id', id)
            const localVarPath = `/receivable-plans/{id}/receivables`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceivablePlansReceivablesApi - functional programming interface
 * @export
 */
export const ReceivablePlansReceivablesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceivablePlansReceivablesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivablePlanReceivableControllerGetReceivables(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindReceivablesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivablePlanReceivableControllerGetReceivables(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablePlansReceivablesApi.receivablePlanReceivableControllerGetReceivables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReceivablePlansReceivablesApi - factory interface
 * @export
 */
export const ReceivablePlansReceivablesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceivablePlansReceivablesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivablePlanReceivableControllerGetReceivables(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FindReceivablesResult> {
            return localVarFp.receivablePlanReceivableControllerGetReceivables(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReceivablePlansReceivablesApi - object-oriented interface
 * @export
 * @class ReceivablePlansReceivablesApi
 * @extends {BaseAPI}
 */
export class ReceivablePlansReceivablesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablePlansReceivablesApi
     */
    public receivablePlanReceivableControllerGetReceivables(id: string, options?: RawAxiosRequestConfig) {
        return ReceivablePlansReceivablesApiFp(this.configuration).receivablePlanReceivableControllerGetReceivables(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReceivablesApi - axios parameter creator
 * @export
 */
export const ReceivablesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateReceivableDto} createReceivableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerCreateReceivable: async (createReceivableDto: CreateReceivableDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReceivableDto' is not null or undefined
            assertParamExists('receivableControllerCreateReceivable', 'createReceivableDto', createReceivableDto)
            const localVarPath = `/receivables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReceivableDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerDeleteReceivable: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receivableControllerDeleteReceivable', 'id', id)
            const localVarPath = `/receivables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {Array<string>} [providerIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerFindReceivables: async (take?: number, skip?: number, providerIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/receivables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (providerIds) {
                localVarQueryParameter['providerIds'] = providerIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerGetReceivableNames: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/receivables/names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReceivableDto} updateReceivableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerUpdateReceivable: async (id: string, updateReceivableDto: UpdateReceivableDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('receivableControllerUpdateReceivable', 'id', id)
            // verify required parameter 'updateReceivableDto' is not null or undefined
            assertParamExists('receivableControllerUpdateReceivable', 'updateReceivableDto', updateReceivableDto)
            const localVarPath = `/receivables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReceivableDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceivablesApi - functional programming interface
 * @export
 */
export const ReceivablesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceivablesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateReceivableDto} createReceivableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivableControllerCreateReceivable(createReceivableDto: CreateReceivableDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivableControllerCreateReceivable(createReceivableDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablesApi.receivableControllerCreateReceivable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivableControllerDeleteReceivable(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivableControllerDeleteReceivable(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablesApi.receivableControllerDeleteReceivable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {Array<string>} [providerIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivableControllerFindReceivables(take?: number, skip?: number, providerIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindReceivablesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivableControllerFindReceivables(take, skip, providerIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablesApi.receivableControllerFindReceivables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivableControllerGetReceivableNames(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReceivableNamesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivableControllerGetReceivableNames(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablesApi.receivableControllerGetReceivableNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReceivableDto} updateReceivableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receivableControllerUpdateReceivable(id: string, updateReceivableDto: UpdateReceivableDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivableControllerUpdateReceivable(id, updateReceivableDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceivablesApi.receivableControllerUpdateReceivable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReceivablesApi - factory interface
 * @export
 */
export const ReceivablesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceivablesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateReceivableDto} createReceivableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerCreateReceivable(createReceivableDto: CreateReceivableDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receivableControllerCreateReceivable(createReceivableDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerDeleteReceivable(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receivableControllerDeleteReceivable(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {Array<string>} [providerIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerFindReceivables(take?: number, skip?: number, providerIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<FindReceivablesResult> {
            return localVarFp.receivableControllerFindReceivables(take, skip, providerIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerGetReceivableNames(options?: RawAxiosRequestConfig): AxiosPromise<GetReceivableNamesResult> {
            return localVarFp.receivableControllerGetReceivableNames(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReceivableDto} updateReceivableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receivableControllerUpdateReceivable(id: string, updateReceivableDto: UpdateReceivableDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receivableControllerUpdateReceivable(id, updateReceivableDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReceivablesApi - object-oriented interface
 * @export
 * @class ReceivablesApi
 * @extends {BaseAPI}
 */
export class ReceivablesApi extends BaseAPI {
    /**
     * 
     * @param {CreateReceivableDto} createReceivableDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablesApi
     */
    public receivableControllerCreateReceivable(createReceivableDto: CreateReceivableDto, options?: RawAxiosRequestConfig) {
        return ReceivablesApiFp(this.configuration).receivableControllerCreateReceivable(createReceivableDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablesApi
     */
    public receivableControllerDeleteReceivable(id: string, options?: RawAxiosRequestConfig) {
        return ReceivablesApiFp(this.configuration).receivableControllerDeleteReceivable(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {Array<string>} [providerIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablesApi
     */
    public receivableControllerFindReceivables(take?: number, skip?: number, providerIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return ReceivablesApiFp(this.configuration).receivableControllerFindReceivables(take, skip, providerIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablesApi
     */
    public receivableControllerGetReceivableNames(options?: RawAxiosRequestConfig) {
        return ReceivablesApiFp(this.configuration).receivableControllerGetReceivableNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateReceivableDto} updateReceivableDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceivablesApi
     */
    public receivableControllerUpdateReceivable(id: string, updateReceivableDto: UpdateReceivableDto, options?: RawAxiosRequestConfig) {
        return ReceivablesApiFp(this.configuration).receivableControllerUpdateReceivable(id, updateReceivableDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecommendUserApi - axios parameter creator
 * @export
 */
export const RecommendUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} startTime 
         * @param {number} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendUserControllerCount: async (startTime: number, endTime: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('recommendUserControllerCount', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('recommendUserControllerCount', 'endTime', endTime)
            const localVarPath = `/recommend-user/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} top 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendUserControllerRanking: async (top: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'top' is not null or undefined
            assertParamExists('recommendUserControllerRanking', 'top', top)
            const localVarPath = `/recommend-user/ranking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startTime 
         * @param {number} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendUserControllerSummary: async (startTime: number, endTime: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('recommendUserControllerSummary', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('recommendUserControllerSummary', 'endTime', endTime)
            const localVarPath = `/recommend-user/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecommendUserApi - functional programming interface
 * @export
 */
export const RecommendUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecommendUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} startTime 
         * @param {number} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendUserControllerCount(startTime: number, endTime: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserCountResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendUserControllerCount(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendUserApi.recommendUserControllerCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} top 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendUserControllerRanking(top: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRankingResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendUserControllerRanking(top, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendUserApi.recommendUserControllerRanking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} startTime 
         * @param {number} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendUserControllerSummary(startTime: number, endTime: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSummaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendUserControllerSummary(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendUserApi.recommendUserControllerSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecommendUserApi - factory interface
 * @export
 */
export const RecommendUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecommendUserApiFp(configuration)
    return {
        /**
         * 
         * @param {number} startTime 
         * @param {number} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendUserControllerCount(startTime: number, endTime: number, options?: RawAxiosRequestConfig): AxiosPromise<GetUserCountResponseDto> {
            return localVarFp.recommendUserControllerCount(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} top 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendUserControllerRanking(top: number, options?: RawAxiosRequestConfig): AxiosPromise<GetRankingResponseDto> {
            return localVarFp.recommendUserControllerRanking(top, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startTime 
         * @param {number} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendUserControllerSummary(startTime: number, endTime: number, options?: RawAxiosRequestConfig): AxiosPromise<GetSummaryResponseDto> {
            return localVarFp.recommendUserControllerSummary(startTime, endTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecommendUserApi - object-oriented interface
 * @export
 * @class RecommendUserApi
 * @extends {BaseAPI}
 */
export class RecommendUserApi extends BaseAPI {
    /**
     * 
     * @param {number} startTime 
     * @param {number} endTime 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendUserApi
     */
    public recommendUserControllerCount(startTime: number, endTime: number, options?: RawAxiosRequestConfig) {
        return RecommendUserApiFp(this.configuration).recommendUserControllerCount(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} top 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendUserApi
     */
    public recommendUserControllerRanking(top: number, options?: RawAxiosRequestConfig) {
        return RecommendUserApiFp(this.configuration).recommendUserControllerRanking(top, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startTime 
     * @param {number} endTime 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendUserApi
     */
    public recommendUserControllerSummary(startTime: number, endTime: number, options?: RawAxiosRequestConfig) {
        return RecommendUserApiFp(this.configuration).recommendUserControllerSummary(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerCreateRole: async (createRoleDto: CreateRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoleDto' is not null or undefined
            assertParamExists('roleControllerCreateRole', 'createRoleDto', createRoleDto)
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerDeleteRole: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('roleControllerDeleteRole', 'id', id)
            const localVarPath = `/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerGetRoles: async (skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerListRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roles/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerUpdateRole: async (id: string, createRoleDto: CreateRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('roleControllerUpdateRole', 'id', id)
            // verify required parameter 'createRoleDto' is not null or undefined
            assertParamExists('roleControllerUpdateRole', 'createRoleDto', createRoleDto)
            const localVarPath = `/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerCreateRole(createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerCreateRole(createRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.roleControllerCreateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerDeleteRole(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerDeleteRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.roleControllerDeleteRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerGetRoles(skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerGetRoles(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.roleControllerGetRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerListRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerListRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.roleControllerListRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleControllerUpdateRole(id: string, createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleControllerUpdateRole(id, createRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.roleControllerUpdateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerCreateRole(createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.roleControllerCreateRole(createRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerDeleteRole(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.roleControllerDeleteRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerGetRoles(skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.roleControllerGetRoles(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerListRoles(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.roleControllerListRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateRoleDto} createRoleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleControllerUpdateRole(id: string, createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.roleControllerUpdateRole(id, createRoleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     * 
     * @param {CreateRoleDto} createRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public roleControllerCreateRole(createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).roleControllerCreateRole(createRoleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public roleControllerDeleteRole(id: string, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).roleControllerDeleteRole(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public roleControllerGetRoles(skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).roleControllerGetRoles(skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public roleControllerListRoles(options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).roleControllerListRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateRoleDto} createRoleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public roleControllerUpdateRole(id: string, createRoleDto: CreateRoleDto, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).roleControllerUpdateRole(id, createRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatementSettingsApi - axios parameter creator
 * @export
 */
export const StatementSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementSettingsControllerFindSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/statement-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStatementSettingsDto} updateStatementSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementSettingsControllerUpdateStatementSettings: async (id: string, updateStatementSettingsDto: UpdateStatementSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('statementSettingsControllerUpdateStatementSettings', 'id', id)
            // verify required parameter 'updateStatementSettingsDto' is not null or undefined
            assertParamExists('statementSettingsControllerUpdateStatementSettings', 'updateStatementSettingsDto', updateStatementSettingsDto)
            const localVarPath = `/statement-settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStatementSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatementSettingsApi - functional programming interface
 * @export
 */
export const StatementSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatementSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementSettingsControllerFindSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindSettingsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementSettingsControllerFindSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatementSettingsApi.statementSettingsControllerFindSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStatementSettingsDto} updateStatementSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statementSettingsControllerUpdateStatementSettings(id: string, updateStatementSettingsDto: UpdateStatementSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statementSettingsControllerUpdateStatementSettings(id, updateStatementSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatementSettingsApi.statementSettingsControllerUpdateStatementSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatementSettingsApi - factory interface
 * @export
 */
export const StatementSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatementSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementSettingsControllerFindSettings(options?: RawAxiosRequestConfig): AxiosPromise<FindSettingsResult> {
            return localVarFp.statementSettingsControllerFindSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStatementSettingsDto} updateStatementSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statementSettingsControllerUpdateStatementSettings(id: string, updateStatementSettingsDto: UpdateStatementSettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.statementSettingsControllerUpdateStatementSettings(id, updateStatementSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatementSettingsApi - object-oriented interface
 * @export
 * @class StatementSettingsApi
 * @extends {BaseAPI}
 */
export class StatementSettingsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementSettingsApi
     */
    public statementSettingsControllerFindSettings(options?: RawAxiosRequestConfig) {
        return StatementSettingsApiFp(this.configuration).statementSettingsControllerFindSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateStatementSettingsDto} updateStatementSettingsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementSettingsApi
     */
    public statementSettingsControllerUpdateStatementSettings(id: string, updateStatementSettingsDto: UpdateStatementSettingsDto, options?: RawAxiosRequestConfig) {
        return StatementSettingsApiFp(this.configuration).statementSettingsControllerUpdateStatementSettings(id, updateStatementSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ToolBagOwnerApi - axios parameter creator
 * @export
 */
export const ToolBagOwnerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 建立工具包所有者
         * @param {CreateToolBagOwnerDto} createToolBagOwnerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolBagOwnerControllerCreate: async (createToolBagOwnerDto: CreateToolBagOwnerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createToolBagOwnerDto' is not null or undefined
            assertParamExists('toolBagOwnerControllerCreate', 'createToolBagOwnerDto', createToolBagOwnerDto)
            const localVarPath = `/tool-bag-owners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createToolBagOwnerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查詢工具包所有者列表
         * @param {string} [startTime] 開始時間 (ISO 格式字串)
         * @param {string} [endTime] 結束時間 (ISO 格式字串)
         * @param {string} [employeeId] 員工ID
         * @param {string} [locationId] 位置ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolBagOwnerControllerFindAll: async (startTime?: string, endTime?: string, employeeId?: string, locationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tool-bag-owners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToolBagOwnerApi - functional programming interface
 * @export
 */
export const ToolBagOwnerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ToolBagOwnerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 建立工具包所有者
         * @param {CreateToolBagOwnerDto} createToolBagOwnerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toolBagOwnerControllerCreate(createToolBagOwnerDto: CreateToolBagOwnerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toolBagOwnerControllerCreate(createToolBagOwnerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolBagOwnerApi.toolBagOwnerControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 查詢工具包所有者列表
         * @param {string} [startTime] 開始時間 (ISO 格式字串)
         * @param {string} [endTime] 結束時間 (ISO 格式字串)
         * @param {string} [employeeId] 員工ID
         * @param {string} [locationId] 位置ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toolBagOwnerControllerFindAll(startTime?: string, endTime?: string, employeeId?: string, locationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindToolBagOwnersResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toolBagOwnerControllerFindAll(startTime, endTime, employeeId, locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolBagOwnerApi.toolBagOwnerControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ToolBagOwnerApi - factory interface
 * @export
 */
export const ToolBagOwnerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ToolBagOwnerApiFp(configuration)
    return {
        /**
         * 
         * @summary 建立工具包所有者
         * @param {CreateToolBagOwnerDto} createToolBagOwnerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolBagOwnerControllerCreate(createToolBagOwnerDto: CreateToolBagOwnerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toolBagOwnerControllerCreate(createToolBagOwnerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查詢工具包所有者列表
         * @param {string} [startTime] 開始時間 (ISO 格式字串)
         * @param {string} [endTime] 結束時間 (ISO 格式字串)
         * @param {string} [employeeId] 員工ID
         * @param {string} [locationId] 位置ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolBagOwnerControllerFindAll(startTime?: string, endTime?: string, employeeId?: string, locationId?: string, options?: RawAxiosRequestConfig): AxiosPromise<FindToolBagOwnersResult> {
            return localVarFp.toolBagOwnerControllerFindAll(startTime, endTime, employeeId, locationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ToolBagOwnerApi - object-oriented interface
 * @export
 * @class ToolBagOwnerApi
 * @extends {BaseAPI}
 */
export class ToolBagOwnerApi extends BaseAPI {
    /**
     * 
     * @summary 建立工具包所有者
     * @param {CreateToolBagOwnerDto} createToolBagOwnerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolBagOwnerApi
     */
    public toolBagOwnerControllerCreate(createToolBagOwnerDto: CreateToolBagOwnerDto, options?: RawAxiosRequestConfig) {
        return ToolBagOwnerApiFp(this.configuration).toolBagOwnerControllerCreate(createToolBagOwnerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查詢工具包所有者列表
     * @param {string} [startTime] 開始時間 (ISO 格式字串)
     * @param {string} [endTime] 結束時間 (ISO 格式字串)
     * @param {string} [employeeId] 員工ID
     * @param {string} [locationId] 位置ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolBagOwnerApi
     */
    public toolBagOwnerControllerFindAll(startTime?: string, endTime?: string, employeeId?: string, locationId?: string, options?: RawAxiosRequestConfig) {
        return ToolBagOwnerApiFp(this.configuration).toolBagOwnerControllerFindAll(startTime, endTime, employeeId, locationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerApproveUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerApproveUser', 'id', id)
            const localVarPath = `/users/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<UserControllerFindUsersStateEnum>} [state] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerFindUsers: async (skip?: number, take?: number, state?: Array<UserControllerFindUsersStateEnum>, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (state) {
                localVarQueryParameter['state'] = state;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerListUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSuspendUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerSuspendUser', 'id', id)
            const localVarPath = `/users/{id}/suspend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUnsuspendUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerUnsuspendUser', 'id', id)
            const localVarPath = `/users/{id}/unsuspend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateMyProfileDto} updateMyProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateProfile: async (updateMyProfileDto: UpdateMyProfileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateMyProfileDto' is not null or undefined
            assertParamExists('userControllerUpdateProfile', 'updateMyProfileDto', updateMyProfileDto)
            const localVarPath = `/users/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMyProfileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateUser: async (id: string, updateUserDto: UpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerUpdateUser', 'id', id)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('userControllerUpdateUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerApproveUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerApproveUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerApproveUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<UserControllerFindUsersStateEnum>} [state] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerFindUsers(skip?: number, take?: number, state?: Array<UserControllerFindUsersStateEnum>, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindUsersResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerFindUsers(skip, take, state, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerFindUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyProfileResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerGetMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerListUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerListUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerListUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSuspendUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSuspendUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerSuspendUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUnsuspendUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUnsuspendUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerUnsuspendUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateMyProfileDto} updateMyProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdateProfile(updateMyProfileDto: UpdateMyProfileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateProfile(updateMyProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerUpdateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdateUser(id: string, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateUser(id, updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.userControllerUpdateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerApproveUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerApproveUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {Array<UserControllerFindUsersStateEnum>} [state] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerFindUsers(skip?: number, take?: number, state?: Array<UserControllerFindUsersStateEnum>, keyword?: string, options?: RawAxiosRequestConfig): AxiosPromise<FindUsersResult> {
            return localVarFp.userControllerFindUsers(skip, take, state, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe(options?: RawAxiosRequestConfig): AxiosPromise<GetMyProfileResult> {
            return localVarFp.userControllerGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerListUsers(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerListUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSuspendUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerSuspendUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUnsuspendUser(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerUnsuspendUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateMyProfileDto} updateMyProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateProfile(updateMyProfileDto: UpdateMyProfileDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerUpdateProfile(updateMyProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateUser(id: string, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerUpdateUser(id, updateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerApproveUser(id: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerApproveUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {Array<UserControllerFindUsersStateEnum>} [state] 
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerFindUsers(skip?: number, take?: number, state?: Array<UserControllerFindUsersStateEnum>, keyword?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerFindUsers(skip, take, state, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetMe(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerListUsers(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerListUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerSuspendUser(id: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerSuspendUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerUnsuspendUser(id: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerUnsuspendUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateMyProfileDto} updateMyProfileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerUpdateProfile(updateMyProfileDto: UpdateMyProfileDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerUpdateProfile(updateMyProfileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerUpdateUser(id: string, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerUpdateUser(id, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UserControllerFindUsersStateEnum = {
    Activated: 'ACTIVATED',
    Reviewing: 'REVIEWING',
    Suspended: 'SUSPENDED'
} as const;
export type UserControllerFindUsersStateEnum = typeof UserControllerFindUsersStateEnum[keyof typeof UserControllerFindUsersStateEnum];


/**
 * VendingApi - axios parameter creator
 * @export
 */
export const VendingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {CreateVendingMenuDto} createVendingMenuDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerCreateVendingMenu: async (areaId: string, machineId: string, createVendingMenuDto: CreateVendingMenuDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerCreateVendingMenu', 'areaId', areaId)
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('vendingControllerCreateVendingMenu', 'machineId', machineId)
            // verify required parameter 'createVendingMenuDto' is not null or undefined
            assertParamExists('vendingControllerCreateVendingMenu', 'createVendingMenuDto', createVendingMenuDto)
            const localVarPath = `/vending/areas/{areaId}/machines/{machineId}/menus`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)))
                .replace(`{${"machineId"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVendingMenuDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingMachines: async (areaId: string, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerFindVendingMachines', 'areaId', areaId)
            const localVarPath = `/vending/areas/{areaId}/machines`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingMenus: async (areaId: string, machineId: string, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerFindVendingMenus', 'areaId', areaId)
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('vendingControllerFindVendingMenus', 'machineId', machineId)
            const localVarPath = `/vending/areas/{areaId}/machines/{machineId}/menus`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)))
                .replace(`{${"machineId"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingProductStocks: async (areaId: string, machineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerFindVendingProductStocks', 'areaId', areaId)
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('vendingControllerFindVendingProductStocks', 'machineId', machineId)
            const localVarPath = `/vending/areas/{areaId}/machines/{machineId}/product-stocks`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)))
                .replace(`{${"machineId"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} [productName] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {VendingControllerFindVendingProductsOrderByEnum} [orderBy] 
         * @param {VendingControllerFindVendingProductsSortByEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingProducts: async (areaId: string, productName?: string, skip?: number, take?: number, orderBy?: VendingControllerFindVendingProductsOrderByEnum, sortBy?: VendingControllerFindVendingProductsSortByEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerFindVendingProducts', 'areaId', areaId)
            const localVarPath = `/vending/areas/{areaId}/products`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingRestockSettings: async (areaId: string, machineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerFindVendingRestockSettings', 'areaId', areaId)
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('vendingControllerFindVendingRestockSettings', 'machineId', machineId)
            const localVarPath = `/vending/areas/{areaId}/machines/{machineId}/restock-settings`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)))
                .replace(`{${"machineId"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {string} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerGetVendingMenuProducts: async (areaId: string, machineId: string, menuId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerGetVendingMenuProducts', 'areaId', areaId)
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('vendingControllerGetVendingMenuProducts', 'machineId', machineId)
            // verify required parameter 'menuId' is not null or undefined
            assertParamExists('vendingControllerGetVendingMenuProducts', 'menuId', menuId)
            const localVarPath = `/vending/areas/{areaId}/machines/{machineId}/menus/{menuId}/products`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)))
                .replace(`{${"machineId"}}`, encodeURIComponent(String(machineId)))
                .replace(`{${"menuId"}}`, encodeURIComponent(String(menuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerGetVendingProductImage: async (areaId: string, fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerGetVendingProductImage', 'areaId', areaId)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('vendingControllerGetVendingProductImage', 'fileName', fileName)
            const localVarPath = `/vending/areas/{areaId}/images/{fileName}`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerListVendingAreas: async (skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vending/areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerListVendingMachinesInfo: async (areaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerListVendingMachinesInfo', 'areaId', areaId)
            const localVarPath = `/vending/areas/{areaId}/machines/remote-list`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerListVendingProductImages: async (areaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerListVendingProductImages', 'areaId', areaId)
            const localVarPath = `/vending/areas/{areaId}/images`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {Array<string>} [productCodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerListVendingProducts: async (areaId: string, productCodes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerListVendingProducts', 'areaId', areaId)
            const localVarPath = `/vending/areas/{areaId}/products/list`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productCodes) {
                localVarQueryParameter['productCodes'] = productCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {TransferVendingProductsDto} transferVendingProductsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerTransferVendingProducts: async (areaId: string, transferVendingProductsDto: TransferVendingProductsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerTransferVendingProducts', 'areaId', areaId)
            // verify required parameter 'transferVendingProductsDto' is not null or undefined
            assertParamExists('vendingControllerTransferVendingProducts', 'transferVendingProductsDto', transferVendingProductsDto)
            const localVarPath = `/vending/areas/{areaId}/transfer-products`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferVendingProductsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productCode 
         * @param {string} areaId 
         * @param {UpdateVendingProductDto} updateVendingProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpdateVendingProduct: async (productCode: string, areaId: string, updateVendingProductDto: UpdateVendingProductDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCode' is not null or undefined
            assertParamExists('vendingControllerUpdateVendingProduct', 'productCode', productCode)
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerUpdateVendingProduct', 'areaId', areaId)
            // verify required parameter 'updateVendingProductDto' is not null or undefined
            assertParamExists('vendingControllerUpdateVendingProduct', 'updateVendingProductDto', updateVendingProductDto)
            const localVarPath = `/vending/areas/{areaId}/products/{productCode}`
                .replace(`{${"productCode"}}`, encodeURIComponent(String(productCode)))
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVendingProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {Array<number>} types 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUploadVendingProductImages: async (areaId: string, types: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerUploadVendingProductImages', 'areaId', areaId)
            // verify required parameter 'types' is not null or undefined
            assertParamExists('vendingControllerUploadVendingProductImages', 'types', types)
            const localVarPath = `/vending/areas/{areaId}/images`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (types) {
                localVarFormParams.append('types', types.join(COLLECTION_FORMATS.csv));
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertVendingAreasDto} upsertVendingAreasDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpsertVendingArea: async (upsertVendingAreasDto: UpsertVendingAreasDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertVendingAreasDto' is not null or undefined
            assertParamExists('vendingControllerUpsertVendingArea', 'upsertVendingAreasDto', upsertVendingAreasDto)
            const localVarPath = `/vending/areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertVendingAreasDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {UpsertVendingMachinesDto} upsertVendingMachinesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpsertVendingMachines: async (areaId: string, upsertVendingMachinesDto: UpsertVendingMachinesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerUpsertVendingMachines', 'areaId', areaId)
            // verify required parameter 'upsertVendingMachinesDto' is not null or undefined
            assertParamExists('vendingControllerUpsertVendingMachines', 'upsertVendingMachinesDto', upsertVendingMachinesDto)
            const localVarPath = `/vending/areas/{areaId}/machines`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertVendingMachinesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {UpsertVendingProductsDto} upsertVendingProductsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpsertVendingProducts: async (areaId: string, upsertVendingProductsDto: UpsertVendingProductsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerUpsertVendingProducts', 'areaId', areaId)
            // verify required parameter 'upsertVendingProductsDto' is not null or undefined
            assertParamExists('vendingControllerUpsertVendingProducts', 'upsertVendingProductsDto', upsertVendingProductsDto)
            const localVarPath = `/vending/areas/{areaId}/products`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertVendingProductsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {UpsertVendingRestockSettingsDto} upsertVendingRestockSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpsertVendingRestockSettings: async (areaId: string, machineId: string, upsertVendingRestockSettingsDto: UpsertVendingRestockSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('vendingControllerUpsertVendingRestockSettings', 'areaId', areaId)
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('vendingControllerUpsertVendingRestockSettings', 'machineId', machineId)
            // verify required parameter 'upsertVendingRestockSettingsDto' is not null or undefined
            assertParamExists('vendingControllerUpsertVendingRestockSettings', 'upsertVendingRestockSettingsDto', upsertVendingRestockSettingsDto)
            const localVarPath = `/vending/areas/{areaId}/machines/{machineId}/restock-settings`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)))
                .replace(`{${"machineId"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertVendingRestockSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendingApi - functional programming interface
 * @export
 */
export const VendingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {CreateVendingMenuDto} createVendingMenuDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerCreateVendingMenu(areaId: string, machineId: string, createVendingMenuDto: CreateVendingMenuDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerCreateVendingMenu(areaId, machineId, createVendingMenuDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerCreateVendingMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerFindVendingMachines(areaId: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerFindVendingMachines(areaId, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerFindVendingMachines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerFindVendingMenus(areaId: string, machineId: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerFindVendingMenus(areaId, machineId, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerFindVendingMenus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerFindVendingProductStocks(areaId: string, machineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerFindVendingProductStocks(areaId, machineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerFindVendingProductStocks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} [productName] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {VendingControllerFindVendingProductsOrderByEnum} [orderBy] 
         * @param {VendingControllerFindVendingProductsSortByEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerFindVendingProducts(areaId: string, productName?: string, skip?: number, take?: number, orderBy?: VendingControllerFindVendingProductsOrderByEnum, sortBy?: VendingControllerFindVendingProductsSortByEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerFindVendingProducts(areaId, productName, skip, take, orderBy, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerFindVendingProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerFindVendingRestockSettings(areaId: string, machineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerFindVendingRestockSettings(areaId, machineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerFindVendingRestockSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {string} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerGetVendingMenuProducts(areaId: string, machineId: string, menuId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerGetVendingMenuProducts(areaId, machineId, menuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerGetVendingMenuProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerGetVendingProductImage(areaId: string, fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerGetVendingProductImage(areaId, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerGetVendingProductImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerListVendingAreas(skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerListVendingAreas(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerListVendingAreas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerListVendingMachinesInfo(areaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerListVendingMachinesInfo(areaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerListVendingMachinesInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerListVendingProductImages(areaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerListVendingProductImages(areaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerListVendingProductImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {Array<string>} [productCodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerListVendingProducts(areaId: string, productCodes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerListVendingProducts(areaId, productCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerListVendingProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {TransferVendingProductsDto} transferVendingProductsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerTransferVendingProducts(areaId: string, transferVendingProductsDto: TransferVendingProductsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerTransferVendingProducts(areaId, transferVendingProductsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerTransferVendingProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productCode 
         * @param {string} areaId 
         * @param {UpdateVendingProductDto} updateVendingProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerUpdateVendingProduct(productCode: string, areaId: string, updateVendingProductDto: UpdateVendingProductDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerUpdateVendingProduct(productCode, areaId, updateVendingProductDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerUpdateVendingProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {Array<number>} types 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerUploadVendingProductImages(areaId: string, types: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerUploadVendingProductImages(areaId, types, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerUploadVendingProductImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertVendingAreasDto} upsertVendingAreasDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerUpsertVendingArea(upsertVendingAreasDto: UpsertVendingAreasDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerUpsertVendingArea(upsertVendingAreasDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerUpsertVendingArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {UpsertVendingMachinesDto} upsertVendingMachinesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerUpsertVendingMachines(areaId: string, upsertVendingMachinesDto: UpsertVendingMachinesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerUpsertVendingMachines(areaId, upsertVendingMachinesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerUpsertVendingMachines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {UpsertVendingProductsDto} upsertVendingProductsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerUpsertVendingProducts(areaId: string, upsertVendingProductsDto: UpsertVendingProductsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerUpsertVendingProducts(areaId, upsertVendingProductsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerUpsertVendingProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {UpsertVendingRestockSettingsDto} upsertVendingRestockSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vendingControllerUpsertVendingRestockSettings(areaId: string, machineId: string, upsertVendingRestockSettingsDto: UpsertVendingRestockSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vendingControllerUpsertVendingRestockSettings(areaId, machineId, upsertVendingRestockSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendingApi.vendingControllerUpsertVendingRestockSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VendingApi - factory interface
 * @export
 */
export const VendingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendingApiFp(configuration)
    return {
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {CreateVendingMenuDto} createVendingMenuDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerCreateVendingMenu(areaId: string, machineId: string, createVendingMenuDto: CreateVendingMenuDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerCreateVendingMenu(areaId, machineId, createVendingMenuDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingMachines(areaId: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerFindVendingMachines(areaId, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingMenus(areaId: string, machineId: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerFindVendingMenus(areaId, machineId, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingProductStocks(areaId: string, machineId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerFindVendingProductStocks(areaId, machineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} [productName] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {VendingControllerFindVendingProductsOrderByEnum} [orderBy] 
         * @param {VendingControllerFindVendingProductsSortByEnum} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingProducts(areaId: string, productName?: string, skip?: number, take?: number, orderBy?: VendingControllerFindVendingProductsOrderByEnum, sortBy?: VendingControllerFindVendingProductsSortByEnum, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerFindVendingProducts(areaId, productName, skip, take, orderBy, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerFindVendingRestockSettings(areaId: string, machineId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerFindVendingRestockSettings(areaId, machineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {string} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerGetVendingMenuProducts(areaId: string, machineId: string, menuId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerGetVendingMenuProducts(areaId, machineId, menuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerGetVendingProductImage(areaId: string, fileName: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerGetVendingProductImage(areaId, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerListVendingAreas(skip?: number, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerListVendingAreas(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerListVendingMachinesInfo(areaId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerListVendingMachinesInfo(areaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerListVendingProductImages(areaId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerListVendingProductImages(areaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {Array<string>} [productCodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerListVendingProducts(areaId: string, productCodes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.vendingControllerListVendingProducts(areaId, productCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {TransferVendingProductsDto} transferVendingProductsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerTransferVendingProducts(areaId: string, transferVendingProductsDto: TransferVendingProductsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerTransferVendingProducts(areaId, transferVendingProductsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productCode 
         * @param {string} areaId 
         * @param {UpdateVendingProductDto} updateVendingProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpdateVendingProduct(productCode: string, areaId: string, updateVendingProductDto: UpdateVendingProductDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerUpdateVendingProduct(productCode, areaId, updateVendingProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {Array<number>} types 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUploadVendingProductImages(areaId: string, types: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerUploadVendingProductImages(areaId, types, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertVendingAreasDto} upsertVendingAreasDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpsertVendingArea(upsertVendingAreasDto: UpsertVendingAreasDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerUpsertVendingArea(upsertVendingAreasDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {UpsertVendingMachinesDto} upsertVendingMachinesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpsertVendingMachines(areaId: string, upsertVendingMachinesDto: UpsertVendingMachinesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerUpsertVendingMachines(areaId, upsertVendingMachinesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {UpsertVendingProductsDto} upsertVendingProductsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpsertVendingProducts(areaId: string, upsertVendingProductsDto: UpsertVendingProductsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerUpsertVendingProducts(areaId, upsertVendingProductsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} areaId 
         * @param {string} machineId 
         * @param {UpsertVendingRestockSettingsDto} upsertVendingRestockSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendingControllerUpsertVendingRestockSettings(areaId: string, machineId: string, upsertVendingRestockSettingsDto: UpsertVendingRestockSettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vendingControllerUpsertVendingRestockSettings(areaId, machineId, upsertVendingRestockSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VendingApi - object-oriented interface
 * @export
 * @class VendingApi
 * @extends {BaseAPI}
 */
export class VendingApi extends BaseAPI {
    /**
     * 
     * @param {string} areaId 
     * @param {string} machineId 
     * @param {CreateVendingMenuDto} createVendingMenuDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerCreateVendingMenu(areaId: string, machineId: string, createVendingMenuDto: CreateVendingMenuDto, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerCreateVendingMenu(areaId, machineId, createVendingMenuDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerFindVendingMachines(areaId: string, skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerFindVendingMachines(areaId, skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {string} machineId 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerFindVendingMenus(areaId: string, machineId: string, skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerFindVendingMenus(areaId, machineId, skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {string} machineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerFindVendingProductStocks(areaId: string, machineId: string, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerFindVendingProductStocks(areaId, machineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {string} [productName] 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {VendingControllerFindVendingProductsOrderByEnum} [orderBy] 
     * @param {VendingControllerFindVendingProductsSortByEnum} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerFindVendingProducts(areaId: string, productName?: string, skip?: number, take?: number, orderBy?: VendingControllerFindVendingProductsOrderByEnum, sortBy?: VendingControllerFindVendingProductsSortByEnum, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerFindVendingProducts(areaId, productName, skip, take, orderBy, sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {string} machineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerFindVendingRestockSettings(areaId: string, machineId: string, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerFindVendingRestockSettings(areaId, machineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {string} machineId 
     * @param {string} menuId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerGetVendingMenuProducts(areaId: string, machineId: string, menuId: string, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerGetVendingMenuProducts(areaId, machineId, menuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerGetVendingProductImage(areaId: string, fileName: string, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerGetVendingProductImage(areaId, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerListVendingAreas(skip?: number, take?: number, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerListVendingAreas(skip, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerListVendingMachinesInfo(areaId: string, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerListVendingMachinesInfo(areaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerListVendingProductImages(areaId: string, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerListVendingProductImages(areaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {Array<string>} [productCodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerListVendingProducts(areaId: string, productCodes?: Array<string>, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerListVendingProducts(areaId, productCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {TransferVendingProductsDto} transferVendingProductsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerTransferVendingProducts(areaId: string, transferVendingProductsDto: TransferVendingProductsDto, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerTransferVendingProducts(areaId, transferVendingProductsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productCode 
     * @param {string} areaId 
     * @param {UpdateVendingProductDto} updateVendingProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerUpdateVendingProduct(productCode: string, areaId: string, updateVendingProductDto: UpdateVendingProductDto, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerUpdateVendingProduct(productCode, areaId, updateVendingProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {Array<number>} types 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerUploadVendingProductImages(areaId: string, types: Array<number>, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerUploadVendingProductImages(areaId, types, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertVendingAreasDto} upsertVendingAreasDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerUpsertVendingArea(upsertVendingAreasDto: UpsertVendingAreasDto, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerUpsertVendingArea(upsertVendingAreasDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {UpsertVendingMachinesDto} upsertVendingMachinesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerUpsertVendingMachines(areaId: string, upsertVendingMachinesDto: UpsertVendingMachinesDto, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerUpsertVendingMachines(areaId, upsertVendingMachinesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {UpsertVendingProductsDto} upsertVendingProductsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerUpsertVendingProducts(areaId: string, upsertVendingProductsDto: UpsertVendingProductsDto, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerUpsertVendingProducts(areaId, upsertVendingProductsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} areaId 
     * @param {string} machineId 
     * @param {UpsertVendingRestockSettingsDto} upsertVendingRestockSettingsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendingApi
     */
    public vendingControllerUpsertVendingRestockSettings(areaId: string, machineId: string, upsertVendingRestockSettingsDto: UpsertVendingRestockSettingsDto, options?: RawAxiosRequestConfig) {
        return VendingApiFp(this.configuration).vendingControllerUpsertVendingRestockSettings(areaId, machineId, upsertVendingRestockSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const VendingControllerFindVendingProductsOrderByEnum = {
    CreateTime: 'createTime',
    ProductName: 'productName',
    Price: 'price'
} as const;
export type VendingControllerFindVendingProductsOrderByEnum = typeof VendingControllerFindVendingProductsOrderByEnum[keyof typeof VendingControllerFindVendingProductsOrderByEnum];
/**
 * @export
 */
export const VendingControllerFindVendingProductsSortByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type VendingControllerFindVendingProductsSortByEnum = typeof VendingControllerFindVendingProductsSortByEnum[keyof typeof VendingControllerFindVendingProductsSortByEnum];


